// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Prediction Market component styles (ported from SCSS) */

/* from src/games/PredictionMarket/predictionMarket.scss */
/* Custom-property host for the page. The layout/paint rules live on the element
   as Tailwind utilities; only the tokens the rest of this file reads stay here. */
.prediction-market-page {
  --pm-ease: cubic-bezier(0.4, 0, 0.2, 1);
  --pm-ease-spring: cubic-bezier(0.34, 1.2, 0.64, 1);
  /* top row + nav + news ticker */
  --pm-header-offset: 140px;
  --pm-duration-fast: 0.16s;
  --pm-duration: 0.24s;
  --pm-duration-slow: 0.36s;
  --pm-content-pad: 16px;
}

.prediction-market-page--casino {
  /* Full-bleed iframe shell — no marketing-site container */
  max-width: none;
}

@keyframes pm-fade-in-up {
  from {
    opacity: 0;
    transform: translateY(8px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes pm-fade-in {
  from { opacity: 0; }
  to { opacity: 1; }
}

@keyframes pm-scale-in {
  from {
    opacity: 0;
    transform: scale(0.98);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}

@keyframes pm-slide-down {
  from {
    opacity: 0;
    max-height: 0;
    transform: translateY(-4px);
  }
  to {
    opacity: 1;
    max-height: 1200px;
    transform: translateY(0);
  }
}

@keyframes pm-sheet-slide-up {
  from {
    opacity: 0;
    transform: translateY(100%);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@media (max-width: 700px) {
  .prediction-market-page {
    --pm-header-offset: 136px;
    --pm-content-pad: 12px;
  }
}

@media (max-width: 500px) {
  .prediction-market-page {
    --pm-header-offset: 132px;
    --pm-content-pad: 10px;
  }
}

@media (prefers-reduced-motion: reduce) {
  .prediction-market-page,
  .prediction-market-main,
  .market-detail-wrapper,
  .market-detail-header,
  .ua-replies-list,
  .user-activity-panel,
  .order-panel,
  .order-panel-fieldset,
  .order-panel-disabled-note,
  .portfolio-page,
  .market-detail-trade-sheet-backdrop,
  .market-detail-trade-sheet-content {
    animation: none !important;
  }
}

/* from src/games/PredictionMarket/components/Header/header.scss */
.header-section {
  flex-shrink: 0;
  color: rgb(var(--color-ink));
  width: 100%;
  left: 0;
  top: 0;
  position: fixed;
  z-index: 1000;
  box-sizing: border-box;
  padding-top: 0.5rem;
  padding-bottom: 0.35rem;
  padding-left: 12px;
  padding-right: 12px;
  background: rgb(var(--color-surface) / 0.94);
  backdrop-filter: blur(10px) saturate(1.2);
  -webkit-backdrop-filter: blur(10px) saturate(1.2);
  margin: 0;
  transition: box-shadow var(--pm-duration-fast, 0.16s) var(--pm-ease, ease);
  border-bottom: 1px solid rgb(var(--color-line) / 0.9);
  box-shadow: 0 1px 0 rgb(var(--pm-gold) / 0.12);
}
.header-section::after {
  content: none;
}
.header-section .logo-section {
  color: rgb(var(--color-ink));
  font-weight: 700;
  cursor: pointer;
  min-height: 2rem;
  flex-shrink: 0;
}
.header-section .logo-section h4 {
  margin: 0;
  font-size: 0.92rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: rgb(var(--pm-gold));
}
.header-section .logo-section img {
  width: 1.65rem;
  height: 1.65rem;
  object-fit: contain;
  filter: drop-shadow(0 0 6px rgb(var(--pm-gold) / 0.35));
}
.header-section .header-top-row {
  gap: 0.5rem;
  width: 100%;
  max-width: 1400px;
  margin: 0 auto;
  min-height: 2rem;
  flex-wrap: nowrap;
  align-items: center !important;
}
.header-section .actions-section {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 0.4rem;
  min-width: 0;
  flex: 1 1 auto;
  width: auto;
  margin-left: auto;
}
:is(.header-section, .pm-header-actions) .header-icon-btn {
  flex-shrink: 0;
  width: 2rem;
  height: 2rem;
  padding: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 1px solid rgb(var(--color-line-strong));
  border-radius: var(--pm-radius-sm, 6px);
  background: rgb(var(--color-surface-raised));
  color: rgb(var(--color-ink-muted));
  cursor: pointer;
  appearance: none;
  font-size: 0.85rem;
  transition: background 0.15s, color 0.15s, border-color 0.15s;
}
:is(.header-section, .pm-header-actions) .header-icon-btn:hover {
  background: rgb(var(--color-surface-muted));
  color: rgb(var(--color-ink));
  border-color: rgb(var(--pm-gold) / 0.45);
}
.header-section .balance-section {
  border: 1px solid rgb(var(--color-line-strong));
  border-radius: var(--pm-radius-sm, 6px);
  display: flex;
  align-items: stretch;
  gap: 0.5rem;
  overflow: hidden;
  background: linear-gradient(
    180deg,
    rgb(var(--color-surface-raised)) 0%,
    rgb(var(--color-surface-muted) / 0.65) 100%
  );
  box-shadow: inset 0 1px 0 rgb(var(--pm-gold) / 0.08);
}
.header-section .action-icons {
  display: flex;
  flex-direction: column;
  width: 2rem;
  flex-shrink: 0;
  background: rgb(var(--color-surface-muted));
}
.header-section .action-icons button {
  flex: 1 1;
  min-height: 1.85rem;
  width: 2rem;
  border: none;
  outline: none;
  background: transparent;
  color: rgb(var(--color-ink-soft));
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background 0.15s, color 0.15s;
  box-shadow: none;
  appearance: none;
}
.header-section .balance-section {
  padding-right: 0.65rem;
  font-weight: 600;
  color: rgb(var(--color-ink-soft));
  max-width: 100%;
}
.header-section .balance-values {
  display: flex;
  flex-direction: column;
  gap: 0.05rem;
  line-height: 1.15;
  padding: 0.3rem 0;
  min-width: 0;
  font-size: 0.72rem;
  justify-content: center;
}
.header-section .balance-currency {
  color: rgb(var(--color-ink-faint));
  font-size: 0.62rem;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
}
.header-section .balance-main,
.header-section .balance-sub {
  white-space: normal;
  overflow-wrap: anywhere;
  word-break: break-word;
}
.header-section .balance-sub-row {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 0.6rem;
  min-width: 0;
}
.header-section .balance-sub-row .balance-sub {
  flex: 0 1 auto;
}
.header-section .balance-main {
  font-weight: 700;
  font-variant-numeric: tabular-nums;
  color: rgb(var(--pm-gold));
  font-size: 0.82rem;
}
.header-section .balance-sub {
  color: rgb(var(--color-ink-muted));
  font-weight: 600;
}
.header-section .action-icons button + button {
  border-top: 1px solid rgb(var(--color-line-strong));
}
.header-section .action-icons button i {
  font-size: 0.95rem;
  line-height: 1;
}
.header-section .action-icons button:hover {
  background: rgb(var(--color-line));
  color: rgb(var(--pm-gold));
}
.header-section .action-icons button:focus {
  outline: none;
  box-shadow: none;
}
@media (max-width: 900px) {
  .header-section .header-top-row {
    align-items: center !important;
  }
  .header-section .actions-section {
    width: auto;
    flex: 1 1 auto;
    justify-content: flex-end;
  }
  .header-section .balance-section {
    max-width: min(100%, 280px);
  }
}
@media (max-width: 700px) {
  .header-section .header-top-row {
    align-items: center !important;
  }
  .header-section .logo-section {
    width: fit-content;
  }
  .header-section .logo-section h4 {
    display: none;
  }
  .header-section .actions-section {
    gap: 0.35rem;
    width: auto;
    flex: 1 1 auto;
  }
  .header-section .balance-section {
    flex: 0 1 auto;
    min-width: 0;
  }
}
@media (max-width: 500px) {
  .header-section {
    padding-left: 8px;
    padding-right: 8px;
  }
  .header-section .action-icons {
    width: 2rem;
  }
  .header-section .action-icons button {
    width: 2rem;
    min-height: 1.85rem;
  }
  .header-section .balance-section {
    padding-right: 0.5rem;
    gap: 0.4rem;
  }
  .header-section .balance-values {
    font-size: 0.7rem;
    gap: 0.05rem;
    padding: 0.28rem 0;
  }
  .header-section .balance-sub-row {
    gap: 0.4rem;
  }
}
:is(.header-section, .pm-header-actions) .market-orders-indicator {
  position: relative;
  flex-shrink: 0;
}
:is(.header-section, .pm-header-actions) .market-orders-indicator__trigger {
  width: 2rem;
  height: 2rem;
  border: 1px solid transparent;
  border-radius: var(--pm-radius-sm, 6px);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: default;
  box-shadow: none;
  appearance: none;
  padding: 0;
}
:is(.header-section, .pm-header-actions) .market-orders-indicator__trigger--active {
  background: rgb(var(--color-warning-soft));
  border-color: rgb(var(--color-warning));
  color: rgb(var(--color-warning-contrast));
}
:is(.header-section, .pm-header-actions) .market-orders-indicator__trigger--active i {
  animation: market-orders-indicator-spin 1s linear infinite;
}
:is(.header-section, .pm-header-actions) .market-orders-indicator__trigger--idle {
  background: rgb(var(--color-success-soft));
  border-color: rgb(var(--color-success));
  color: rgb(var(--color-success-contrast));
}
:is(.header-section, .pm-header-actions) .market-orders-indicator__trigger i {
  font-size: 1rem;
  line-height: 1;
}
:is(.header-section, .pm-header-actions) .market-orders-indicator__dropdown {
  position: absolute;
  top: calc(100% + 8px);
  right: 0;
  width: min(20rem, calc(100vw - 2rem));
  padding: 0.75rem 0.85rem;
  border-radius: 10px;
  background: rgb(var(--color-surface-raised));
  border: 1px solid rgb(var(--color-line-strong));
  box-shadow: 0 10px 24px rgb(var(--color-shadow) / 0.12);
  color: rgb(var(--color-ink));
  font-size: clamp(0.72rem, 2.5vw, 0.78rem);
  line-height: 1.45;
  text-align: left;
  opacity: 0;
  visibility: hidden;
  margin-top: -4px;
  transition: opacity 0.15s ease, margin-top 0.15s ease, visibility 0.15s ease;
  pointer-events: none;
  z-index: 1100;
}
:is(.header-section, .pm-header-actions) .market-orders-indicator:hover .market-orders-indicator__dropdown,
:is(.header-section, .pm-header-actions) .market-orders-indicator:focus-within .market-orders-indicator__dropdown {
  opacity: 1;
  visibility: visible;
  margin-top: 0;
  pointer-events: auto;
}
:is(.header-section, .pm-header-actions) .market-orders-indicator__dropdown-title {
  margin: 0 0 0.5rem;
  font-size: 0.72rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: rgb(var(--color-warning-contrast));
}
:is(.header-section, .pm-header-actions) .market-orders-indicator__dropdown-details {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  color: rgb(var(--color-ink-soft));
  font-weight: 500;
  overflow-wrap: anywhere;
}
:is(.header-section, .pm-header-actions) .market-orders-indicator__dropdown-empty {
  margin: 0;
  color: rgb(var(--color-ink-muted));
  font-weight: 500;
  overflow-wrap: anywhere;
}
@keyframes market-orders-indicator-spin {
  to {
    transform: rotate(360deg);
  }
}
:is(.header-section, .pm-header-actions) .notification-bell {
  position: relative;
  flex-shrink: 0;
}
:is(.header-section, .pm-header-actions) .notification-bell__trigger {
  position: relative;
  width: 2rem;
  height: 2rem;
  border: 1px solid rgb(var(--color-line-strong));
  border-radius: var(--pm-radius-sm, 6px);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  background: rgb(var(--color-surface-raised));
  color: rgb(var(--color-ink-soft));
  box-shadow: none;
  appearance: none;
  padding: 0;
  transition: background 0.15s, border-color 0.15s, color 0.15s;
}
:is(.header-section, .pm-header-actions) .notification-bell__trigger i {
  font-size: 1.05rem;
  line-height: 1;
}
:is(.header-section, .pm-header-actions) .notification-bell__trigger:hover {
  background: rgb(var(--color-surface-muted));
  border-color: rgb(var(--color-line-strong));
  color: rgb(var(--color-ink));
}
:is(.header-section, .pm-header-actions) .notification-bell__trigger--active {
  background: rgb(var(--color-info-soft));
  border-color: rgb(var(--color-info));
  color: rgb(var(--color-info-contrast));
}
:is(.header-section, .pm-header-actions) .notification-bell__badge {
  position: absolute;
  top: -5px;
  right: -5px;
  min-width: 1.1rem;
  height: 1.1rem;
  padding: 0 0.25rem;
  border-radius: 999px;
  background: rgb(var(--color-danger));
  color: rgb(var(--color-surface-raised));
  font-size: 0.62rem;
  font-weight: 700;
  line-height: 1.1rem;
  text-align: center;
  border: 2px solid rgb(var(--color-surface));
}
:is(.header-section, .pm-header-actions) .notification-bell__dropdown {
  position: absolute;
  top: calc(100% + 8px);
  right: 0;
  width: min(22rem, calc(100vw - 2rem));
  max-height: min(24rem, calc(100vh - 6rem));
  display: flex;
  flex-direction: column;
  border-radius: 12px;
  background: rgb(var(--color-surface-raised));
  border: 1px solid rgb(var(--color-line-strong));
  box-shadow: 0 12px 28px rgb(var(--color-shadow) / 0.14);
  z-index: 1200;
  overflow: hidden;
}
:is(.header-section, .pm-header-actions) .notification-bell__dropdown-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem;
  padding: 0.85rem 1rem;
  border-bottom: 1px solid rgb(var(--color-line));
  background: rgb(var(--color-surface-overlay));
}
:is(.header-section, .pm-header-actions) .notification-bell__dropdown-header h3 {
  margin: 0;
  font-size: 0.9rem;
  font-weight: 700;
  color: rgb(var(--color-ink));
}
:is(.header-section, .pm-header-actions) .notification-bell__count {
  font-size: 0.72rem;
  font-weight: 600;
  color: rgb(var(--color-ink-faint));
  white-space: nowrap;
}
:is(.header-section, .pm-header-actions) .notification-bell__list {
  overflow-y: auto;
  max-height: min(20rem, calc(100vh - 9rem));
}
:is(.header-section, .pm-header-actions) .notification-bell__empty {
  margin: 0;
  padding: 1.25rem 1rem;
  color: rgb(var(--color-ink-faint));
  font-size: 0.82rem;
  line-height: 1.45;
  text-align: center;
}
:is(.header-section, .pm-header-actions) .notification-bell__item {
  width: 100%;
  display: flex;
  align-items: flex-start;
  gap: 0.7rem;
  padding: 0.8rem 1rem;
  border: none;
  border-bottom: 1px solid rgb(var(--color-surface-muted));
  background: transparent;
  text-align: left;
  cursor: pointer;
  transition: background 0.15s;
}
:is(.header-section, .pm-header-actions) .notification-bell__item:hover {
  background: rgb(var(--color-surface-overlay));
}
:is(.header-section, .pm-header-actions) .notification-bell__item--unread {
  background: rgb(var(--color-info-soft));
}
:is(.header-section, .pm-header-actions) .notification-bell__item--unread:hover {
  background: rgb(var(--color-info-soft));
}
:is(.header-section, .pm-header-actions) .notification-bell__icon {
  flex-shrink: 0;
  width: 2rem;
  height: 2rem;
  border-radius: 999px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 0.8rem;
}
:is(.header-section, .pm-header-actions) .notification-bell__icon--order {
  background: rgb(var(--color-info-soft));
  color: rgb(var(--color-info-contrast));
}
:is(.header-section, .pm-header-actions) .notification-bell__icon--trade {
  background: rgb(var(--color-success-soft));
  color: rgb(var(--color-success-contrast));
}
:is(.header-section, .pm-header-actions) .notification-bell__icon--order_complete {
  background: rgb(var(--color-success-soft));
  color: rgb(var(--color-success-contrast));
}
:is(.header-section, .pm-header-actions) .notification-bell__icon--position {
  background: rgb(var(--color-info-soft));
  color: rgb(var(--color-info-contrast));
}
:is(.header-section, .pm-header-actions) .notification-bell__icon--resolution {
  background: rgb(var(--color-warning-soft));
  color: rgb(var(--color-warning-contrast));
}
:is(.header-section, .pm-header-actions) .notification-bell__icon--wallet {
  background: rgb(var(--color-warning-soft));
  color: rgb(var(--color-warning-contrast));
}
:is(.header-section, .pm-header-actions) .notification-bell__content {
  display: flex;
  flex-direction: column;
  gap: 0.15rem;
  min-width: 0;
}
:is(.header-section, .pm-header-actions) .notification-bell__title {
  font-size: 0.8rem;
  font-weight: 700;
  color: rgb(var(--color-ink));
  overflow-wrap: anywhere;
}
:is(.header-section, .pm-header-actions) .notification-bell__option {
  font-size: 0.72rem;
  font-weight: 600;
  color: rgb(var(--color-ink-muted));
  overflow-wrap: anywhere;
}
:is(.header-section, .pm-header-actions) .notification-bell__message {
  font-size: 0.75rem;
  color: rgb(var(--color-ink-soft));
  line-height: 1.35;
  overflow-wrap: anywhere;
}
:is(.header-section, .pm-header-actions) .notification-bell__time {
  font-size: 0.68rem;
  color: rgb(var(--color-ink-faint));
  font-weight: 500;
  margin-top: 0.1rem;
}
@media (max-width: 620px) {
  :is(.header-section, .pm-header-actions) .market-orders-indicator__dropdown {
    position: fixed;
    top: 76px;
    left: 12px;
    right: 12px;
    width: auto;
  }
  .header-section .balance-section {
    padding-right: 0;
    gap: 0;
    width: fit-content;
  }
  .header-section .balance-values {
    display: none;
  }
  .header-section .actions-section {
    width: fit-content;
    margin-left: auto;
  }
  .header-section .action-icons {
    border-radius: 10px;
    overflow: hidden;
  }
  .header-section .action-icons button {
    min-height: 2.45rem;
  }
  :is(.header-section, .pm-header-actions) .notification-bell__dropdown {
    position: fixed;
    top: 76px;
    left: 12px;
    right: 12px;
    width: auto;
  }
}

/* from src/games/PredictionMarket/components/Markets/markets.scss */
/* Featured news ticker fade edges (Tailwind animation + mask) */
.masked-news-fade {
  mask-image: linear-gradient(180deg, transparent 0%, #000 14%, #000 86%, transparent 100%);
}

/* from src/games/PredictionMarket/components/MarketDetail/marketDetail.scss */
.market-detail-wrapper {
  width: min(100%, calc(100% - var(--pm-content-pad, 16px) * 2));
  max-width: 1400px;
  margin: 12px auto;
  padding: 0 4px;
  max-height: calc(100vh - var(--pm-header-offset, 140px) - 8px);
  overflow-y: auto;
  scrollbar-width: none;
  -ms-overflow-style: none;
  padding-bottom: 16px;
  box-sizing: border-box;
  font-family: inherit;
  animation: pm-fade-in-up var(--pm-duration-slow, 0.36s) var(--pm-ease, ease) both;
}

/* stretch so the order column matches main height — sticky panel then lasts until
   layout ends; footer below scrolls the whole block up together */
.market-detail-layout {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(260px, min(380px, 100%));
  gap: clamp(12px, 2.5vw, 20px);
  align-items: stretch;
}

.market-detail-main {
  min-width: 0;
}

.market-detail-order-panel-wrap {
  --order-panel-top: 12px;
  --order-panel-bottom-pad: 16px;
  --order-panel-max-h: calc(
    100vh - var(--pm-header-offset, 140px) - var(--order-panel-top) - var(--order-panel-bottom-pad)
  );
  --order-panel-max-h: calc(
    100dvh - var(--pm-header-offset, 140px) - var(--order-panel-top) - var(--order-panel-bottom-pad)
  );
  min-width: 0;
  width: 100%;
  max-width: 380px;
  justify-self: end;
  align-self: start;
  display: flex;
  flex-direction: column;
  position: sticky;
  top: var(--order-panel-top);
  max-height: var(--order-panel-max-h);
}

.market-detail-order-panel-wrap .order-panel {
  align-self: stretch;
  flex: 0 1 auto;
  min-height: 0;
  height: auto;
  max-height: var(--order-panel-max-h);
  position: static;
  top: auto;
}

.market-detail-wrapper::-webkit-scrollbar {
  width: 0;
  height: 0;
}

.market-detail-wrapper > footer {
  margin-top: 24px;
  margin-left: -8px;
  margin-right: -8px;
  width: calc(100% + 16px);
}

.market-detail-header {
  display: flex;
  gap: 14px;
  margin-bottom: 16px;
  animation: pm-fade-in-up var(--pm-duration, 0.24s) var(--pm-ease, ease) 0.06s both;
}

.market-detail-image {
  width: 56px;
  height: 56px;
  border-radius: var(--pm-radius, 8px);
  object-fit: cover;
  border: 1px solid rgb(var(--color-line));
  transition: transform var(--pm-duration, 0.24s) var(--pm-ease-spring, ease);
}

.market-detail-header:hover .market-detail-image {
  transform: scale(1.04);
}

.market-detail-meta {
  flex: 1 1;
}

.market-category {
  font-size: 12px;
  color: rgb(var(--color-ink-faint));
  margin: 0 0 6px 0;
  text-transform: uppercase;
  font-weight: 600;
}

.market-title {
  font-size: 1.15rem;
  line-height: 1.35;
  font-weight: 700;
  letter-spacing: -0.01em;
  margin: 0 0 8px 0;
  color: rgb(var(--color-ink));
}

.market-meta-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.market-meta {
  font-size: 13px;
  color: rgb(var(--color-ink-faint));
  font-weight: 500;
  margin: 0;
}

.market-meta-actions {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  flex-shrink: 0;
}

.graph-legend {
  display: flex;
  flex-wrap: wrap;
  gap: 14px 20px;
  margin-bottom: 14px;
  padding-bottom: 12px;
  border-bottom: 1px solid rgb(var(--color-surface-muted));
}

.graph-legend-item {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
}

.graph-legend-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  flex-shrink: 0;
}

.graph-legend-text {
  display: inline-flex;
  align-items: baseline;
  gap: 8px;
  font-size: 14px;
  font-weight: 600;
  min-width: 0;
}

.graph-legend-title {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 200px;
}

.graph-legend-chance {
  font-weight: 600;
  font-variant-numeric: tabular-nums;
  flex-shrink: 0;
}

.graph-tooltip {
  background: white;
  border: 1px solid rgb(var(--color-line));
  padding: 8px 10px;
  border-radius: 10px;
  box-shadow: 0 8px 20px rgb(var(--color-shadow) / 0.08);
  min-width: 140px;
}

.tooltip-time {
  font-size: 11px;
  color: rgb(var(--color-ink-faint));
  margin: 0 0 8px 0;
  padding-bottom: 6px;
  border-bottom: 1px solid rgb(var(--color-surface-muted));
}

.tooltip-row {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  gap: 16px;
  font-size: 13px;
  font-weight: 600;
  margin: 4px 0 0 0;
}

.tooltip-option-title {
  flex: 1 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.tooltip-option-chance {
  font-variant-numeric: tabular-nums;
  flex-shrink: 0;
}

.graph-range-filters {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  gap: 4px;
  margin-top: 4px;
  padding-top: 14px;
  border-top: 1px solid rgb(var(--color-surface-muted));
}

.graph-range-btn {
  padding: 6px 14px;
  border: none;
  border-radius: 999px;
  background: transparent;
  font-size: 13px;
  font-weight: 600;
  color: rgb(var(--color-ink-faint));
  cursor: pointer;
  font-family: inherit;
  line-height: 1.2;
  transition: background 0.15s ease, color 0.15s ease;
}

.graph-range-btn:hover {
  color: rgb(var(--color-ink));
}

.graph-range-btn--active {
  background: rgb(var(--color-accent-soft));
  color: rgb(var(--color-ink));
}

.user-activity-panel {
  border-top: 1px solid rgb(var(--color-surface-muted));
  padding-top: 12px;
  animation: pm-fade-in var(--pm-duration, 0.28s) var(--pm-ease, ease);
}

.ua-top-holders-head {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 10px;
}

.ua-top-holders-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
}

.ua-comment-card {
  border: 1px solid rgb(var(--color-line));
  border-radius: 10px;
  padding: 10px;
  background: rgb(var(--color-surface-overlay));
}

.ua-comment-card + .ua-comment-card {
  margin-top: 8px;
}

.ua-comment-head {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
}

.ua-comment-head-user {
  display: flex;
  align-items: center;
  gap: 8px;
}

.ua-comment-head-user img {
  width: 26px;
  height: 26px;
  border-radius: 999px;
  object-fit: cover;
  flex-shrink: 0;
}

.ua-comment-user {
  font-size: 12px;
  font-weight: 600;
  color: rgb(var(--color-ink));
}

.ua-comment-time {
  font-size: 11px;
  color: rgb(var(--color-ink-faint));
}

.ua-comment-text {
  margin: 6px 0 0 0;
  font-size: 13px;
  line-height: 1.5;
  color: rgb(var(--color-ink-soft));
  overflow-wrap: break-word;
}

.ua-comment-compose {
  border: 1px solid rgb(var(--color-line));
  border-radius: 10px;
  padding: 10px;
  background: rgb(var(--color-surface-overlay));
  margin-bottom: 10px;
}

.ua-comment-compose-label {
  display: block;
  font-size: 12px;
  font-weight: 600;
  color: rgb(var(--color-ink));
  margin-bottom: 8px;
}

.ua-comment-compose-input {
  width: 100%;
  box-sizing: border-box;
  /* border: 1px solid rgb(var(--color-line-strong)); */
  border-radius: 8px;
  background: rgb(var(--color-surface-raised));
  color: rgb(var(--color-ink));
  font-size: 13px;
  line-height: 1.45;
  font-family: inherit;
  resize: vertical;
  padding: 8px 10px;
}

.ua-comment-compose-input::placeholder {
  color: rgb(var(--color-ink-faint));
}

.ua-comment-compose-btn {
  margin-top: 8px;
  border: 1px solid rgb(var(--color-ink));
  background: rgb(var(--color-ink));
  color: rgb(var(--color-surface-raised));
  border-radius: 0.5rem;
  padding: 6px 12px;
  font-size: 12px;
  font-weight: 600;
  font-family: inherit;
  cursor: pointer;
}

.is-active-button {
  background: rgb(var(--color-ink)) !important;
  border-color: rgb(var(--color-ink)) !important;
  color: rgb(var(--color-surface-raised)) !important;
}

.ua-comment-compose-btn:hover {
  background: rgb(var(--color-ink-soft));
  border-color: rgb(var(--color-ink-soft));
}

.ua-comment-actions {
  margin-top: 8px;
  display: flex;
  align-items: center;
  gap: 8px;
}

.ua-comment-action-btn {
  border: 1px solid rgb(var(--color-line));
  background: rgb(var(--color-surface-raised));
  color: rgb(var(--color-ink-soft));
  border-radius: 0.5rem;
  padding: 4px 10px;
  font-size: 12px;
  font-weight: 600;
  font-family: inherit;
  cursor: pointer;
}

.ua-comment-action-btn:hover {
  background: rgb(var(--color-surface-overlay));
}

.ua-comment-reply-input {
  margin-top: 8px;
  width: 100%;
  box-sizing: border-box;
  border: 1px solid rgb(var(--color-line-strong));
  border-radius: 8px;
  font-size: 13px;
  color: rgb(var(--color-ink));
  background: rgb(var(--color-surface-raised));
  padding: 8px 10px;
  font-family: inherit;
}

.ua-comment-reply-input::placeholder {
  color: rgb(var(--color-ink-faint));
}

.ua-comment-reply-box {
  margin-top: 8px;
  display: flex;
  align-items: center;
  gap: 8px;
}

.ua-comment-reply-btn {
  border: 1px solid rgb(var(--color-ink));
  background: rgb(var(--color-ink));
  color: rgb(var(--color-surface-raised));
  border-radius: 0.5rem;
  padding: 8px 14px;
  font-size: 12px;
  font-weight: 600;
  font-family: inherit;
  cursor: pointer;
  flex-shrink: 0;
  transition: background 0.15s ease, border-color 0.15s ease;
}

.ua-comment-reply-btn:hover {
  background: rgb(var(--color-ink-soft));
  border-color: rgb(var(--color-ink-soft));
}

.ua-replies-list {
  margin-top: 10px;
  padding-left: 12px;
  border-left: 2px solid rgb(var(--color-line));
  display: grid;
  gap: 8px;
  animation: pm-fade-in var(--pm-duration, 0.28s) var(--pm-ease, ease);
}

.ua-reply-card {
  border: 1px solid rgb(var(--color-line));
  border-radius: 10px;
  padding: 8px 10px;
  background: rgb(var(--color-surface-raised));
}

.ua-load-more-btn {
  width: 100%;
  margin-top: 12px;
  border: 1px solid rgb(var(--color-line-strong));
  background: rgb(var(--color-surface-overlay));
  color: rgb(var(--color-ink));
  border-radius: 0.5rem;
  padding: 10px 14px;
  font-size: 13px;
  font-weight: 600;
  font-family: inherit;
  cursor: pointer;
  transition: background 0.15s ease, border-color 0.15s ease, color 0.15s ease;
}

.ua-load-more-btn:hover:not(:disabled) {
  background: rgb(var(--color-surface-muted));
  border-color: rgb(var(--color-line-strong));
}

.ua-load-more-btn:disabled {
  cursor: not-allowed;
  opacity: 0.7;
}

.ua-table-wrap {
  width: 100%;
  overflow-x: auto;
  scrollbar-width: none;
  -ms-overflow-style: none;
}

.ua-table-wrap::-webkit-scrollbar {
  width: 0;
  height: 0;
}

.ua-split-tables {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
}

.ua-table {
  width: 100%;
  min-width: 260px;
  border-collapse: collapse;
}

.ua-table th {
  text-align: left;
  padding: 8px 6px;
  font-size: 11px;
  font-weight: 600;
  color: rgb(var(--color-ink-faint));
  border-bottom: 1px solid rgb(var(--color-surface-muted));
}

.ua-table td {
  padding: 10px 6px;
  font-size: 13px;
  color: rgb(var(--color-ink));
  font-variant-numeric: tabular-nums;
  border-bottom: 1px solid rgb(var(--color-surface-overlay));
}

.ua-activity-list {
  margin: 0;
  padding: 0;
  list-style: none;
}

.ua-activity-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
  padding: 10px 0;
  border-bottom: 1px solid rgb(var(--color-surface-overlay));
}

.ua-activity-main {
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.ua-activity-type {
  font-size: 11px;
  font-weight: 600;
  color: rgb(var(--color-ink-faint));
  text-transform: uppercase;
}

.ua-activity-detail {
  font-size: 13px;
  color: rgb(var(--color-ink));
  line-height: 1.45;
}

.ua-activity-meta {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 2px;
  flex-shrink: 0;
}

.ua-activity-value {
  font-size: 12px;
  font-weight: 600;
  color: rgb(var(--color-ink));
  font-variant-numeric: tabular-nums;
}

.ua-activity-time {
  font-size: 11px;
  color: rgb(var(--color-ink-faint));
}

@media (max-width: 992px) {
  .market-detail-layout {
    grid-template-columns: 1fr;
    gap: 16px;
  }
  .market-detail-order-panel-wrap {
    max-width: none;
    justify-self: stretch;
  }
  .market-detail-wrapper {
    max-height: calc(100vh - 108px);
  }
  .ua-activity-row {
    flex-direction: column;
    align-items: flex-start;
    gap: 6px;
  }
  .ua-activity-meta {
    align-items: flex-start;
  }
  .ua-split-tables {
    grid-template-columns: 1fr;
  }
  .ua-top-holders-grid {
    grid-template-columns: 1fr;
  }
  .ua-comment-head {
    align-items: flex-start;
    flex-direction: column;
    gap: 6px;
  }
  .ua-comment-reply-box {
    flex-direction: column;
    align-items: stretch;
  }
  .ua-comment-reply-btn {
    width: 100%;
  }
  .ua-load-more-btn {
    padding: 10px 12px;
  }
}

.market-detail-trade-fab {
  display: none;
}

@media (max-width: 992px) {
  .market-detail-wrapper {
    padding-bottom: 88px;
  }

  .market-detail-trade-fab {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    position: fixed;
    right: 16px;
    bottom: 20px;
    z-index: 900;
    padding: 14px 20px;
    border: none;
    border-radius: 0.5rem;
    background: rgb(var(--color-accent));
    color: rgb(var(--color-accent-contrast));
    font-size: 15px;
    font-weight: 700;
    font-family: inherit;
    cursor: pointer;
    box-shadow: 0 8px 28px rgb(var(--color-shadow) / 0.2);
    transition:
      transform var(--pm-duration-fast, 0.18s) var(--pm-ease-spring, ease),
      box-shadow var(--pm-duration-fast, 0.18s) var(--pm-ease, ease);
  }

  .market-detail-trade-fab i {
    font-size: 14px;
  }

  .market-detail-trade-fab:hover {
    transform: translateY(-2px);
    box-shadow: 0 12px 32px rgb(var(--color-shadow) / 0.28);
  }

  .market-detail-trade-fab:active {
    transform: translateY(0);
  }

  .market-detail-trade-sheet {
    position: fixed;
    inset: 0;
    z-index: 1200;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
  }

  .market-detail-trade-sheet-backdrop {
    position: absolute;
    inset: 0;
    border: none;
    padding: 0;
    background: rgb(var(--color-ink) / 0.5);
    backdrop-filter: blur(4px);
    -webkit-backdrop-filter: blur(4px);
    cursor: pointer;
    animation: pm-fade-in var(--pm-duration-fast, 0.18s) var(--pm-ease, ease) both;
  }

  .market-detail-trade-sheet-content {
    position: relative;
    z-index: 1;
    width: 100%;
    max-height: min(92vh, 900px);
    max-height: min(92dvh, 900px);
    display: flex;
    flex-direction: column;
    min-height: 0;
    overflow: hidden;
    animation: pm-sheet-slide-up var(--pm-duration, 0.28s) var(--pm-ease, ease) both;
  }
}

@media (max-width: 640px) {
  .market-detail-image {
    width: 60px;
    height: 60px;
  }
}

/* from src/games/PredictionMarket/components/MarketDetail/OrderPanel/orderPanel.scss */
/* The panel shell is styled in orderPanel.styles.js; only the scrollbar
   pseudo-elements, which Tailwind cannot target, remain here. */
.order-panel::-webkit-scrollbar {
  width: 6px;
}

.order-panel::-webkit-scrollbar-thumb {
  border-radius: 999px;
  background: rgb(var(--color-line-strong));
}

.order-panel-disabled .order-panel-submit {
  opacity: 0.55;
  cursor: not-allowed;
}

.order-panel-section {
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.order-panel-field-row {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1.15fr);
  gap: 10px;
  align-items: end;
}

.order-panel-field-row .order-panel-field {
  min-width: 0;
}

.order-panel-field-row .order-panel-stepper-btn {
  flex-basis: 40px;
}

.order-panel-field-row .order-panel-stepper-input {
  padding-left: 8px;
  padding-right: 8px;
}

@container order-panel (max-width: 300px) {
  .order-panel-field-row {
    grid-template-columns: 1fr;
  }

  .order-panel-field-row .order-panel-stepper-btn {
    flex-basis: 40px;
  }
}

.order-panel-section--muted .order-panel-hint {
  margin: 0 0 4px 0;
  font-size: 12px;
  line-height: 1.45;
  color: rgb(var(--color-ink-faint));
}

.order-panel-side-toggle {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 0;
  padding: 3px;
  border-radius: 10px;
  background: rgb(var(--color-surface-overlay));
  /* border: 1px solid rgb(var(--color-line-strong)); */
}

.order-panel-side-toggle-btn {
  padding: 10px 12px;
  border: none;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  font-family: inherit;
  background: transparent;
  color: rgb(var(--color-ink-faint));
  transition: background 0.15s ease, color 0.15s ease;
}

.order-panel-side-toggle-btn--active {
  background: rgb(var(--color-surface-raised));
  color: rgb(var(--color-ink));
  box-shadow: 0 0 0 1px rgb(var(--color-line-strong)) inset;
}

.order-panel-outcome {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px;
}

.order-panel-outcome-btn {
  padding: 12px 10px;
  border-radius: 0.5rem;
  border: 1px solid rgb(var(--color-line));
  background: rgb(var(--color-surface-raised));
  color: rgb(var(--color-ink-soft));
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  font-family: inherit;
  font-variant-numeric: tabular-nums;
  transition: border-color 0.15s ease, background 0.15s ease, box-shadow 0.15s ease;
}

.order-panel-outcome-btn:hover {
  border-color: rgb(var(--color-line-strong));
  background: rgb(var(--color-surface-overlay));
}

.order-panel-outcome-btn--active {
  border-color: rgb(var(--color-ink));
  background: rgb(var(--color-surface-muted));
  color: rgb(var(--color-ink));
  box-shadow: 0 0 0 1px rgb(var(--color-shadow) / 0.14);
}

.order-panel-outcome-btn--yes.order-panel-outcome-btn--active {
  border-color: rgb(var(--pm-gold));
  background: rgb(var(--pm-gold) / 0.16);
  color: rgb(var(--pm-gold));
  box-shadow: 0 0 0 1px rgb(var(--pm-gold) / 0.28);
}

.order-panel-outcome-btn--no.order-panel-outcome-btn--active {
  border-color: rgb(var(--color-danger));
  background: rgb(var(--color-danger) / 0.12);
  color: rgb(var(--color-danger-contrast));
  box-shadow: 0 0 0 1px rgb(var(--color-danger) / 0.22);
}

.order-panel-field {
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin: 0;
}

.order-panel-field-label {
  font-size: 12px;
  font-weight: 600;
  color: rgb(var(--color-ink-faint));
}

.order-panel-stepper {
  display: flex;
  align-items: stretch;
  border-radius: 10px;
  border: 1px solid rgb(var(--color-line));
  background: rgb(var(--color-surface-raised));
  overflow: hidden;
}

.order-panel-stepper-btn {
  flex: 0 0 44px;
  border: none;
  background: rgb(var(--color-surface-overlay));
  color: rgb(var(--color-ink-muted));
  font-size: 18px;
  font-weight: 500;
  line-height: 1;
  cursor: pointer;
  font-family: inherit;
  transition: background 0.12s ease, color 0.12s ease;
}

.order-panel-stepper-btn:hover {
  background: rgb(var(--color-surface-muted));
  color: rgb(var(--color-ink));
}

.order-panel-stepper-btn:active {
  background: rgb(var(--color-line));
}

.order-panel-stepper > .order-panel-stepper-input {
  border-left: 1px solid rgb(var(--color-line));
  border-right: 1px solid rgb(var(--color-line));
}

.order-panel-stepper-input-wrap {
  flex: 1 1;
  min-width: 0;
  display: flex;
  align-items: center;
  position: relative;
  border-left: 1px solid rgb(var(--color-line));
  border-right: 1px solid rgb(var(--color-line));
}

.order-panel-stepper-input {
  flex: 1 1;
  min-width: 0;
  border: none;
  background: transparent;
  color: rgb(var(--color-ink));
  font-size: 15px;
  font-weight: 600;
  font-variant-numeric: tabular-nums;
  padding: 12px 10px;
  text-align: center;
  outline: none;
  font-family: inherit;
}

.order-panel-stepper-input::placeholder {
  color: rgb(var(--color-ink-faint));
}

.order-panel-stepper-input--cents {
  padding-right: 22px;
  text-align: center;
}

.order-panel-suffix {
  position: absolute;
  right: 10px;
  font-size: 13px;
  font-weight: 600;
  color: rgb(var(--color-ink-faint));
  pointer-events: none;
}

.order-panel-submit {
  margin-top: 4px;
  width: 100%;
  padding: 11px 14px;
  border: 1px solid rgb(var(--pm-gold) / 0.55);
  border-radius: 0.5rem;
  background: linear-gradient(
    180deg,
    rgb(var(--pm-gold)) 0%,
    rgb(var(--pm-gold-dark, 203 125 0)) 100%
  );
  color: rgb(var(--color-accent-contrast));
  font-size: 13px;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  cursor: pointer;
  font-family: inherit;
  transition: filter 0.15s ease, transform 0.05s ease, box-shadow 0.15s ease;
  box-shadow: 0 2px 8px rgb(var(--pm-gold) / 0.28);
}

.order-panel-submit:disabled {
  opacity: 0.55;
  cursor: not-allowed;
  filter: none;
  transform: none;
  box-shadow: none;
}

.order-panel-submit:hover {
  filter: brightness(1.06);
}

.order-panel-submit:hover:disabled {
  filter: none;
}

.order-panel-submit:active {
  transform: scale(0.99);
}

.order-panel-submit:active:disabled {
  transform: none;
}

.order-panel-error-message {
  margin: 8px 0 0;
  font-size: 12px;
  font-weight: 600;
  line-height: 1.4;
  color: rgb(var(--color-danger));
}

.order-panel-market-tab-summary,
.order-panel-limit-tab-summary {
  margin-top: 2px;
  padding: 10px 12px;
  /* border: 1px solid rgb(var(--color-line-strong)); */
  border-radius: 10px;
  background: rgb(var(--color-surface-overlay));
}

.order-panel-summary-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 6px 10px;
  color: rgb(var(--color-ink-soft));
  font-size: 12px;
  font-weight: 600;
  line-height: 1.4;
}

.order-panel-summary-label {
  color: rgb(var(--color-ink-faint));
  font-weight: 600;
}

.order-panel-commission-rate {
  margin-left: 2px;
  color: rgb(var(--color-warning));
  font-size: 11px;
  font-weight: 500;
}

.order-panel-summary-value {
  color: rgb(var(--color-ink));
  font-weight: 600;
  font-variant-numeric: tabular-nums;
}

.order-panel-summary-row + .order-panel-summary-row {
  margin-top: 8px;
}

.order-panel-fee-note {
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-top: 8px;
}

.order-panel-fee-note-copy {
  margin: 0;
  color: rgb(var(--color-ink-soft));
  font-size: 12px;
  font-weight: 600;
  line-height: 1.4;
}

.order-panel-fee-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 12px;
  font-variant-numeric: tabular-nums;
}

.order-panel-fee-table-caption {
  caption-side: top;
  text-align: left;
  margin-bottom: 6px;
  color: rgb(var(--color-ink-faint));
  font-size: 11px;
  font-weight: 700;
}

.order-panel-fee-table th,
.order-panel-fee-table td {
  padding: 6px 0;
  border-bottom: 1px solid rgb(var(--color-line));
  text-align: left;
}

.order-panel-fee-table th:last-child,
.order-panel-fee-table td:last-child {
  text-align: right;
}

.order-panel-fee-table th {
  color: rgb(var(--color-ink-faint));
  font-weight: 700;
}

.order-panel-submit--secondary {
  background: rgb(var(--color-surface-muted));
  color: rgb(var(--color-ink));
  border: 1px solid rgb(var(--color-line-strong));
  box-shadow: none;
  letter-spacing: 0.02em;
  text-transform: none;
}

.order-panel-submit--secondary:hover {
  background: rgb(var(--color-line));
  filter: none;
}

/* Match market detail stack breakpoint (992px) — mobile uses sheet modal */
@media (max-width: 992px) {
  .market-detail-order-panel-wrap {
    position: static;
    top: auto;
    max-height: none;
  }

  .market-detail-order-panel-wrap .order-panel {
    height: auto;
    max-height: none;
  }
}
@media (max-width: 480px) {
  .order-panel-stepper-btn {
    flex-basis: 40px;
  }
}

/* from src/games/PredictionMarket/components/MarketDetail/OptionList/optionList.scss */
.option-detail-toolbar {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  margin-bottom: 12px;
  row-gap: 10px;
}

.option-detail-tabs {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  flex-shrink: 0;
}

.option-detail-book-tabs {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  flex-shrink: 0;
  margin-left: auto;
}

.option-detail-tab {
  border: 1px solid rgb(var(--color-line));
  border-radius: 999px;
  background: rgb(var(--color-surface-raised));
  color: rgb(var(--color-ink-faint));
  font-size: 13px;
  font-weight: 600;
  font-family: inherit;
  padding: 7px 12px;
  cursor: pointer;
  white-space: nowrap;
  line-height: 1.2;
}

.option-detail-tab--active {
  color: rgb(var(--color-ink));
  background: rgb(var(--color-accent-soft));
  border-color: rgb(var(--color-line-strong));
}

.option-detail-tab--yes.option-detail-tab--active {
  color: rgb(var(--pm-gold));
  background: rgb(var(--pm-gold) / 0.14);
  border-color: rgb(var(--pm-gold));
}

.option-detail-tab--no.option-detail-tab--active {
  color: rgb(var(--color-danger-contrast));
  background: rgb(var(--color-danger) / 0.12);
  border-color: rgb(var(--color-danger));
}

.option-orderbook {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.option-orderbook-grid {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.book-side {
  /* border: 1px solid rgb(var(--color-line-strong)); */
  border-radius: 10px;
  padding: 12px;
  /* background: rgb(var(--color-surface-raised)); */
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.book-side-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.book-side-title {
  margin: 0;
  font-size: 13px;
  font-weight: 600;
  color: rgb(var(--color-ink));
  letter-spacing: 0.02em;
}

.book-block {
  border: 1px solid rgb(var(--color-line));
  border-radius: 8px;
  overflow: hidden;
  background: rgb(var(--color-surface-overlay));
}

.book-block--ask {
  border-color: rgb(var(--color-danger-soft));
  background: rgb(var(--color-danger-soft));
}

.book-block--bid {
  border-color: rgb(var(--color-success-soft));
  background: rgb(var(--color-success-soft));
}

.book-block-heading {
  padding: 6px 10px;
  border-bottom: 1px solid rgb(var(--color-line));
  background: rgb(var(--color-surface-raised));
}

.book-block--ask .book-block-heading {
  border-bottom-color: rgb(var(--color-danger-soft));
}

.book-block--bid .book-block-heading {
  border-bottom-color: rgb(var(--color-success-soft));
}

.book-block-side {
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: rgb(var(--color-ink-faint));
}

.book-block--ask .book-block-side {
  color: rgb(var(--color-danger-contrast));
}

.book-block--bid .book-block-side {
  color: rgb(var(--color-success-contrast));
}

.book-grid {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr) minmax(0, 1fr);
  column-gap: 8px;
  align-items: center;
  padding: 0 10px;
}

.book-grid--header {
  min-height: 28px;
  font-size: 11px;
  font-weight: 600;
  /* color: rgb(var(--color-ink-faint)); */
  background: rgb(var(--color-surface-raised));
  border-bottom: 1px solid rgb(var(--color-line));
}

.book-block--ask .book-grid--header {
  border-bottom-color: rgb(var(--color-danger-soft));
}

.book-block--bid .book-grid--header {
  border-bottom-color: rgb(var(--color-success-soft));
}

.book-grid-body {
  max-height: 168px;
  overflow-y: auto;
  overflow-x: hidden;
  scrollbar-gutter: stable;
  padding: 4px 0;
}
.book-grid-body::-webkit-scrollbar {
  width: 6px;
}
.book-grid-body::-webkit-scrollbar-thumb {
  background: rgb(var(--color-line-strong));
  border-radius: 3px;
}

.book-grid--row {
  min-height: 28px;
  margin: 0 4px 2px;
  padding: 0 6px;
  border-radius: 4px;
  font-size: 12px;
  color: rgb(var(--color-ink));
  font-variant-numeric: tabular-nums;
}

.book-grid-col--right {
  text-align: right;
}

.book-row {
  --row-fill: 0%;
  background: linear-gradient(to right, var(--row-color) 0, var(--row-color) var(--row-fill), transparent var(--row-fill), transparent 100%);
}

.book-row--ask {
  --row-color: rgb(var(--color-danger) / 0.18);
}

.book-row--bid {
  --row-color: rgb(var(--color-success) / 0.18);
}

.book-row--ask.book-row--user-order {
  --row-color: rgb(var(--color-danger) / 0.42);
  box-shadow: inset 3px 0 0 rgb(var(--color-danger));
  font-weight: 700;
}

.book-row--bid.book-row--user-order {
  --row-color: rgb(var(--color-success) / 0.42);
  box-shadow: inset 3px 0 0 rgb(var(--color-success));
  font-weight: 700;
}

.book-row-you {
  margin-left: 6px;
  padding: 1px 5px;
  border-radius: 3px;
  font-size: 10px;
  font-style: normal;
  font-weight: 700;
  letter-spacing: 0.02em;
  color: rgb(var(--color-ink));
  background: rgb(var(--color-accent-soft));
  border: 1px solid rgb(var(--color-line-strong));
  vertical-align: middle;
}

.book-spread-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  margin: 2px 0;
  padding: 8px 10px;
  border: 1px dashed rgb(var(--color-line-strong));
  border-radius: 8px;
  background: rgb(var(--color-surface-muted));
}

.book-spread-label {
  font-size: 11px;
  font-weight: 600;
  /* color: rgb(var(--color-ink-faint)); */
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

.book-spread-value {
  font-size: 12px;
  font-weight: 600;
  color: rgb(var(--color-ink));
  font-variant-numeric: tabular-nums;
}

.book-empty-row {
  padding: 12px 10px;
  text-align: center;
  font-size: 12px;
  /* color: rgb(var(--color-ink-faint)); */
}

.option-graph {
  /* border: 1px solid rgb(var(--color-line-strong)); */
  border-radius: 12px;
  padding: 10px 10px 8px;
  /* background: rgb(var(--color-surface-raised)); */
}

.option-graph-legend {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 6px;
}

.option-graph-legend-item {
  border-radius: 999px;
  padding: 4px 8px;
  font-size: 11px;
  font-weight: 600;
}

.option-graph-legend-item--yes-bid {
  background: rgb(var(--color-success-soft));
  color: rgb(var(--color-success-contrast));
}

.option-graph-legend-item--yes-ask {
  background: rgb(var(--color-success-soft));
  color: rgb(var(--color-success-contrast));
}

.option-graph-legend-item--no-bid {
  background: rgb(var(--color-info-soft));
  color: rgb(var(--color-info-contrast));
}

.option-graph-legend-item--no-ask {
  background: rgb(var(--color-info-soft));
  color: rgb(var(--color-info-contrast));
}

@media (max-width: 640px) {
  .option-orderbook-grid {
    gap: 10px;
  }

  .option-detail-toolbar {
    flex-direction: column;
    align-items: stretch;
  }

  .option-detail-tabs,
  .option-detail-book-tabs {
    margin-left: 0;
    width: 100%;
  }

  .option-detail-tab {
    flex: 1 1 auto;
    text-align: center;
    font-size: 12px;
    padding: 8px 10px;
  }
}

/* from src/games/PredictionMarket/components/Portfolio/portfolio.scss */
.portfolio-page {
  width: min(100%, calc(100% - var(--pm-content-pad, 12px) * 2));
  max-width: 1400px;
  margin: 10px auto 0;
  padding: 0 4px 16px;
  box-sizing: border-box;
  animation: pm-fade-in-up var(--pm-duration-slow, 0.36s) var(--pm-ease, ease) both;
}

.portfolio-summary-wrap {
  margin-bottom: 12px;
}

.portfolio-summary-card,
.portfolio-tabs-card {
  border: 1px solid rgb(var(--color-line-strong));
  border-radius: var(--pm-radius, 8px);
  background: linear-gradient(
    180deg,
    rgb(var(--color-surface-raised)) 0%,
    rgb(var(--color-surface-muted) / 0.45) 100%
  );
  box-shadow: inset 0 1px 0 rgb(var(--pm-gold) / 0.06);
}

.portfolio-summary-card {
  padding: 12px;
}

.portfolio-summary-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 14px;
  margin-bottom: 14px;
}

.portfolio-summary-caption {
  margin: 0 0 4px 0;
  font-size: 12px;
  font-weight: 600;
  color: rgb(var(--color-ink-faint));
  text-transform: uppercase;
}

.portfolio-summary-title {
  margin: 0;
  font-size: 23px;
  line-height: 1.2;
  letter-spacing: -0.01em;
  color: rgb(var(--color-ink));
}

.portfolio-summary-actions {
  display: flex;
  align-items: center;
  gap: 8px;
}

.portfolio-action-btn {
  border: 1px solid rgb(var(--color-line-strong));
  border-radius: 0.5rem;
  padding: 8px 14px;
  background: rgb(var(--color-surface-raised));
  color: rgb(var(--color-ink));
  font-size: 13px;
  font-weight: 600;
  font-family: inherit;
  cursor: pointer;
}

.portfolio-action-btn:hover {
  background: rgb(var(--color-surface-overlay));
}

.portfolio-action-btn--primary {
  background: rgb(var(--color-ink));
  border-color: rgb(var(--color-ink));
  color: rgb(var(--color-surface-raised));
}

.portfolio-action-btn--primary:hover {
  background: rgb(var(--color-ink-soft));
  border-color: rgb(var(--color-ink-soft));
}

.portfolio-metrics-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 10px;
  margin-bottom: 14px;
}

.portfolio-metric-card {
  border: 1px solid rgb(var(--color-line));
  border-radius: 12px;
  background: rgb(var(--color-surface-overlay));
  padding: 10px;
}

.portfolio-metric-label {
  margin: 0 0 6px 0;
  font-size: 12px;
  color: rgb(var(--color-ink-faint));
  font-weight: 600;
}

.portfolio-metric-label-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  margin-bottom: 6px;
}

.portfolio-metric-label-row .portfolio-metric-label {
  margin: 0;
}

.portfolio-commission-btn {
  flex-shrink: 0;
  border: 1px solid rgb(var(--color-line));
  border-radius: 0.5rem;
  background: transparent;
  padding: 2px 8px;
  font-size: 10px;
  font-weight: 600;
  color: rgb(var(--color-ink-faint));
  cursor: pointer;
  line-height: 1.4;
  white-space: nowrap;
}

.portfolio-commission-btn:hover {
  border-color: rgb(var(--color-ink-faint));
  color: rgb(var(--color-ink));
}

.portfolio-commission-btn--active {
  border-color: rgb(var(--color-ink-faint));
  background: rgb(var(--color-surface-muted));
  color: rgb(var(--color-ink));
}

.portfolio-metric-value {
  margin: 0;
  font-size: 22px;
  font-weight: 600;
  color: rgb(var(--color-ink));
  line-height: 1.25;
  font-variant-numeric: tabular-nums;
}

.portfolio-metric-value--positive {
  color: rgb(var(--color-success-contrast));
}

.portfolio-metric-value--negative {
  color: rgb(var(--color-danger-contrast));
}

.portfolio-metric-commission {
  font-size: 14px;
  font-weight: 500;
  color: rgb(var(--color-ink-faint));
}

.portfolio-profit-graph {
  border: 1px solid rgb(var(--color-line));
  border-radius: 12px;
  padding: 10px 8px 2px;
}

.portfolio-profit-graph-head {
  padding: 0 8px;
}

.portfolio-profit-title {
  margin: 0 0 8px 0;
  font-size: 14px;
  font-weight: 600;
  color: rgb(var(--color-ink));
}

.portfolio-tooltip {
  background: rgb(var(--color-surface-raised));
  border: 1px solid rgb(var(--color-line));
  border-radius: 10px;
  box-shadow: 0 8px 20px rgb(var(--color-shadow) / 0.08);
  padding: 8px 10px;
}

.portfolio-tooltip-time {
  margin: 0 0 6px 0;
  border-bottom: 1px solid rgb(var(--color-surface-muted));
  padding-bottom: 6px;
  font-size: 11px;
  color: rgb(var(--color-ink-faint));
}

.portfolio-tooltip-profit {
  margin: 0;
  font-size: 13px;
  font-weight: 600;
}

.portfolio-tooltip-profit--up {
  color: rgb(var(--color-success-contrast));
}

.portfolio-tooltip-profit--down {
  color: rgb(var(--color-danger-contrast));
}

.portfolio-tabs-card {
  padding: 18px 18px 16px;
}

.portfolio-activity-head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 16px;
}

.portfolio-activity-eyebrow {
  margin: 0 0 4px;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: rgb(var(--color-ink-faint));
}

.portfolio-activity-title {
  margin: 0;
  font-size: 22px;
  line-height: 1.2;
  letter-spacing: -0.02em;
  color: rgb(var(--color-ink));
}

.portfolio-history-controls {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
  flex-shrink: 0;
}

.portfolio-search-wrap {
  position: relative;
  display: flex;
  align-items: center;
}

.portfolio-search-icon {
  position: absolute;
  left: 12px;
  font-size: 12px;
  color: rgb(var(--color-ink-faint));
  pointer-events: none;
}

.portfolio-search-input {
  height: 38px;
  min-width: 240px;
  border: 1px solid rgb(var(--color-line));
  border-radius: 12px;
  padding: 0 12px 0 34px;
  font-size: 13px;
  color: rgb(var(--color-ink));
  background: rgb(var(--color-surface-overlay));
  transition: border-color 0.15s ease, background 0.15s ease, box-shadow 0.15s ease;
}

.portfolio-search-input:focus {
  outline: none;
  border-color: rgb(var(--color-info));
  background: rgb(var(--color-surface-raised));
  box-shadow: 0 0 0 3px rgb(var(--color-info) / 0.1);
}

.portfolio-refresh-btn {
  width: 38px;
  height: 38px;
  border: 1px solid rgb(var(--color-line));
  border-radius: 0.5rem;
  background: rgb(var(--color-surface-overlay));
  color: rgb(var(--color-ink-muted));
  cursor: pointer;
  transition: all 0.15s ease;
}

.portfolio-refresh-btn:hover {
  color: rgb(var(--color-ink));
  background: rgb(var(--color-surface-raised));
  border-color: rgb(var(--color-line-strong));
}

.portfolio-activity-tabs {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 10px;
  margin-bottom: 14px;
}

.portfolio-tab-btn {
  position: relative;
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 0;
  padding: 12px 14px;
  border: 1px solid rgb(var(--color-line));
  border-radius: 14px;
  background: linear-gradient(180deg, rgb(var(--color-surface-raised)) 0%, rgb(var(--color-surface-overlay)) 100%);
  color: rgb(var(--color-ink-faint));
  font-size: 13px;
  font-weight: 700;
  font-family: inherit;
  cursor: pointer;
  overflow: hidden;
  transition: transform 0.15s ease, border-color 0.15s ease, box-shadow 0.15s ease;
}

.portfolio-tab-btn::before {
  content: "";
  position: absolute;
  inset: 0 auto auto 0;
  width: 100%;
  height: 3px;
  opacity: 0;
  transition: opacity 0.15s ease;
}

.portfolio-tab-btn--positions::before {
  background: linear-gradient(90deg, rgb(var(--color-success)), rgb(var(--color-success)));
}

.portfolio-tab-btn--orders::before {
  background: linear-gradient(90deg, rgb(var(--color-info)), rgb(var(--color-info)));
}

.portfolio-tab-btn--history::before {
  background: linear-gradient(90deg, rgb(var(--color-info)), rgb(var(--color-info)));
}

.portfolio-tab-btn:hover {
  transform: translateY(-1px);
  border-color: rgb(var(--color-line-strong));
  box-shadow: 0 8px 20px rgb(var(--color-shadow) / 0.06);
  color: rgb(var(--color-ink));
}

.portfolio-tab-btn--active {
  color: rgb(var(--color-ink));
  border-color: transparent;
  box-shadow: 0 10px 24px rgb(var(--color-shadow) / 0.08);
}

.portfolio-tab-btn--active::before {
  opacity: 1;
}

.portfolio-tab-btn--active.portfolio-tab-btn--positions {
  background: linear-gradient(180deg, rgb(var(--color-success-soft)) 0%, rgb(var(--color-surface-raised)) 72%);
}

.portfolio-tab-btn--active.portfolio-tab-btn--orders {
  background: linear-gradient(180deg, rgb(var(--color-info-soft)) 0%, rgb(var(--color-surface-raised)) 72%);
}

.portfolio-tab-btn--active.portfolio-tab-btn--history {
  background: linear-gradient(180deg, rgb(var(--color-info-soft)) 0%, rgb(var(--color-surface-raised)) 72%);
}

.portfolio-tab-btn-icon {
  width: 34px;
  height: 34px;
  border-radius: 10px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  font-size: 14px;
  background: rgb(var(--color-surface-muted));
  color: rgb(var(--color-ink-faint));
}

.portfolio-tab-btn--active.portfolio-tab-btn--positions .portfolio-tab-btn-icon {
  background: rgb(var(--color-success-soft));
  color: rgb(var(--color-success-contrast));
}

.portfolio-tab-btn--active.portfolio-tab-btn--orders .portfolio-tab-btn-icon {
  background: rgb(var(--color-info-soft));
  color: rgb(var(--color-info-contrast));
}

.portfolio-tab-btn--active.portfolio-tab-btn--history .portfolio-tab-btn-icon {
  background: rgb(var(--color-info-soft));
  color: rgb(var(--color-info-contrast));
}

.portfolio-tab-btn-label {
  flex: 1 1;
  text-align: left;
  min-width: 0;
}

.portfolio-tab-count {
  min-width: 22px;
  height: 22px;
  padding: 0 6px;
  border-radius: 999px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 11px;
  font-weight: 700;
  font-variant-numeric: tabular-nums;
  background: rgb(var(--color-shadow) / 0.06);
  color: rgb(var(--color-ink-soft));
}

.portfolio-tab-btn--active .portfolio-tab-count {
  background: rgb(var(--color-shadow) / 0.1);
}

.portfolio-tab-panel {
  --panel-accent: rgb(var(--color-ink-faint));
  --panel-accent-soft: rgb(var(--color-surface-overlay));
  --panel-row-accent: rgb(var(--color-line));
  min-height: 84px;
}

.portfolio-tab-panel--positions {
  --panel-accent: rgb(var(--color-success));
  --panel-accent-soft: rgb(var(--color-success-soft));
  --panel-row-accent: rgb(var(--color-success));
}

.portfolio-tab-panel--orders {
  --panel-accent: rgb(var(--color-info));
  --panel-accent-soft: rgb(var(--color-info-soft));
  --panel-row-accent: rgb(var(--color-info));
}

.portfolio-tab-panel--history {
  --panel-accent: rgb(var(--color-info));
  --panel-accent-soft: rgb(var(--color-info-soft));
  --panel-row-accent: rgb(var(--color-info));
}

.portfolio-orders-filters {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-bottom: 12px;
}

.portfolio-orders-filters .portfolio-activity-filter {
  margin: 0;
  flex: 1 1 220px;
}

.portfolio-order-type-filter {
  flex: 0 1 180px;
}

.portfolio-activity-filter {
  margin: 0 0 12px;
  padding: 8px 12px;
  border-radius: 12px;
  background: linear-gradient(90deg, color-mix(in srgb, var(--panel-accent) 8%, transparent), transparent);
  border: 1px solid color-mix(in srgb, var(--panel-accent) 14%, rgb(var(--color-line)));
}

.portfolio-tab-panel .molecule-common-filter-btn--active {
  border-color: color-mix(in srgb, var(--panel-accent) 30%, rgb(var(--color-line-strong)));
  background: var(--panel-accent-soft);
  color: rgb(var(--color-ink));
}

.portfolio-tab-panel .molecule-empty-panel {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  min-height: 200px;
  padding: 24px 16px;
  border-radius: 16px;
  background: linear-gradient(180deg, var(--panel-accent-soft), rgb(var(--color-surface-raised)) 70%);
  border: 1px dashed color-mix(in srgb, var(--panel-accent) 22%, rgb(var(--color-line-strong)));
}

.portfolio-tab-panel .molecule-empty-title {
  font-size: 16px;
  font-weight: 700;
}

.portfolio-tab-panel .molecule-loader-wrap {
  min-height: 180px;
}

.portfolio-tab-panel .molecule-table-wrap {
  border-radius: 14px;
  overflow: hidden;
  border: 1px solid rgb(var(--color-line));
}

.portfolio-tab-panel .molecule-table-head {
  background: linear-gradient(180deg, var(--panel-accent-soft), rgb(var(--color-surface-raised)));
}

.portfolio-tab-panel .molecule-table-th {
  padding: 10px 12px;
  font-size: 10px;
  font-weight: 800;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: var(--panel-accent);
  border-bottom: 1px solid color-mix(in srgb, var(--panel-accent) 12%, rgb(var(--color-surface-muted)));
  white-space: nowrap;
}

.portfolio-tab-panel .molecule-table-tr {
  transition: background 0.12s ease, box-shadow 0.12s ease;
}

.portfolio-tab-panel .molecule-table-tr--clickable:hover {
  background: color-mix(in srgb, var(--panel-accent-soft) 55%, rgb(var(--color-surface-raised)));
}

.portfolio-tab-panel .molecule-table-td {
  padding: 12px;
  font-size: 13px;
  border-bottom: 1px solid rgb(var(--color-surface-muted));
  vertical-align: middle;
}

.portfolio-tab-panel .molecule-table-body .molecule-table-tr {
  border-left: 3px solid transparent;
}

.portfolio-tab-panel .molecule-table-body .molecule-table-tr--clickable:hover {
  border-left-color: var(--panel-row-accent);
}

.portfolio-tab-panel .molecule-table-thumbnail {
  width: 44px;
  height: 44px;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgb(var(--color-shadow) / 0.08);
}

.portfolio-tab-panel .molecule-table-td[data-label=Title],
.portfolio-tab-panel .molecule-table-td[data-label="Question Title"] {
  font-weight: 700;
  color: rgb(var(--color-ink));
  max-width: 220px;
}

.portfolio-tab-panel .molecule-table-td[data-label="To Win"] {
  font-weight: 700;
  font-size: 14px;
}

.portfolio-tab-panel .molecule-table-td[data-label="Realized Pnl"] {
  font-weight: 700;
}

.portfolio-tab-panel .molecule-table-td[data-label="Realized Pnl"].positive-pnl {
  font-weight: 700;
  color: rgb(var(--color-success-contrast));
}

.portfolio-tab-panel .molecule-table-td[data-label="Realized Pnl"].negative-pnl {
  font-weight: 700;
  color: rgb(var(--color-danger-contrast));
}

.portfolio-tab-panel .molecule-table-td[data-label=Price] {
  font-weight: 800;
  color: rgb(var(--color-info-contrast));
  font-size: 15px;
}

.portfolio-tab-panel .molecule-table-td[data-label=Side] {
  font-weight: 800;
  font-size: 11px;
  letter-spacing: 0.05em;
  text-transform: uppercase;
}

.portfolio-tab-panel .molecule-table-td[data-label=Outcome] {
  font-weight: 800;
  font-size: 11px;
  letter-spacing: 0.05em;
  text-transform: uppercase;
}

.portfolio-tab-panel--positions .molecule-table-td[data-label="Yes Shares"],
.portfolio-tab-panel--positions .molecule-table-td[data-label="No Shares"] {
  font-weight: 700;
}

.portfolio-tab-panel--history .molecule-table-td[data-label=Description] {
  font-weight: 600;
  line-height: 1.45;
  max-width: 360px;
}

.portfolio-tab-panel .molecule-table-action-btn {
  border-color: rgb(var(--color-danger-soft));
  background: rgb(var(--color-danger-soft));
  color: rgb(var(--color-danger-contrast));
  border-radius: 0.5rem;
  font-weight: 700;
}

.portfolio-tab-panel .molecule-table-action-btn:hover {
  background: rgb(var(--color-danger-soft));
  border-color: rgb(var(--color-danger-soft));
}

.portfolio-tab-panel .molecule-table-pagination {
  padding: 12px 4px 4px;
}

.portfolio-empty-title {
  margin: 0;
  font-size: 15px;
  font-weight: 600;
  color: rgb(var(--color-ink));
}

.portfolio-empty-caption {
  margin: 6px 0 0 0;
  font-size: 13px;
  color: rgb(var(--color-ink-faint));
  line-height: 1.5;
}

.portfolio-chart-empty {
  height: 220px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 0 10px;
}

.wallet-activity-overlay {
  position: fixed;
  inset: 0;
  z-index: 1200;
  background: rgb(var(--color-shadow) / 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
}

.wallet-activity-modal {
  width: min(420px, 100%);
  position: relative;
  border-radius: 14px;
  background: rgb(var(--color-surface-raised));
  border: 1px solid rgb(var(--color-line));
  box-shadow: 0 18px 40px rgb(var(--color-shadow) / 0.18);
  padding: 18px;
}

.wallet-activity-close {
  position: absolute;
  top: 10px;
  right: 10px;
  border: 1px solid rgb(var(--color-line-strong));
  border-radius: 999px;
  width: 28px;
  height: 28px;
  background: rgb(var(--color-surface-raised));
  color: rgb(var(--color-ink-soft));
  cursor: pointer;
  line-height: 1;
  font-size: 14px;
}

.wallet-activity-title {
  margin: 0 0 14px 0;
  color: rgb(var(--color-ink));
  font-size: 20px;
  font-weight: 700;
}

.wallet-activity-form {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.wallet-activity-label {
  font-size: 13px;
  font-weight: 600;
  color: rgb(var(--color-ink-muted));
}

.wallet-activity-input {
  height: 42px;
  border-radius: 10px;
  border: 1px solid rgb(var(--color-line-strong));
  padding: 0 12px;
  font-size: 14px;
  color: rgb(var(--color-ink));
  background: rgb(var(--color-surface-raised));
}

.wallet-activity-input:focus {
  outline: none;
  border-color: rgb(var(--color-ink-faint));
}

.wallet-activity-submit {
  margin-top: 6px;
  height: 42px;
  border: 0;
  border-radius: 0.5rem;
  font-size: 14px;
  font-weight: 700;
  font-family: inherit;
  color: rgb(var(--color-surface-raised));
  background: rgb(var(--color-ink));
  cursor: pointer;
}

.wallet-activity-submit:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

@media (max-width: 992px) {
  .portfolio-page {
    width: min(1200px, calc(100% - 20px));
    margin-top: 16px;
    padding-bottom: 20px;
  }
  .portfolio-summary-title {
    font-size: 20px;
  }
  .portfolio-summary-head {
    flex-direction: column;
    align-items: flex-start;
  }
  .portfolio-metrics-grid {
    grid-template-columns: 1fr;
  }
  .portfolio-metric-value {
    font-size: 20px;
  }
  .portfolio-activity-head {
    flex-direction: column;
    align-items: stretch;
  }
  .portfolio-history-controls {
    width: 100%;
  }
  .portfolio-search-input {
    flex: 1 1;
    min-width: 0;
    width: 100%;
  }
  .portfolio-activity-tabs {
    grid-template-columns: 1fr;
  }
}
@media (max-width: 768px) {
  .portfolio-tab-panel .molecule-table,
  .portfolio-tab-panel .molecule-table-head,
  .portfolio-tab-panel .molecule-table-body,
  .portfolio-tab-panel .molecule-table-tr,
  .portfolio-tab-panel .molecule-table-th,
  .portfolio-tab-panel .molecule-table-td {
    display: block;
    width: 100%;
  }
  .portfolio-tab-panel .molecule-table-head {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border: 0;
  }
  .portfolio-tab-panel .molecule-table-body .molecule-table-tr {
    margin-bottom: 10px;
    padding: 12px;
    border: 1px solid rgb(var(--color-line));
    border-left: 3px solid var(--panel-row-accent);
    border-radius: 14px;
    background: rgb(var(--color-surface-raised));
    box-shadow: 0 4px 14px rgb(var(--color-shadow) / 0.04);
  }
  .portfolio-tab-panel .molecule-table-body .molecule-table-tr--clickable:hover {
    box-shadow: 0 8px 20px rgb(var(--color-shadow) / 0.07);
  }
  .portfolio-tab-panel .molecule-table-td {
    display: grid;
    grid-template-columns: minmax(90px, 38%) 1fr;
    gap: 8px;
    align-items: baseline;
    padding: 7px 0;
    border-bottom: 1px solid rgb(var(--color-surface-overlay));
  }
  .portfolio-tab-panel .molecule-table-td:last-child {
    border-bottom: 0;
  }
  .portfolio-tab-panel .molecule-table-td::before {
    content: attr(data-label);
    font-size: 10px;
    font-weight: 800;
    letter-spacing: 0.05em;
    text-transform: uppercase;
    color: rgb(var(--color-ink-faint));
  }
  .portfolio-tab-panel .molecule-table-td--thumbnail {
    display: flex;
    align-items: center;
    gap: 10px;
    grid-template-columns: 1fr;
    padding-bottom: 10px;
    margin-bottom: 4px;
    border-bottom: 1px solid rgb(var(--color-surface-muted));
  }
  .portfolio-tab-panel .molecule-table-td--thumbnail::before {
    display: none;
  }
  .portfolio-tab-panel .molecule-table-td[data-label=Title],
  .portfolio-tab-panel .molecule-table-td[data-label="Question Title"] {
    max-width: none;
  }
  .portfolio-tab-panel .molecule-table-td:has(.molecule-table-actions) {
    grid-template-columns: 1fr;
    padding-top: 10px;
  }
  .portfolio-tab-panel .molecule-table-td:has(.molecule-table-actions)::before {
    display: none;
  }
}
@media (max-width: 576px) {
  .portfolio-summary-card,
  .portfolio-tabs-card {
    border-radius: 12px;
  }
  .portfolio-summary-card {
    padding: 12px;
  }
  .portfolio-tabs-card {
    padding: 12px;
  }
  .portfolio-activity-title {
    font-size: 18px;
  }
  .portfolio-tab-btn {
    padding: 10px 12px;
  }
  .portfolio-tab-btn-icon {
    width: 30px;
    height: 30px;
    font-size: 13px;
  }
  .portfolio-summary-actions {
    width: 100%;
  }
  .portfolio-action-btn {
    flex: 1 1;
    text-align: center;
  }
  .wallet-activity-overlay {
    align-items: flex-end;
    padding: 0;
  }
  .wallet-activity-modal {
    width: 100%;
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
    padding: 16px;
  }
}

/* Casino embed densify — remaining panel radii */
.prediction-market-page--casino .sub-filter-bar,
.prediction-market-page--casino .sub-filter-item,
.prediction-market-page--casino .market-detail-trade-fab,
.prediction-market-page--casino .how-it-works-panel,
.prediction-market-page--casino .common-popup,
.prediction-market-page--casino .wallet-activity-modal,
.prediction-market-page--casino .portfolio-tabs-card,
.prediction-market-page--casino .notification-bell__dropdown,
.prediction-market-page--casino .market-orders-indicator__dropdown {
  border-radius: var(--pm-radius, 8px);
}

.prediction-market-page--casino .order-panel-outcome-btn,
.prediction-market-page--casino .order-panel-stepper,
.prediction-market-page--casino .order-panel-market-tab-summary,
.prediction-market-page--casino .order-panel-limit-tab-summary,
.prediction-market-page--casino .order-panel-disabled-note {
  border-radius: 0.5rem;
}

.dark .prediction-market-page--casino .header-section {
  background: rgb(var(--color-surface) / 0.96);
}

/* ========== Breaking Markets ========== */
.breaking-markets {
  position: relative;
  isolation: isolate;
  min-height: calc(100vh - var(--pm-header-offset, 140px) - 12px);
  padding: 10px 12px 18px;
  overflow: hidden;
  animation: pm-fade-in-up var(--pm-duration-slow, 0.36s) var(--pm-ease, ease) both;
}

.breaking-markets-bg {
  position: absolute;
  inset: -4%;
  z-index: 0;
  background-color: rgb(var(--color-surface));
  background-image: var(--breaking-bg, none);
  background-size: cover;
  background-position: center;
  filter: blur(16px) saturate(1.25) brightness(0.68);
  transform: scale(1.06);
  opacity: 0.9;
}

.breaking-markets-veil {
  position: absolute;
  inset: 0;
  z-index: 1;
  background:
    radial-gradient(ellipse 65% 50% at 50% 30%, rgb(0 0 0 / 0.22), transparent 70%),
    linear-gradient(180deg, rgb(var(--color-surface) / 0.3) 0%, rgb(var(--color-surface) / 0.55) 50%, rgb(var(--color-surface) / 0.82) 100%);
  pointer-events: none;
}

.breaking-markets--empty {
  display: grid;
  place-items: center;
  min-height: 40vh;
}

.breaking-markets-empty-copy {
  margin: 0;
  font-size: 1rem;
  font-weight: 600;
  color: rgb(var(--color-ink-muted));
}

.breaking-markets-stage {
  position: relative;
  z-index: 2;
  width: min(100%, 1480px);
  margin: 0 auto;
}

.breaking-markets-arrow {
  position: absolute;
  top: 50%;
  z-index: 5;
  display: grid;
  place-items: center;
  width: 48px;
  height: 48px;
  padding: 0;
  border: 1px solid rgb(var(--color-warning, 245 158 11) / 0.55);
  border-radius: 999px;
  background: rgb(var(--color-surface-raised) / 0.95);
  color: rgb(var(--color-warning, 245 158 11));
  font-size: 16px;
  cursor: pointer;
  box-shadow: 0 8px 22px rgb(0 0 0 / 0.2), 0 0 0 4px rgb(var(--color-warning, 245 158 11) / 0.18);
  transform: translateY(-50%);
  transition: transform 0.18s ease, background 0.18s ease;
}

.breaking-markets-arrow--prev { left: 8px; }
.breaking-markets-arrow--next { right: 8px; }

.breaking-markets-arrow:hover,
.breaking-markets-arrow:focus-visible {
  background: rgb(var(--color-warning, 245 158 11));
  color: #111;
  outline: none;
  transform: translateY(-50%) scale(1.06);
}

.breaking-markets-arrow:active {
  transform: translateY(-50%) scale(0.96);
}

.breaking-markets-card {
  position: relative;
  z-index: 3;
  display: flex;
  flex-direction: column;
  min-width: 0;
  margin: 0 56px;
  padding: 14px clamp(12px, 2vw, 20px) 16px;
  border-radius: 18px;
  background: rgb(var(--color-surface-raised) / 0.92);
  border: 1px solid rgb(var(--color-line) / 0.7);
  box-shadow: 0 18px 48px rgb(0 0 0 / 0.22);
  backdrop-filter: blur(12px);
  animation: breaking-card-in 0.34s var(--pm-ease, ease) both;
}

.breaking-markets-card-bg {
  position: absolute;
  inset: 0;
  z-index: 0;
  border-radius: inherit;
  overflow: hidden;
  pointer-events: none;
}

.breaking-markets-card-bg img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  opacity: 0.26;
  filter: blur(2px) saturate(1.05);
  transform: scale(1.04);
}

.breaking-markets-card-bg::after {
  content: '';
  position: absolute;
  inset: 0;
  background: linear-gradient(
    180deg,
    rgb(var(--color-surface-raised) / 0.72) 0%,
    rgb(var(--color-surface-raised) / 0.88) 45%,
    rgb(var(--color-surface-raised) / 0.95) 100%
  );
}

.breaking-markets-card > :not(.breaking-markets-card-bg) {
  position: relative;
  z-index: 1;
}

.breaking-markets-card-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  margin-bottom: 12px;
}

.breaking-markets-card-actions {
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.breaking-markets-badge {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 5px 10px;
  border-radius: 999px;
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: rgb(var(--color-warning, 245 158 11));
  background: rgb(var(--color-warning, 245 158 11) / 0.14);
  border: 1px solid rgb(var(--color-warning, 245 158 11) / 0.4);
}

.breaking-markets-progress {
  display: inline-flex;
  align-items: baseline;
  gap: 2px;
  padding: 4px 10px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 800;
  color: rgb(var(--color-ink));
  background: rgb(var(--color-surface) / 0.7);
  border: 1px solid rgb(var(--color-line));
}

.breaking-markets-progress-sep { opacity: 0.45; margin: 0 1px; }

.breaking-markets-expand {
  display: grid;
  place-items: center;
  width: 36px;
  height: 36px;
  padding: 0;
  border: 1px solid rgb(var(--color-line-strong));
  border-radius: 0.5rem;
  background: rgb(var(--color-surface) / 0.85);
  color: rgb(var(--color-ink));
  cursor: pointer;
  transition: background 0.15s ease, border-color 0.15s ease;
}

.breaking-markets-expand:hover,
.breaking-markets-expand:focus-visible {
  border-color: rgb(var(--color-warning, 245 158 11) / 0.7);
  color: rgb(var(--color-warning, 245 158 11));
  outline: none;
}

.breaking-markets-loader {
  min-height: 280px;
  display: grid;
  place-items: center;
}

.breaking-markets-layout {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(260px, min(380px, 100%));
  gap: clamp(12px, 2vw, 18px);
  align-items: start;
}

.breaking-markets-main {
  min-width: 0;
  max-height: calc(100vh - var(--pm-header-offset, 140px) - 220px);
  overflow-y: auto;
  scrollbar-width: thin;
  padding-right: 4px;
}

.breaking-markets-order-wrap {
  --order-panel-max-h: calc(100vh - var(--pm-header-offset, 140px) - 220px);
  min-width: 0;
  width: 100%;
  max-width: 380px;
  position: sticky;
  top: 0;
  align-self: start;
  max-height: var(--order-panel-max-h);
  display: flex;
  flex-direction: column;
}

.breaking-markets-order-wrap .order-panel {
  position: static;
  max-height: var(--order-panel-max-h);
  height: auto;
  min-height: 0;
  overflow: auto;
}

.market-detail-image--breaking {
  width: 64px;
  height: 64px;
  border-radius: 12px;
}

.breaking-markets-mobile-options {
  list-style: none;
  margin: 4px 0 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 8px;
  max-height: min(52vh, 420px);
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}

.breaking-markets-mobile-option {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  padding: 10px 12px;
  border-radius: 0.5rem;
  background: rgb(var(--color-surface) / 0.7);
  border: 1px solid rgb(var(--color-line));
  color: rgb(var(--color-ink));
  cursor: pointer;
  text-align: left;
  transition: border-color 0.15s ease, background 0.15s ease;
}

.breaking-markets-mobile-option.is-selected {
  border-color: rgb(var(--color-warning, 245 158 11) / 0.85);
  background: rgb(var(--color-warning, 245 158 11) / 0.14);
  box-shadow: 0 0 0 2px rgb(var(--color-warning, 245 158 11) / 0.2);
}

.breaking-markets-mobile-option-thumb {
  width: 40px;
  height: 40px;
  border-radius: 10px;
  object-fit: cover;
  flex-shrink: 0;
}

.breaking-markets-mobile-option-title {
  font-size: 13px;
  font-weight: 700;
  color: rgb(var(--color-ink));
  line-height: 1.3;
}

.breaking-markets-mobile-cta {
  display: grid;
  grid-template-columns: 1fr;
  gap: 8px;
  margin-top: 8px;
  position: sticky;
  bottom: 0;
  padding-top: 8px;
}

.breaking-markets-mobile-trade {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  min-height: 46px;
  padding: 0 16px;
  border-radius: 0.5rem;
  font-size: 14px;
  font-weight: 800;
  cursor: pointer;
  border: 0;
  background: rgb(var(--color-warning, 245 158 11));
  color: #111;
}

.breaking-markets-mobile-trade:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

.breaking-markets--mobile {
  min-height: auto;
  overflow: visible;
  padding: 12px 12px 28px;
  background: transparent;
}

.breaking-mobile {
  position: relative;
  z-index: 2;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.breaking-mobile-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
}

.breaking-mobile-back {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  border: 1px solid rgb(var(--color-line));
  border-radius: 0.5rem;
  background: rgb(var(--color-surface-raised) / 0.95);
  color: rgb(var(--color-ink));
  font-size: 13px;
  font-weight: 700;
  cursor: pointer;
}

.breaking-mobile-markets {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.breaking-mobile-market-card {
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
  padding: 12px;
  border: 1px solid rgb(var(--color-line));
  border-radius: 16px;
  background: rgb(var(--color-surface-raised) / 0.96);
  color: rgb(var(--color-ink));
  text-align: left;
  cursor: pointer;
  box-shadow: 0 6px 18px rgb(0 0 0 / 0.08);
}

.breaking-mobile-market-card img {
  width: 56px;
  height: 56px;
  border-radius: 12px;
  object-fit: cover;
  flex-shrink: 0;
}

.breaking-mobile-market-body {
  display: flex;
  flex-direction: column;
  gap: 3px;
  min-width: 0;
  flex: 1 1;
}

.breaking-mobile-market-category {
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: rgb(var(--color-ink-muted));
}

.breaking-mobile-market-title {
  font-size: 14px;
  font-weight: 800;
  line-height: 1.3;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.breaking-mobile-market-vol {
  font-size: 12px;
  font-weight: 600;
  color: rgb(var(--color-ink-muted));
}

.breaking-mobile-market-chevron {
  color: rgb(var(--color-ink-faint));
  flex-shrink: 0;
}

.breaking-mobile-selected {
  display: flex;
  align-items: flex-start;
  gap: 12px;
}

.breaking-mobile-selected-thumb {
  width: 56px;
  height: 56px;
  border-radius: 12px;
  object-fit: cover;
  flex-shrink: 0;
  border: 1px solid rgb(var(--color-line));
}

.breaking-mobile-options-label {
  margin: 4px 0 0;
  font-size: 12px;
  font-weight: 800;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: rgb(var(--color-ink-muted));
}

.breaking-markets-bottom {
  position: relative;
  z-index: 2;
  width: min(100%, 1480px);
  margin: 14px auto 0;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.breaking-markets-dots {
  display: flex;
  justify-content: center;
  gap: 7px;
}

.breaking-markets-dots button {
  width: 8px;
  height: 8px;
  padding: 0;
  border: 0;
  border-radius: 999px;
  background: rgb(var(--color-line-strong));
  cursor: pointer;
  transition: width 0.2s ease, background 0.2s ease;
}

.breaking-markets-dots button.is-active {
  width: 24px;
  background: rgb(var(--color-warning, 245 158 11));
}

.breaking-markets-rail {
  list-style: none;
  margin: 0;
  padding: 2px 2px 6px;
  display: flex;
  gap: 10px;
  overflow-x: auto;
  scrollbar-width: thin;
  scroll-snap-type: x mandatory;
  -webkit-overflow-scrolling: touch;
}

.breaking-markets-rail-card {
  display: flex;
  align-items: center;
  gap: 10px;
  width: min(240px, 72vw);
  padding: 8px;
  border: 1px solid rgb(var(--color-line));
  border-radius: 14px;
  background: rgb(var(--color-surface-raised) / 0.92);
  color: rgb(var(--color-ink));
  cursor: pointer;
  text-align: left;
  scroll-snap-align: start;
  transition: border-color 0.18s ease, transform 0.18s ease;
}

.breaking-markets-rail-card img {
  width: 44px;
  height: 44px;
  border-radius: 10px;
  object-fit: cover;
  flex-shrink: 0;
}

.breaking-markets-rail-title {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  font-size: 12px;
  font-weight: 700;
  line-height: 1.3;
}

.breaking-markets-rail-card.is-active {
  border-color: rgb(var(--color-warning, 245 158 11) / 0.8);
  box-shadow: 0 0 0 2px rgb(var(--color-warning, 245 158 11) / 0.2);
}

.breaking-markets-rail-card:hover,
.breaking-markets-rail-card:focus-visible {
  transform: translateY(-1px);
  border-color: rgb(var(--color-warning, 245 158 11) / 0.65);
  outline: none;
}

@keyframes breaking-card-in {
  from {
    opacity: 0;
    transform: translateY(10px) scale(0.985);
  }
  to {
    opacity: 1;
    transform: none;
  }
}

/* My Position tab */
.order-panel-my-position {
  flex-shrink: 0;
  margin-top: auto;
  border-top: 1px solid rgb(var(--color-line));
  padding: 12px 14px 14px;
  background: linear-gradient(180deg, rgb(var(--color-surface-overlay)) 0%, rgb(var(--color-surface-muted)) 100%);
  border-radius: 0 0 15px 15px;
}

.order-panel-my-position-pnl {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 12px;
  margin-top: 10px;
  padding: 8px 10px;
  border-radius: 10px;
  border: 1px solid rgb(var(--color-line));
  background: rgb(var(--color-surface-raised));
}

.order-panel-my-position-pnl-label {
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: rgb(var(--color-ink-faint));
}

.order-panel-my-position-pnl-value {
  font-size: 15px;
  font-weight: 700;
  font-variant-numeric: tabular-nums;
  color: rgb(var(--color-ink));
  line-height: 1.2;
}

.order-panel-my-position-table-wrap {
  width: 100%;
  min-width: 0;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none;
}

.order-panel-my-position-table-wrap::-webkit-scrollbar {
  height: 0;
}

.order-panel-my-position-table {
  width: 100%;
  min-width: 240px;
  border-collapse: collapse;
  table-layout: fixed;
  font-size: 12px;
}

.order-panel-my-position-th {
  padding: 0 6px 8px 6px;
  text-align: right;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.03em;
  text-transform: uppercase;
  color: rgb(var(--color-ink-faint));
  border-bottom: 1px solid rgb(var(--color-line));
  vertical-align: bottom;
}

.order-panel-my-position-th--metric {
  width: 42%;
  text-align: left;
  padding-left: 0;
  text-transform: none;
  font-size: 11px;
  letter-spacing: 0.01em;
}

.order-panel-my-position-th--yes,
.order-panel-my-position-th--no {
  width: 29%;
}

.order-panel-my-position-th--yes {
  color: rgb(var(--color-success));
}

.order-panel-my-position-th--no {
  color: rgb(var(--color-danger));
}

.order-panel-my-position-metric {
  padding: 8px 8px 8px 0;
  text-align: left;
  font-size: 11px;
  font-weight: 700;
  color: rgb(var(--color-ink-soft));
  border-bottom: 1px solid rgb(var(--color-surface-muted));
  vertical-align: middle;
}

.order-panel-my-position-table td {
  padding: 8px 6px;
  text-align: right;
  font-weight: 600;
  font-variant-numeric: tabular-nums;
  color: rgb(var(--color-ink));
  border-bottom: 1px solid rgb(var(--color-surface-muted));
}

.order-panel-my-position-table tbody tr:last-child th,
.order-panel-my-position-table tbody tr:last-child td {
  border-bottom: none;
  padding-bottom: 2px;
}

.order-panel-my-position-sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}

.option-my-position {
  display: flex;
  flex-direction: column;
  gap: 0;
}

.option-my-position-section-title {
  margin: 0 0 10px;
  font-size: 14px;
  font-weight: 700;
  color: rgb(var(--color-ink));
}

.option-my-position-summary {
  border: 1px solid rgb(var(--color-line));
  border-radius: 12px;
  padding: 14px;
  background: rgb(var(--color-surface-raised));
}

.option-my-position-loading {
  margin: 0;
  color: rgb(var(--color-ink-faint));
  font-size: 13px;
}

.option-my-position-orders-panel {
  margin-top: 16px;
  padding: 14px;
  border: 1px solid rgb(var(--color-line));
  border-radius: 12px;
  background: rgb(var(--color-surface));
  box-shadow: 0 1px 0 rgb(var(--color-line) / 0.6);
  --panel-accent: rgb(var(--color-accent));
  --panel-accent-soft: rgb(var(--color-accent-soft));
  --panel-row-accent: rgb(var(--color-accent));
}

.option-my-position-orders-title {
  margin: 0 0 12px;
  padding-bottom: 10px;
  font-size: 14px;
  font-weight: 700;
  color: rgb(var(--color-ink));
  border-bottom: 1px solid rgb(var(--color-line));
}

.option-my-position-orders-filters {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 12px;
}

.option-my-position-orders-filters .portfolio-activity-filter {
  margin: 0;
  flex: 1 1 180px;
  min-width: 0;
}

.option-my-position-orders-panel .portfolio-activity-filter {
  padding: 8px 10px;
  border-radius: 12px;
  background: linear-gradient(90deg, color-mix(in srgb, var(--panel-accent) 8%, transparent), transparent);
  border: 1px solid color-mix(in srgb, var(--panel-accent) 14%, rgb(var(--color-line)));
}

.option-my-position-orders-panel .molecule-common-filter-btn--active {
  border-color: color-mix(in srgb, var(--panel-accent) 30%, rgb(var(--color-line-strong)));
  background: var(--panel-accent-soft);
  color: rgb(var(--color-ink));
}

.option-my-position-orders-panel .molecule-table-wrap {
  border: 1px solid rgb(var(--color-line));
  border-radius: 12px;
  background: rgb(var(--color-surface-raised));
  overflow: auto;
}

.option-my-position-orders-panel .molecule-table-th {
  font-size: 11px;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: rgb(var(--color-ink-faint));
  white-space: nowrap;
}

.option-my-position-orders-panel .molecule-table-td {
  font-size: 13px;
  white-space: nowrap;
}

.option-my-position-orders-panel .molecule-table-tr--clickable:hover {
  background: rgb(var(--color-surface-overlay));
}

.option-my-position-orders-panel .molecule-table-action-btn {
  font-size: 12px;
  padding: 5px 10px;
}

.option-my-position-orders-panel .molecule-empty-panel {
  min-height: 160px;
  padding: 20px 16px;
  border-radius: 12px;
  background: linear-gradient(180deg, var(--panel-accent-soft), rgb(var(--color-surface-raised)) 70%);
}

@media (max-width: 768px) {
  .option-my-position-orders-filters .portfolio-activity-filter {
    flex: 1 1 100%;
  }

  .option-my-position-orders-panel .molecule-table,
  .option-my-position-orders-panel .molecule-table-head,
  .option-my-position-orders-panel .molecule-table-body,
  .option-my-position-orders-panel .molecule-table-tr,
  .option-my-position-orders-panel .molecule-table-th,
  .option-my-position-orders-panel .molecule-table-td {
    display: block;
    width: 100%;
  }

  .option-my-position-orders-panel .molecule-table-head {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border: 0;
  }

  .option-my-position-orders-panel .molecule-table-body .molecule-table-tr {
    margin-bottom: 10px;
    padding: 12px;
    border: 1px solid rgb(var(--color-line));
    border-left: 3px solid var(--panel-row-accent);
    border-radius: 14px;
    background: rgb(var(--color-surface-raised));
    box-shadow: 0 4px 14px rgb(var(--color-shadow) / 0.04);
  }

  .option-my-position-orders-panel .molecule-table-td {
    display: grid;
    grid-template-columns: minmax(90px, 38%) 1fr;
    gap: 8px;
    align-items: baseline;
    padding: 7px 0;
    border-bottom: 1px solid rgb(var(--color-surface-overlay));
    white-space: normal;
  }

  .option-my-position-orders-panel .molecule-table-td:last-child {
    border-bottom: 0;
  }

  .option-my-position-orders-panel .molecule-table-td::before {
    content: attr(data-label);
    font-size: 10px;
    font-weight: 800;
    letter-spacing: 0.05em;
    text-transform: uppercase;
    color: rgb(var(--color-ink-faint));
  }

  .option-my-position-orders-panel .molecule-table-td:has(.molecule-table-actions) {
    grid-template-columns: 1fr;
    padding-top: 10px;
  }

  .option-my-position-orders-panel .molecule-table-td:has(.molecule-table-actions)::before {
    display: none;
  }

  .option-my-position-orders-panel .molecule-table-pagination {
    padding: 10px 4px 4px;
  }
}

@media (max-width: 640px) {
  .option-my-position-summary {
    padding: 12px;
    border-radius: 10px;
  }

  .option-my-position-orders-panel {
    margin-top: 12px;
    padding: 12px;
    border-radius: 10px;
  }

  .option-my-position-section-title,
  .option-my-position-orders-title {
    font-size: 13px;
  }

  .option-my-position-orders-filters {
    gap: 6px;
  }

  .option-my-position-orders-filters .molecule-common-filter-btn {
    flex: 1 1 auto;
    font-size: 12px;
    padding: 6px 10px;
  }
}

@media (max-width: 480px) {
  .order-panel-my-position {
    padding: 10px 12px 12px;
  }

  .order-panel-my-position-pnl {
    padding: 7px 9px;
    margin-top: 8px;
  }

  .order-panel-my-position-pnl-value {
    font-size: 14px;
  }

  .order-panel-my-position-table {
    font-size: 11px;
  }

  .order-panel-my-position-th {
    font-size: 9px;
    padding: 0 4px 5px 4px;
  }

  .order-panel-my-position-metric,
  .order-panel-my-position-table td {
    padding: 7px 4px;
  }
}


/* === Demo mode (ported from B2B) === */

.header-section .is-demo-disabled,
.is-demo-disabled {
  opacity: 0.55;
  pointer-events: none;
  cursor: default;
}
.header-section .is-demo-disabled button:disabled,
.is-demo-disabled button:disabled {
  cursor: default;
}


.manage-market {
  position: relative;
  flex-shrink: 0;
}

.manage-market__trigger {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.45rem;
  min-height: 2rem;
  padding: 0 0.75rem;
  border: 1px solid rgb(var(--color-line-strong));
  border-radius: var(--pm-radius-sm, 6px);
  background: linear-gradient(
    180deg,
    rgb(var(--color-surface-raised)) 0%,
    rgb(var(--color-surface-muted) / 0.65) 100%
  );
  color: rgb(var(--color-ink-soft));
  font-family: inherit;
  font-size: 0.72rem;
  font-weight: 700;
  letter-spacing: 0.03em;
  text-transform: uppercase;
  white-space: nowrap;
  cursor: pointer;
  appearance: none;
  box-shadow: inset 0 1px 0 rgb(var(--pm-gold) / 0.08);
  transition:
    background 0.15s ease,
    border-color 0.15s ease,
    color 0.15s ease,
    box-shadow 0.15s ease;
}

.manage-market__trigger i {
  font-size: 0.72rem;
  line-height: 1;
}

.manage-market__trigger:hover {
  background: rgb(var(--color-surface-muted));
  border-color: rgb(var(--color-line-strong));
  color: rgb(var(--color-ink));
}

.manage-market__trigger--active {
  background: rgb(var(--color-info-soft));
  border-color: rgb(var(--color-info));
  color: rgb(var(--color-info-contrast));
  box-shadow: inset 0 0 0 1px rgb(var(--color-info) / 0.18);
}

.manage-market__chevron {
  opacity: 0.75;
  font-size: 0.62rem !important;
}

.manage-market__overlay {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 900;
  display: flex;
  flex-direction: column;
  min-height: 0;
  background:
    linear-gradient(
      180deg,
      rgb(var(--color-surface) / 0.88) 0%,
      rgb(var(--color-surface) / 0.72) 42%,
      rgb(var(--color-surface) / 0.66) 100%
    );
  backdrop-filter: blur(12px) saturate(1.2);
  -webkit-backdrop-filter: blur(12px) saturate(1.2);
  color: rgb(var(--color-ink));
  border: 0;
  box-shadow: none;
  border-radius: 0;
  animation: news-overlay-enter 0.34s var(--pm-ease) both;
  overflow: hidden;
  cursor: pointer;
}

.manage-market__overlay-body {
  flex: 1 1 auto;
  min-height: 0;
  overflow-x: hidden;
  overflow-y: auto;
  overscroll-behavior: contain;
  padding: 18px 20px 36px;
  padding-right: 56px;
  -webkit-overflow-scrolling: touch;
  width: 100%;
  max-width: 900px;
  margin: 0 auto;
  box-sizing: border-box;
  position: relative;
  z-index: 1;
  cursor: default;
}

.manage-market__overlay .manage-market__header {
  margin: 0 0 18px;
  padding: 0 0 14px;
  border-bottom: 1px solid rgb(var(--color-line) / 0.85);
  background: transparent;
}

.manage-market__overlay .manage-market__title {
  font-size: 1.05rem;
  letter-spacing: -0.01em;
}

.manage-market__overlay .manage-market__subtitle {
  font-size: 0.82rem;
}

.manage-market__close--overlay {
  position: absolute;
  top: 12px;
  right: 16px;
  z-index: 2;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.manage-market__header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 0.75rem;
  padding: 0.9rem 1rem;
  border-bottom: 1px solid rgb(var(--color-line));
  background: rgb(var(--color-surface-overlay));
}

.manage-market__title {
  margin: 0;
  font-size: 0.9rem;
  font-weight: 700;
  line-height: 1.25;
  color: rgb(var(--color-ink));
}

.manage-market__subtitle {
  margin: 0.25rem 0 0;
  font-size: 0.75rem;
  line-height: 1.45;
  color: rgb(var(--color-ink-faint));
}

.manage-market__close {
  flex-shrink: 0;
  width: 2rem;
  height: 2rem;
  border: 1px solid rgb(var(--color-line-strong));
  border-radius: var(--pm-radius-sm, 6px);
  background: rgb(var(--color-surface-raised));
  color: rgb(var(--color-ink-soft));
  cursor: pointer;
  appearance: none;
  transition: background 0.15s ease, color 0.15s ease;
}

.manage-market__close:hover {
  background: rgb(var(--color-surface-muted));
  color: rgb(var(--color-ink));
}

.manage-market__body {
  overflow-y: auto;
  padding: 0.85rem 1rem 1.25rem;
  scrollbar-width: thin;
  scrollbar-color: rgb(var(--color-line-strong)) transparent;
}

.manage-market__overlay .manage-market__body {
  overflow: visible;
  padding: 0;
}

.manage-market__overlay .manage-market__steps {
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 1rem;
}

.manage-market__steps {
  display: grid;
  gap: 0.75rem;
}

.manage-market__step {
  padding: 0.85rem;
  border: 1px solid rgb(var(--color-line));
  border-radius: 10px;
  background: rgb(var(--color-surface-overlay));
}

.manage-market__step--locked {
  opacity: 0.72;
}

.manage-market__step-head {
  display: flex;
  align-items: flex-start;
  gap: 0.65rem;
  margin-bottom: 0.55rem;
}

.manage-market__step-badge {
  flex-shrink: 0;
  width: 1.5rem;
  height: 1.5rem;
  border-radius: 999px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: rgb(var(--color-info-soft));
  color: rgb(var(--color-info-contrast));
  font-size: 0.72rem;
  font-weight: 800;
}

.manage-market__step-meta {
  min-width: 0;
  flex: 1 1;
}

.manage-market__step-title {
  margin: 0;
  font-size: 0.82rem;
  font-weight: 700;
  color: rgb(var(--color-ink));
}

.manage-market__step-status {
  display: inline-block;
  margin-top: 0.15rem;
  font-size: 0.68rem;
  font-weight: 700;
  letter-spacing: 0.03em;
  text-transform: uppercase;
  color: rgb(var(--color-ink-faint));
}

.manage-market__step-status--done {
  color: rgb(var(--color-success-contrast));
}

.manage-market__step-copy {
  margin: 0 0 0.75rem;
  font-size: 0.75rem;
  line-height: 1.45;
  color: rgb(var(--color-ink-soft));
}

.manage-market__field-label {
  margin-bottom: 0.45rem;
}

.manage-market__outcome {
  margin-bottom: 0.75rem;
}

.manage-market__action {
  margin-top: 0;
}

.manage-market__sheet {
  position: fixed;
  inset: 0;
  z-index: 1250;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
}

.manage-market__sheet-backdrop {
  position: absolute;
  inset: 0;
  border: none;
  padding: 0;
  background: rgb(var(--color-ink) / 0.5);
  backdrop-filter: blur(4px);
  -webkit-backdrop-filter: blur(4px);
  cursor: pointer;
  animation: pm-fade-in var(--pm-duration-fast, 0.18s) var(--pm-ease, ease) both;
}

.manage-market__sheet-content {
  position: relative;
  z-index: 1;
  width: 100%;
  max-height: min(88dvh, 720px);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  border-top-left-radius: 16px;
  border-top-right-radius: 16px;
  border: 1px solid rgb(var(--color-line-strong));
  border-bottom: none;
  background: linear-gradient(
    180deg,
    rgb(var(--color-surface-raised)) 0%,
    rgb(var(--color-surface-muted) / 0.82) 100%
  );
  box-shadow: 0 -8px 32px rgb(var(--color-shadow) / 0.18);
  animation: pm-sheet-slide-up var(--pm-duration, 0.28s) var(--pm-ease, ease) both;
}

@media (max-width: 992px) {
  .manage-market__trigger {
    min-height: 2.25rem;
    padding: 0 0.65rem;
    font-size: 0.68rem;
  }
}

@media (max-width: 860px) {
  .manage-market__overlay .manage-market__steps {
    grid-template-columns: 1fr;
  }
}


.demo-walkthrough {
  position: fixed;
  inset: 0;
  z-index: 1260;
  pointer-events: none;
}

.demo-walkthrough__shade {
  position: absolute;
  inset: 0;
  pointer-events: none;
}

.demo-walkthrough__hole {
  position: absolute;
  border-radius: 14px;
  box-shadow: 0 0 0 9999px rgb(var(--color-shadow) / 0.55);
  outline: 2px solid rgb(var(--color-info, 0 149 255) / 0.85);
  transition:
    top 0.22s ease,
    left 0.22s ease,
    width 0.22s ease,
    height 0.22s ease,
    opacity 0.18s ease;
  pointer-events: none;
}

.demo-walkthrough__tip {
  position: fixed;
  z-index: 1;
  width: min(340px, calc(100vw - 24px));
  padding: 14px 14px 12px;
  border: 1px solid rgb(var(--color-line-strong));
  border-radius: 16px;
  background: rgb(var(--color-surface-raised));
  box-shadow: 0 18px 40px rgb(var(--color-shadow) / 0.28);
  color: rgb(var(--color-ink));
  pointer-events: auto;
  animation: demo-walkthrough-tip-in 0.22s ease;
  box-sizing: border-box;
}

.demo-walkthrough__tip-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  margin-bottom: 8px;
}

.demo-walkthrough__progress {
  font-size: 0.7rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: rgb(var(--color-ink-muted));
}

.demo-walkthrough__icon-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border: none;
  border-radius: 999px;
  background: rgb(var(--color-surface-muted) / 0.9);
  color: rgb(var(--color-ink-muted));
  cursor: pointer;
  flex-shrink: 0;
}

.demo-walkthrough__icon-btn:hover {
  color: rgb(var(--color-ink));
  background: rgb(var(--color-surface-overlay));
}

.demo-walkthrough__title {
  margin: 0;
  font-size: 1.05rem;
  font-weight: 750;
  line-height: 1.25;
  letter-spacing: -0.01em;
}

.demo-walkthrough__body {
  margin: 8px 0 0;
  font-size: 0.9rem;
  line-height: 1.45;
  color: rgb(var(--color-ink-soft));
}

.demo-walkthrough__hint {
  margin: 8px 0 0;
  padding: 8px 10px;
  border-radius: 10px;
  background: rgb(var(--color-info-soft, 219 234 254) / 0.55);
  font-size: 0.78rem;
  line-height: 1.4;
  color: rgb(var(--color-ink-muted));
}

.demo-walkthrough__waiting {
  margin: 10px 0 0;
  font-size: 0.78rem;
  font-weight: 700;
  line-height: 1.35;
  color: rgb(var(--color-warning, 245 158 11));
}

.demo-walkthrough__btn:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

.demo-walkthrough__actions {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  margin-top: 14px;
}

.demo-walkthrough__actions-end {
  display: flex;
  align-items: center;
  gap: 6px;
  flex-wrap: wrap;
  justify-content: flex-end;
}

.demo-walkthrough__btn {
  min-height: 34px;
  padding: 0 12px;
  border: 1px solid transparent;
  border-radius: 10px;
  font-family: inherit;
  font-size: 0.82rem;
  font-weight: 700;
  cursor: pointer;
}

.demo-walkthrough__btn--ghost {
  background: transparent;
  border-color: transparent;
  color: rgb(var(--color-ink-muted));
}

.demo-walkthrough__btn--ghost:hover {
  color: rgb(var(--color-ink));
}

.demo-walkthrough__btn--secondary {
  background: rgb(var(--color-surface-muted));
  border-color: rgb(var(--color-line));
  color: rgb(var(--color-ink-soft));
}

.demo-walkthrough__btn--primary {
  background: #0095ff;
  color: #fff;
}

.demo-walkthrough__btn--primary:hover {
  opacity: 0.94;
}

.demo-walkthrough-launcher {
  position: fixed;
  left: 16px;
  bottom: 24px;
  z-index: 1260;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  min-height: 40px;
  padding: 0 14px;
  border: 1px solid rgb(var(--color-line-strong));
  border-radius: 999px;
  background: rgb(var(--color-surface-raised));
  color: rgb(var(--color-ink));
  box-shadow: 0 10px 24px rgb(var(--color-shadow) / 0.2);
  font-family: inherit;
  font-size: 0.82rem;
  font-weight: 700;
  cursor: pointer;
}

.demo-walkthrough-launcher:hover {
  border-color: rgb(var(--color-info, 0 149 255) / 0.55);
}

@media (max-width: 992px) {
  .demo-walkthrough__tip {
    width: auto;
    max-width: none;
    padding: 12px 12px 10px;
    border-radius: 14px;
    overflow: auto;
    -webkit-overflow-scrolling: touch;
    box-shadow: 0 12px 32px rgb(var(--color-shadow) / 0.32);
  }

  .demo-walkthrough__tip--dock-top {
    transform: none;
  }

  .demo-walkthrough__tip--dock-bottom {
    transform: none;
  }

  .demo-walkthrough__title {
    font-size: 0.98rem;
  }

  .demo-walkthrough__body {
    font-size: 0.84rem;
    line-height: 1.4;
  }

  .demo-walkthrough__hint {
    font-size: 0.74rem;
    padding: 7px 9px;
  }

  .demo-walkthrough__actions {
    margin-top: 12px;
    gap: 6px;
    flex-wrap: wrap;
  }

  .demo-walkthrough__btn {
    min-height: 36px;
    padding: 0 11px;
    font-size: 0.8rem;
  }

  .demo-walkthrough__hole {
    border-radius: 12px;
    /* Keep hole transitions snappy so scroll/sheet open stays aligned */
    transition:
      top 0.12s ease,
      left 0.12s ease,
      width 0.12s ease,
      height 0.12s ease,
      opacity 0.12s ease;
  }

  .demo-walkthrough-launcher {
    left: max(12px, env(safe-area-inset-left, 0px));
    bottom: calc(88px + env(safe-area-inset-bottom, 0px));
  }
}

@media (max-width: 480px) {
  .demo-walkthrough__actions {
    flex-direction: column;
    align-items: stretch;
  }

  .demo-walkthrough__actions-end {
    width: 100%;
    display: grid;
    grid-template-columns: 1fr 1fr;
  }

  .demo-walkthrough__btn--ghost {
    order: 1;
    width: 100%;
    min-height: 32px;
  }

  .demo-walkthrough__btn--primary {
    grid-column: 2;
  }

  .demo-walkthrough__actions-end .demo-walkthrough__btn--secondary:only-child,
  .demo-walkthrough__actions-end .demo-walkthrough__btn--primary:only-child {
    grid-column: 1 / -1;
  }
}

`, "",{"version":3,"sources":["webpack://./src/styles/prediction-market.css"],"names":[],"mappings":"AAAA,0DAA0D;;AAE1D,0DAA0D;AAC1D;kFACkF;AAClF;EACE,uCAAuC;EACvC,kDAAkD;EAClD,gCAAgC;EAChC,yBAAyB;EACzB,yBAAyB;EACzB,oBAAoB;EACpB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,0DAA0D;EAC1D,eAAe;AACjB;;AAEA;EACE;IACE,UAAU;IACV,0BAA0B;EAC5B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,OAAO,UAAU,EAAE;EACnB,KAAK,UAAU,EAAE;AACnB;;AAEA;EACE;IACE,UAAU;IACV,sBAAsB;EACxB;EACA;IACE,UAAU;IACV,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,UAAU;IACV,aAAa;IACb,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,kBAAkB;IAClB,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,yBAAyB;IACzB,sBAAsB;EACxB;AACF;;AAEA;EACE;IACE,yBAAyB;IACzB,sBAAsB;EACxB;AACF;;AAEA;EACE;;;;;;;;;;;;IAYE,0BAA0B;EAC5B;AACF;;AAEA,kEAAkE;AAClE;EACE,cAAc;EACd,4BAA4B;EAC5B,WAAW;EACX,OAAO;EACP,MAAM;EACN,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,mBAAmB;EACnB,4CAA4C;EAC5C,yCAAyC;EACzC,iDAAiD;EACjD,SAAS;EACT,0EAA0E;EAC1E,qDAAqD;EACrD,8CAA8C;AAChD;AACA;EACE,aAAa;AACf;AACA;EACE,4BAA4B;EAC5B,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,0BAA0B;AAC5B;AACA;EACE,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,uDAAuD;AACzD;AACA;EACE,WAAW;EACX,WAAW;EACX,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,8BAA8B;AAChC;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,WAAW;EACX,iBAAiB;AACnB;AACA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,UAAU;EACV,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,+CAA+C;EAC/C,uCAAuC;EACvC,4CAA4C;EAC5C,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,6DAA6D;AAC/D;AACA;EACE,2CAA2C;EAC3C,4BAA4B;EAC5B,wCAAwC;AAC1C;AACA;EACE,+CAA+C;EAC/C,uCAAuC;EACvC,aAAa;EACb,oBAAoB;EACpB,WAAW;EACX,gBAAgB;EAChB;;;;GAIC;EACD,oDAAoD;AACtD;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,cAAc;EACd,2CAA2C;AAC7C;AACA;EACE,SAAO;EACP,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,iCAAiC;EACjC,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,yCAAyC;EACzC,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,iCAAiC;EACjC,eAAe;AACjB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,iBAAiB;EACjB,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;AACzB;AACA;EACE,kCAAkC;EAClC,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;AACA;;EAEE,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,WAAW;EACX,YAAY;AACd;AACA;EACE,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,kCAAkC;EAClC,0BAA0B;EAC1B,kBAAkB;AACpB;AACA;EACE,kCAAkC;EAClC,gBAAgB;AAClB;AACA;EACE,mDAAmD;AACrD;AACA;EACE,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,kCAAkC;EAClC,0BAA0B;AAC5B;AACA;EACE,aAAa;EACb,gBAAgB;AAClB;AACA;EACE;IACE,8BAA8B;EAChC;EACA;IACE,WAAW;IACX,cAAc;IACd,yBAAyB;EAC3B;EACA;IACE,2BAA2B;EAC7B;AACF;AACA;EACE;IACE,8BAA8B;EAChC;EACA;IACE,kBAAkB;EACpB;EACA;IACE,aAAa;EACf;EACA;IACE,YAAY;IACZ,WAAW;IACX,cAAc;EAChB;EACA;IACE,cAAc;IACd,YAAY;EACd;AACF;AACA;EACE;IACE,iBAAiB;IACjB,kBAAkB;EACpB;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;IACX,mBAAmB;EACrB;EACA;IACE,qBAAqB;IACrB,WAAW;EACb;EACA;IACE,iBAAiB;IACjB,YAAY;IACZ,kBAAkB;EACpB;EACA;IACE,WAAW;EACb;AACF;AACA;EACE,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,WAAW;EACX,YAAY;EACZ,6BAA6B;EAC7B,uCAAuC;EACvC,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,UAAU;AACZ;AACA;EACE,0CAA0C;EAC1C,uCAAuC;EACvC,yCAAyC;AAC3C;AACA;EACE,0DAA0D;AAC5D;AACA;EACE,0CAA0C;EAC1C,uCAAuC;EACvC,yCAAyC;AAC3C;AACA;EACE,eAAe;EACf,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,QAAQ;EACR,qCAAqC;EACrC,wBAAwB;EACxB,mBAAmB;EACnB,4CAA4C;EAC5C,+CAA+C;EAC/C,uDAAuD;EACvD,4BAA4B;EAC5B,yCAAyC;EACzC,iBAAiB;EACjB,gBAAgB;EAChB,UAAU;EACV,kBAAkB;EAClB,gBAAgB;EAChB,4EAA4E;EAC5E,oBAAoB;EACpB,aAAa;AACf;AACA;;EAEE,UAAU;EACV,mBAAmB;EACnB,aAAa;EACb,oBAAoB;AACtB;AACA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,yCAAyC;AAC3C;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,iCAAiC;EACjC,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,SAAS;EACT,kCAAkC;EAClC,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE;IACE,yBAAyB;EAC3B;AACF;AACA;EACE,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,+CAA+C;EAC/C,uCAAuC;EACvC,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,4CAA4C;EAC5C,iCAAiC;EACjC,gBAAgB;EAChB,gBAAgB;EAChB,UAAU;EACV,6DAA6D;AAC/D;AACA;EACE,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,2CAA2C;EAC3C,2CAA2C;EAC3C,4BAA4B;AAC9B;AACA;EACE,uCAAuC;EACvC,oCAAoC;EACpC,sCAAsC;AACxC;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,oBAAoB;EACpB,oCAAoC;EACpC,uCAAuC;EACvC,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,2CAA2C;AAC7C;AACA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,QAAQ;EACR,qCAAqC;EACrC,0CAA0C;EAC1C,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,4CAA4C;EAC5C,+CAA+C;EAC/C,uDAAuD;EACvD,aAAa;EACb,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;EACX,qBAAqB;EACrB,+CAA+C;EAC/C,6CAA6C;AAC/C;AACA;EACE,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,4BAA4B;AAC9B;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,kCAAkC;EAClC,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,0CAA0C;AAC5C;AACA;EACE,SAAS;EACT,qBAAqB;EACrB,kCAAkC;EAClC,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,WAAW;EACX,oBAAoB;EACpB,YAAY;EACZ,wDAAwD;EACxD,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;EACf,4BAA4B;AAC9B;AACA;EACE,6CAA6C;AAC/C;AACA;EACE,uCAAuC;AACzC;AACA;EACE,uCAAuC;AACzC;AACA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;AACnB;AACA;EACE,uCAAuC;EACvC,sCAAsC;AACxC;AACA;EACE,0CAA0C;EAC1C,yCAAyC;AAC3C;AACA;EACE,0CAA0C;EAC1C,yCAAyC;AAC3C;AACA;EACE,uCAAuC;EACvC,sCAAsC;AACxC;AACA;EACE,0CAA0C;EAC1C,yCAAyC;AAC3C;AACA;EACE,0CAA0C;EAC1C,yCAAyC;AAC3C;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,YAAY;AACd;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,4BAA4B;EAC5B,uBAAuB;AACzB;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,kCAAkC;EAClC,uBAAuB;AACzB;AACA;EACE,kBAAkB;EAClB,iCAAiC;EACjC,iBAAiB;EACjB,uBAAuB;AACzB;AACA;EACE,kBAAkB;EAClB,kCAAkC;EAClC,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE;IACE,eAAe;IACf,SAAS;IACT,UAAU;IACV,WAAW;IACX,WAAW;EACb;EACA;IACE,gBAAgB;IAChB,MAAM;IACN,kBAAkB;EACpB;EACA;IACE,aAAa;EACf;EACA;IACE,kBAAkB;IAClB,iBAAiB;EACnB;EACA;IACE,mBAAmB;IACnB,gBAAgB;EAClB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,eAAe;IACf,SAAS;IACT,UAAU;IACV,WAAW;IACX,WAAW;EACb;AACF;;AAEA,oEAAoE;AACpE,gEAAgE;AAChE;EAEE,yFAAyF;AAC3F;;AAEA,8EAA8E;AAC9E;EACE,8DAA8D;EAC9D,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;EACd,8DAA8D;EAC9D,gBAAgB;EAChB,qBAAqB;EACrB,wBAAwB;EACxB,oBAAoB;EACpB,sBAAsB;EACtB,oBAAoB;EACpB,iFAAiF;AACnF;;AAEA;kEACkE;AAClE;EACE,aAAa;EACb,qEAAqE;EACrE,6BAA6B;EAC7B,oBAAoB;AACtB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,8BAA8B;EAC9B;;GAEC;EACD;;GAEC;EACD,YAAY;EACZ,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,2BAA2B;EAC3B,oCAAoC;AACtC;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,YAAY;EACZ,oCAAoC;EACpC,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,kFAAkF;AACpF;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,iBAAiB;EACjB,wCAAwC;EACxC,2EAA2E;AAC7E;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,eAAe;EACf,kCAAkC;EAClC,iBAAiB;EACjB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,iBAAiB;EACjB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,eAAe;EACf,kCAAkC;EAClC,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,oBAAoB;EACpB,wDAAwD;AAC1D;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;EACrB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,wCAAwC;EACxC,iBAAiB;EACjB,mBAAmB;EACnB,sDAAsD;EACtD,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,kCAAkC;EAClC,iBAAiB;EACjB,mBAAmB;EACnB,wDAAwD;AAC1D;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,qBAAqB;EACrB,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,eAAe;EACf,iBAAiB;EACjB,qDAAqD;AACvD;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,oBAAoB;EACpB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,kCAAkC;EAClC,eAAe;EACf,oBAAoB;EACpB,gBAAgB;EAChB,mDAAmD;AACrD;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,yCAAyC;EACzC,4BAA4B;AAC9B;;AAEA;EACE,qDAAqD;EACrD,iBAAiB;EACjB,oEAAoE;AACtE;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;AACX;;AAEA;EACE,wCAAwC;EACxC,mBAAmB;EACnB,aAAa;EACb,6CAA6C;AAC/C;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,iCAAiC;EACjC,yBAAyB;AAC3B;;AAEA;EACE,wCAAwC;EACxC,mBAAmB;EACnB,aAAa;EACb,6CAA6C;EAC7C,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,qDAAqD;EACrD,kBAAkB;EAClB,4CAA4C;EAC5C,4BAA4B;EAC5B,eAAe;EACf,iBAAiB;EACjB,oBAAoB;EACpB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,eAAe;EACf,uCAAuC;EACvC,iCAAiC;EACjC,uCAAuC;EACvC,qBAAqB;EACrB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,4CAA4C;EAC5C,8CAA8C;EAC9C,kDAAkD;AACpD;;AAEA;EACE,sCAAsC;EACtC,wCAAwC;AAC1C;;AAEA;EACE,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,wCAAwC;EACxC,4CAA4C;EAC5C,iCAAiC;EACjC,qBAAqB;EACrB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,eAAe;EACf,WAAW;EACX,sBAAsB;EACtB,+CAA+C;EAC/C,kBAAkB;EAClB,eAAe;EACf,4BAA4B;EAC5B,4CAA4C;EAC5C,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,uCAAuC;EACvC,iCAAiC;EACjC,uCAAuC;EACvC,qBAAqB;EACrB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,cAAc;EACd,0DAA0D;AAC5D;;AAEA;EACE,sCAAsC;EACtC,wCAAwC;AAC1C;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,6CAA6C;EAC7C,aAAa;EACb,QAAQ;EACR,oEAAoE;AACtE;;AAEA;EACE,wCAAwC;EACxC,mBAAmB;EACnB,iBAAiB;EACjB,4CAA4C;AAC9C;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,+CAA+C;EAC/C,6CAA6C;EAC7C,4BAA4B;EAC5B,qBAAqB;EACrB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,4EAA4E;AAC9E;;AAEA;EACE,2CAA2C;EAC3C,2CAA2C;AAC7C;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,qBAAqB;EACrB,wBAAwB;AAC1B;;AAEA;EACE,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,kCAAkC;EAClC,wDAAwD;AAC1D;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,4BAA4B;EAC5B,kCAAkC;EAClC,0DAA0D;AAC5D;;AAEA;EACE,SAAS;EACT,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,0DAA0D;AAC5D;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kCAAkC;EAClC,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,4BAA4B;EAC5B,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,4BAA4B;EAC5B,kCAAkC;AACpC;;AAEA;EACE,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE;IACE,0BAA0B;IAC1B,SAAS;EACX;EACA;IACE,eAAe;IACf,qBAAqB;EACvB;EACA;IACE,+BAA+B;EACjC;EACA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,QAAQ;EACV;EACA;IACE,uBAAuB;EACzB;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,uBAAuB;IACvB,sBAAsB;IACtB,QAAQ;EACV;EACA;IACE,sBAAsB;IACtB,oBAAoB;EACtB;EACA;IACE,WAAW;EACb;EACA;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE,aAAa;AACf;;AAEA;EACE;IACE,oBAAoB;EACtB;;EAEA;IACE,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;IACR,eAAe;IACf,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,qBAAqB;IACrB,oCAAoC;IACpC,wCAAwC;IACxC,eAAe;IACf,gBAAgB;IAChB,oBAAoB;IACpB,eAAe;IACf,qDAAqD;IACrD;;oEAEgE;EAClE;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,2BAA2B;IAC3B,uDAAuD;EACzD;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,eAAe;IACf,QAAQ;IACR,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,yBAAyB;EAC3B;;EAEA;IACE,kBAAkB;IAClB,QAAQ;IACR,YAAY;IACZ,UAAU;IACV,uCAAuC;IACvC,0BAA0B;IAC1B,kCAAkC;IAClC,eAAe;IACf,8EAA8E;EAChF;;EAEA;IACE,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,4BAA4B;IAC5B,6BAA6B;IAC7B,aAAa;IACb,sBAAsB;IACtB,aAAa;IACb,gBAAgB;IAChB,gFAAgF;EAClF;AACF;;AAEA;EACE;IACE,WAAW;IACX,YAAY;EACd;AACF;;AAEA,uFAAuF;AACvF;gEACgE;AAChE;EACE,UAAU;AACZ;;AAEA;EACE,oBAAoB;EACpB,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,uDAAuD;EACvD,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,iBAAiB;EACjB,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,MAAM;EACN,YAAY;EACZ,mBAAmB;EACnB,6CAA6C;EAC7C,qDAAqD;AACvD;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,uBAAuB;EACvB,kCAAkC;EAClC,mDAAmD;AACrD;;AAEA;EACE,4CAA4C;EAC5C,4BAA4B;EAC5B,yDAAyD;AAC3D;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,wCAAwC;EACxC,4CAA4C;EAC5C,iCAAiC;EACjC,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,kCAAkC;EAClC,iFAAiF;AACnF;;AAEA;EACE,2CAA2C;EAC3C,6CAA6C;AAC/C;;AAEA;EACE,mCAAmC;EACnC,2CAA2C;EAC3C,4BAA4B;EAC5B,qDAAqD;AACvD;;AAEA;EACE,iCAAiC;EACjC,sCAAsC;EACtC,0BAA0B;EAC1B,gDAAgD;AAClD;;AAEA;EACE,sCAAsC;EACtC,2CAA2C;EAC3C,wCAAwC;EACxC,qDAAqD;AACvD;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,oBAAoB;EACpB,mBAAmB;EACnB,wCAAwC;EACxC,4CAA4C;EAC5C,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,6CAA6C;EAC7C,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,mDAAmD;AACrD;;AAEA;EACE,2CAA2C;EAC3C,4BAA4B;AAC9B;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,6CAA6C;EAC7C,8CAA8C;AAChD;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,6CAA6C;EAC7C,8CAA8C;AAChD;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,4BAA4B;EAC5B,eAAe;EACf,gBAAgB;EAChB,kCAAkC;EAClC,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,kCAAkC;EAClC,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,kBAAkB;EAClB,4CAA4C;EAC5C,qBAAqB;EACrB;;;;GAIC;EACD,wCAAwC;EACxC,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,eAAe;EACf,oBAAoB;EACpB,0EAA0E;EAC1E,gDAAgD;AAClD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;;EAEE,eAAe;EACf,kBAAkB;EAClB,qDAAqD;EACrD,mBAAmB;EACnB,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,aAAa;EACb,iCAAiC;EACjC,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;EAClC,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,gCAAgC;EAChC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;EAC5B,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,iCAAiC;EACjC,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,kCAAkC;EAClC,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE,cAAc;EACd,+CAA+C;EAC/C,gBAAgB;AAClB;;AAEA;;EAEE,iBAAiB;AACnB;;AAEA;EACE,kCAAkC;EAClC,gBAAgB;AAClB;;AAEA;EACE,2CAA2C;EAC3C,4BAA4B;EAC5B,+CAA+C;EAC/C,gBAAgB;EAChB,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;EACE,kCAAkC;EAClC,YAAY;AACd;;AAEA,2EAA2E;AAC3E;EACE;IACE,gBAAgB;IAChB,SAAS;IACT,gBAAgB;EAClB;;EAEA;IACE,YAAY;IACZ,gBAAgB;EAClB;AACF;AACA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA,uFAAuF;AACvF;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,wCAAwC;EACxC,oBAAoB;EACpB,4CAA4C;EAC5C,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,iBAAiB;EACjB,eAAe;EACf,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;EAC5B,yCAAyC;EACzC,2CAA2C;AAC7C;;AAEA;EACE,0BAA0B;EAC1B,sCAAsC;EACtC,iCAAiC;AACnC;;AAEA;EACE,wCAAwC;EACxC,2CAA2C;EAC3C,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,qDAAqD;EACrD,mBAAmB;EACnB,aAAa;EACb,kDAAkD;EAClD,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,4BAA4B;EAC5B,sBAAsB;AACxB;;AAEA;EACE,wCAAwC;EACxC,kBAAkB;EAClB,gBAAgB;EAChB,6CAA6C;AAC/C;;AAEA;EACE,2CAA2C;EAC3C,yCAAyC;AAC3C;;AAEA;EACE,4CAA4C;EAC5C,0CAA0C;AAC5C;;AAEA;EACE,iBAAiB;EACjB,+CAA+C;EAC/C,4CAA4C;AAC9C;;AAEA;EACE,kDAAkD;AACpD;;AAEA;EACE,mDAAmD;AACrD;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,kCAAkC;AACpC;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,mEAAmE;EACnE,eAAe;EACf,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,wCAAwC;EACxC,4CAA4C;EAC5C,+CAA+C;AACjD;;AAEA;EACE,kDAAkD;AACpD;;AAEA;EACE,mDAAmD;AACrD;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,wBAAwB;EACxB,cAAc;AAChB;AACA;EACE,UAAU;AACZ;AACA;EACE,yCAAyC;EACzC,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,4BAA4B;EAC5B,kCAAkC;AACpC;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,0IAA0I;AAC5I;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,4CAA4C;EAC5C,kDAAkD;EAClD,gBAAgB;AAClB;;AAEA;EACE,6CAA6C;EAC7C,mDAAmD;EACnD,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,4BAA4B;EAC5B,yCAAyC;EACzC,+CAA+C;EAC/C,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,aAAa;EACb,iBAAiB;EACjB,gDAAgD;EAChD,kBAAkB;EAClB,2CAA2C;AAC7C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,wCAAwC;EACxC,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,4BAA4B;EAC5B,kCAAkC;AACpC;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,wCAAwC;AAC1C;;AAEA;EACE,qDAAqD;EACrD,mBAAmB;EACnB,sBAAsB;EACtB,kDAAkD;AACpD;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,0CAA0C;EAC1C,yCAAyC;AAC3C;;AAEA;EACE,0CAA0C;EAC1C,yCAAyC;AAC3C;;AAEA;EACE,uCAAuC;EACvC,sCAAsC;AACxC;;AAEA;EACE,uCAAuC;EACvC,sCAAsC;AACxC;;AAEA;EACE;IACE,SAAS;EACX;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;;IAEE,cAAc;IACd,WAAW;EACb;;EAEA;IACE,cAAc;IACd,kBAAkB;IAClB,eAAe;IACf,iBAAiB;EACnB;AACF;;AAEA,wEAAwE;AACxE;EACE,8DAA8D;EAC9D,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;EACnB,sBAAsB;EACtB,iFAAiF;AACnF;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,+CAA+C;EAC/C,oCAAoC;EACpC;;;;GAIC;EACD,oDAAoD;AACtD;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,kCAAkC;EAClC,yBAAyB;AAC3B;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,+CAA+C;EAC/C,qBAAqB;EACrB,iBAAiB;EACjB,4CAA4C;EAC5C,4BAA4B;EAC5B,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,iCAAiC;EACjC,mCAAmC;EACnC,uCAAuC;AACzC;;AAEA;EACE,sCAAsC;EACtC,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,wCAAwC;EACxC,mBAAmB;EACnB,6CAA6C;EAC7C,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,kCAAkC;EAClC,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,cAAc;EACd,wCAAwC;EACxC,qBAAqB;EACrB,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,yCAAyC;EACzC,4BAA4B;AAC9B;;AAEA;EACE,yCAAyC;EACzC,2CAA2C;EAC3C,4BAA4B;AAC9B;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,4BAA4B;EAC5B,iBAAiB;EACjB,kCAAkC;AACpC;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,wCAAwC;EACxC,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,4CAA4C;EAC5C,wCAAwC;EACxC,mBAAmB;EACnB,sDAAsD;EACtD,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,wDAAwD;EACxD,mBAAmB;EACnB,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,kCAAkC;AACpC;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,eAAe;EACf,kCAAkC;EAClC,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,wCAAwC;EACxC,mBAAmB;EACnB,sBAAsB;EACtB,eAAe;EACf,4BAA4B;EAC5B,6CAA6C;EAC7C,iFAAiF;AACnF;;AAEA;EACE,aAAa;EACb,oCAAoC;EACpC,4CAA4C;EAC5C,kDAAkD;AACpD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,wCAAwC;EACxC,qBAAqB;EACrB,6CAA6C;EAC7C,kCAAkC;EAClC,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,4BAA4B;EAC5B,4CAA4C;EAC5C,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,YAAY;EACZ,kBAAkB;EAClB,wCAAwC;EACxC,mBAAmB;EACnB,gHAAgH;EAChH,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,gFAAgF;AAClF;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,oBAAoB;EACpB,WAAW;EACX,WAAW;EACX,UAAU;EACV,8BAA8B;AAChC;;AAEA;EACE,wFAAwF;AAC1F;;AAEA;EACE,kFAAkF;AACpF;;AAEA;EACE,kFAAkF;AACpF;;AAEA;EACE,2BAA2B;EAC3B,2CAA2C;EAC3C,sDAAsD;EACtD,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;EAC5B,yBAAyB;EACzB,uDAAuD;AACzD;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,4GAA4G;AAC9G;;AAEA;EACE,yGAAyG;AAC3G;;AAEA;EACE,yGAAyG;AAC3G;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,2CAA2C;EAC3C,kCAAkC;AACpC;;AAEA;EACE,0CAA0C;EAC1C,yCAAyC;AAC3C;;AAEA;EACE,uCAAuC;EACvC,sCAAsC;AACxC;;AAEA;EACE,uCAAuC;EACvC,sCAAsC;AACxC;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,cAAc;EACd,oBAAoB;EACpB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,kCAAkC;EAClC,2CAA2C;EAC3C,iCAAiC;AACnC;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,2CAA2C;EAC3C,sDAAsD;EACtD,0CAA0C;EAC1C,gBAAgB;AAClB;;AAEA;EACE,yCAAyC;EACzC,mDAAmD;EACnD,6CAA6C;AAC/C;;AAEA;EACE,sCAAsC;EACtC,gDAAgD;EAChD,0CAA0C;AAC5C;;AAEA;EACE,sCAAsC;EACtC,gDAAgD;EAChD,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,wGAAwG;EACxG,qFAAqF;AACvF;;AAEA;EACE,wFAAwF;EACxF,oCAAoC;EACpC,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,mGAAmG;EACnG,6FAA6F;AAC/F;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,wCAAwC;AAC1C;;AAEA;EACE,+FAA+F;AACjG;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,0BAA0B;EAC1B,qGAAqG;EACrG,mBAAmB;AACrB;;AAEA;EACE,wDAAwD;AAC1D;;AAEA;EACE,8FAA8F;AAChG;;AAEA;EACE,aAAa;EACb,eAAe;EACf,wDAAwD;EACxD,sBAAsB;AACxB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,sDAAsD;AACxD;;AAEA;;EAEE,gBAAgB;EAChB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA;EACE,gBAAgB;EAChB,wCAAwC;AAC1C;;AAEA;EACE,gBAAgB;EAChB,sCAAsC;EACtC,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,2CAA2C;EAC3C,yCAAyC;EACzC,wCAAwC;EACxC,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,yCAAyC;EACzC,2CAA2C;AAC7C;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,kCAAkC;EAClC,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,2CAA2C;EAC3C,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,mBAAmB;EACnB,4CAA4C;EAC5C,wCAAwC;EACxC,uDAAuD;EACvD,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,+CAA+C;EAC/C,oBAAoB;EACpB,WAAW;EACX,YAAY;EACZ,4CAA4C;EAC5C,iCAAiC;EACjC,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,4BAA4B;EAC5B,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,+CAA+C;EAC/C,eAAe;EACf,eAAe;EACf,4BAA4B;EAC5B,4CAA4C;AAC9C;;AAEA;EACE,aAAa;EACb,yCAAyC;AAC3C;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,SAAS;EACT,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,uCAAuC;EACvC,iCAAiC;EACjC,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE;IACE,qCAAqC;IACrC,gBAAgB;IAChB,oBAAoB;EACtB;EACA;IACE,eAAe;EACjB;EACA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,eAAe;EACjB;EACA;IACE,sBAAsB;IACtB,oBAAoB;EACtB;EACA;IACE,WAAW;EACb;EACA;IACE,SAAO;IACP,YAAY;IACZ,WAAW;EACb;EACA;IACE,0BAA0B;EAC5B;AACF;AACA;EACE;;;;;;IAME,cAAc;IACd,WAAW;EACb;EACA;IACE,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,UAAU;IACV,YAAY;IACZ,gBAAgB;IAChB,sBAAsB;IACtB,mBAAmB;IACnB,SAAS;EACX;EACA;IACE,mBAAmB;IACnB,aAAa;IACb,wCAAwC;IACxC,8CAA8C;IAC9C,mBAAmB;IACnB,4CAA4C;IAC5C,sDAAsD;EACxD;EACA;IACE,sDAAsD;EACxD;EACA;IACE,aAAa;IACb,4CAA4C;IAC5C,QAAQ;IACR,qBAAqB;IACrB,cAAc;IACd,0DAA0D;EAC5D;EACA;IACE,gBAAgB;EAClB;EACA;IACE,yBAAyB;IACzB,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;IACzB,kCAAkC;EACpC;EACA;IACE,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,0BAA0B;IAC1B,oBAAoB;IACpB,kBAAkB;IAClB,wDAAwD;EAC1D;EACA;IACE,aAAa;EACf;EACA;;IAEE,eAAe;EACjB;EACA;IACE,0BAA0B;IAC1B,iBAAiB;EACnB;EACA;IACE,aAAa;EACf;AACF;AACA;EACE;;IAEE,mBAAmB;EACrB;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,eAAe;EACjB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;EACA;IACE,WAAW;EACb;EACA;IACE,SAAO;IACP,kBAAkB;EACpB;EACA;IACE,qBAAqB;IACrB,UAAU;EACZ;EACA;IACE,WAAW;IACX,4BAA4B;IAC5B,6BAA6B;IAC7B,aAAa;EACf;AACF;;AAEA,iDAAiD;AACjD;;;;;;;;;EASE,oCAAoC;AACtC;;AAEA;;;;;EAKE,qBAAqB;AACvB;;AAEA;EACE,4CAA4C;AAC9C;;AAEA,2CAA2C;AAC3C;EACE,kBAAkB;EAClB,kBAAkB;EAClB,+DAA+D;EAC/D,uBAAuB;EACvB,gBAAgB;EAChB,iFAAiF;AACnF;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,UAAU;EACV,2CAA2C;EAC3C,0CAA0C;EAC1C,sBAAsB;EACtB,2BAA2B;EAC3B,kDAAkD;EAClD,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV;;4IAE0I;EAC1I,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,wBAAwB;EACxB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,8DAA8D;EAC9D,oBAAoB;EACpB,mDAAmD;EACnD,4CAA4C;EAC5C,eAAe;EACf,eAAe;EACf,+FAA+F;EAC/F,2BAA2B;EAC3B,uDAAuD;AACzD;;AAEA,gCAAgC,SAAS,EAAE;AAC3C,gCAAgC,UAAU,EAAE;;AAE5C;;EAEE,iDAAiD;EACjD,WAAW;EACX,aAAa;EACb,uCAAuC;AACzC;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,cAAc;EACd,yCAAyC;EACzC,mBAAmB;EACnB,mDAAmD;EACnD,8CAA8C;EAC9C,yCAAyC;EACzC,2BAA2B;EAC3B,2DAA2D;AAC7D;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,sBAAsB;EACtB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,aAAa;EACb,gCAAgC;EAChC,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR;;;;;GAKC;AACH;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,4CAA4C;EAC5C,wDAAwD;EACxD,6DAA6D;AAC/D;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;EACrB,QAAQ;EACR,iBAAiB;EACjB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,4BAA4B;EAC5B,2CAA2C;EAC3C,wCAAwC;AAC1C;;AAEA,iCAAiC,aAAa,EAAE,aAAa,EAAE;;AAE/D;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,+CAA+C;EAC/C,qBAAqB;EACrB,4CAA4C;EAC5C,4BAA4B;EAC5B,eAAe;EACf,0DAA0D;AAC5D;;AAEA;;EAEE,yDAAyD;EACzD,4CAA4C;EAC5C,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qEAAqE;EACrE,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,gEAAgE;EAChE,gBAAgB;EAChB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,yEAAyE;EACzE,YAAY;EACZ,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,MAAM;EACN,iBAAiB;EACjB,oCAAoC;EACpC,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,oCAAoC;EACpC,YAAY;EACZ,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,4BAA4B;EAC5B,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,kBAAkB;EAClB,qBAAqB;EACrB,2CAA2C;EAC3C,wCAAwC;EACxC,4BAA4B;EAC5B,eAAe;EACf,gBAAgB;EAChB,0DAA0D;AAC5D;;AAEA;EACE,0DAA0D;EAC1D,wDAAwD;EACxD,iEAAiE;AACnE;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,0BAA0B;EAC1B,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,SAAS;EACT,iDAAiD;EACjD,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;EACvB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,wCAAwC;EACxC,qBAAqB;EACrB,mDAAmD;EACnD,4BAA4B;EAC5B,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,aAAa;EACb,wCAAwC;EACxC,mBAAmB;EACnB,mDAAmD;EACnD,4BAA4B;EAC5B,gBAAgB;EAChB,eAAe;EACf,wCAAwC;AAC1C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;EACZ,SAAO;AACT;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,kCAAkC;AACpC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;EACjB,cAAc;EACd,wCAAwC;AAC1C;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,kCAAkC;AACpC;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,wBAAwB;EACxB,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,UAAU;EACV,WAAW;EACX,UAAU;EACV,SAAS;EACT,oBAAoB;EACpB,yCAAyC;EACzC,eAAe;EACf,iDAAiD;AACnD;;AAEA;EACE,WAAW;EACX,iDAAiD;AACnD;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,oBAAoB;EACpB,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,qBAAqB;EACrB,6BAA6B;EAC7B,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,uBAAuB;EACvB,YAAY;EACZ,wCAAwC;EACxC,mBAAmB;EACnB,mDAAmD;EACnD,4BAA4B;EAC5B,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,yDAAyD;AAC3D;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,yDAAyD;EACzD,iEAAiE;AACnE;;AAEA;;EAEE,2BAA2B;EAC3B,0DAA0D;EAC1D,aAAa;AACf;;AAEA;EACE;IACE,UAAU;IACV,wCAAwC;EAC1C;EACA;IACE,UAAU;IACV,eAAe;EACjB;AACF;;AAEA,oBAAoB;AACpB;EACE,cAAc;EACd,gBAAgB;EAChB,4CAA4C;EAC5C,uBAAuB;EACvB,+GAA+G;EAC/G,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,SAAS;EACT,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,wCAAwC;EACxC,4CAA4C;AAC9C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,kCAAkC;AACpC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kCAAkC;EAClC,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,iCAAiC;EACjC,qBAAqB;AACvB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,kCAAkC;EAClC,+CAA+C;EAC/C,sBAAsB;AACxB;;AAEA;EACE,UAAU;EACV,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,eAAe;EACf,sBAAsB;AACxB;;AAEA;;EAEE,UAAU;AACZ;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,iCAAiC;EACjC,wDAAwD;EACxD,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,kCAAkC;EAClC,4BAA4B;EAC5B,wDAAwD;AAC1D;;AAEA;;EAEE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,MAAM;AACR;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,wCAAwC;EACxC,mBAAmB;EACnB,aAAa;EACb,4CAA4C;AAC9C;;AAEA;EACE,SAAS;EACT,kCAAkC;EAClC,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,wCAAwC;EACxC,mBAAmB;EACnB,qCAAqC;EACrC,gDAAgD;EAChD,wCAAwC;EACxC,kDAAkD;EAClD,4CAA4C;AAC9C;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,4BAA4B;EAC5B,+CAA+C;AACjD;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,wGAAwG;EACxG,qFAAqF;AACvF;;AAEA;EACE,wFAAwF;EACxF,oCAAoC;EACpC,4BAA4B;AAC9B;;AAEA;EACE,wCAAwC;EACxC,mBAAmB;EACnB,4CAA4C;EAC5C,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,sBAAsB;EACtB,yBAAyB;EACzB,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,mGAAmG;AACrG;;AAEA;EACE;IACE,cAAc;EAChB;;EAEA;;;;;;IAME,cAAc;IACd,WAAW;EACb;;EAEA;IACE,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,UAAU;IACV,YAAY;IACZ,gBAAgB;IAChB,sBAAsB;IACtB,mBAAmB;IACnB,SAAS;EACX;;EAEA;IACE,mBAAmB;IACnB,aAAa;IACb,wCAAwC;IACxC,8CAA8C;IAC9C,mBAAmB;IACnB,4CAA4C;IAC5C,sDAAsD;EACxD;;EAEA;IACE,aAAa;IACb,4CAA4C;IAC5C,QAAQ;IACR,qBAAqB;IACrB,cAAc;IACd,0DAA0D;IAC1D,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,yBAAyB;IACzB,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;IACzB,kCAAkC;EACpC;;EAEA;IACE,0BAA0B;IAC1B,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,qBAAqB;EACvB;AACF;;AAEA;EACE;IACE,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;IAChB,aAAa;IACb,mBAAmB;EACrB;;EAEA;;IAEE,eAAe;EACjB;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,cAAc;IACd,eAAe;IACf,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,cAAc;IACd,sBAAsB;EACxB;;EAEA;;IAEE,gBAAgB;EAClB;AACF;;;AAGA,wCAAwC;;AAExC;;EAEE,aAAa;EACb,oBAAoB;EACpB,eAAe;AACjB;AACA;;EAEE,eAAe;AACjB;;;AAGA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,+CAA+C;EAC/C,uCAAuC;EACvC;;;;GAIC;EACD,iCAAiC;EACjC,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,oDAAoD;EACpD;;;;yBAIuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,2CAA2C;EAC3C,2CAA2C;EAC3C,4BAA4B;AAC9B;;AAEA;EACE,uCAAuC;EACvC,oCAAoC;EACpC,sCAAsC;EACtC,yDAAyD;AAC3D;;AAEA;EACE,aAAa;EACb,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,OAAO;EACP,QAAQ;EACR,SAAS;EACT,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb;;;;;;KAMG;EACH,yCAAyC;EACzC,iDAAiD;EACjD,4BAA4B;EAC5B,SAAS;EACT,gBAAgB;EAChB,gBAAgB;EAChB,uDAAuD;EACvD,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,4BAA4B;EAC5B,uBAAuB;EACvB,mBAAmB;EACnB,iCAAiC;EACjC,WAAW;EACX,gBAAgB;EAChB,cAAc;EACd,sBAAsB;EACtB,kBAAkB;EAClB,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,sDAAsD;EACtD,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,UAAU;EACV,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,YAAY;EACZ,oBAAoB;EACpB,+CAA+C;EAC/C,6CAA6C;AAC/C;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,kCAAkC;AACpC;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,+CAA+C;EAC/C,uCAAuC;EACvC,4CAA4C;EAC5C,iCAAiC;EACjC,eAAe;EACf,gBAAgB;EAChB,mDAAmD;AACrD;;AAEA;EACE,2CAA2C;EAC3C,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;EAChB,6BAA6B;EAC7B,qBAAqB;EACrB,0DAA0D;AAC5D;;AAEA;EACE,iBAAiB;EACjB,UAAU;AACZ;;AAEA;EACE,gDAAgD;EAChD,SAAS;AACX;;AAEA;EACE,aAAa;EACb,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,wCAAwC;EACxC,mBAAmB;EACnB,6CAA6C;AAC/C;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,cAAc;EACd,oBAAoB;EACpB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,uCAAuC;EACvC,sCAAsC;EACtC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,SAAO;AACT;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,kCAAkC;AACpC;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,iCAAiC;AACnC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,YAAY;EACZ,UAAU;EACV,uCAAuC;EACvC,0BAA0B;EAC1B,kCAAkC;EAClC,eAAe;EACf,8EAA8E;AAChF;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,6BAA6B;EAC7B,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,4BAA4B;EAC5B,6BAA6B;EAC7B,+CAA+C;EAC/C,mBAAmB;EACnB;;;;GAIC;EACD,uDAAuD;EACvD,gFAAgF;AAClF;;AAEA;EACE;IACE,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;;AAGA;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,wDAAwD;EACxD,2DAA2D;EAC3D;;;;;sBAKoB;EACpB,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,UAAU;EACV,qCAAqC;EACrC,uBAAuB;EACvB,+CAA+C;EAC/C,mBAAmB;EACnB,4CAA4C;EAC5C,uDAAuD;EACvD,4BAA4B;EAC5B,oBAAoB;EACpB,6CAA6C;EAC7C,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,kCAAkC;AACpC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,oBAAoB;EACpB,iDAAiD;EACjD,kCAAkC;EAClC,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,4BAA4B;EAC5B,6CAA6C;AAC/C;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,iCAAiC;AACnC;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,2DAA2D;EAC3D,kBAAkB;EAClB,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,4CAA4C;AAC9C;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,6BAA6B;EAC7B,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,yBAAyB;EACzB,kCAAkC;AACpC;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,2CAA2C;EAC3C,oCAAoC;EACpC,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,UAAU;EACV,YAAY;EACZ,aAAa;EACb,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,eAAe;EACf,+CAA+C;EAC/C,oBAAoB;EACpB,4CAA4C;EAC5C,4BAA4B;EAC5B,sDAAsD;EACtD,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,sDAAsD;AACxD;;AAEA;EACE;IACE,WAAW;IACX,eAAe;IACf,uBAAuB;IACvB,mBAAmB;IACnB,cAAc;IACd,iCAAiC;IACjC,uDAAuD;EACzD;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,QAAQ;IACR,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,mBAAmB;IACnB,oEAAoE;IACpE;;;;;wBAKoB;EACtB;;EAEA;IACE,+CAA+C;IAC/C,qDAAqD;EACvD;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,WAAW;IACX,aAAa;IACb,8BAA8B;EAChC;;EAEA;IACE,QAAQ;IACR,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,cAAc;EAChB;;EAEA;;IAEE,mBAAmB;EACrB;AACF","sourcesContent":["/* Prediction Market component styles (ported from SCSS) */\n\n/* from src/games/PredictionMarket/predictionMarket.scss */\n/* Custom-property host for the page. The layout/paint rules live on the element\n   as Tailwind utilities; only the tokens the rest of this file reads stay here. */\n.prediction-market-page {\n  --pm-ease: cubic-bezier(0.4, 0, 0.2, 1);\n  --pm-ease-spring: cubic-bezier(0.34, 1.2, 0.64, 1);\n  /* top row + nav + news ticker */\n  --pm-header-offset: 140px;\n  --pm-duration-fast: 0.16s;\n  --pm-duration: 0.24s;\n  --pm-duration-slow: 0.36s;\n  --pm-content-pad: 16px;\n}\n\n.prediction-market-page--casino {\n  /* Full-bleed iframe shell — no marketing-site container */\n  max-width: none;\n}\n\n@keyframes pm-fade-in-up {\n  from {\n    opacity: 0;\n    transform: translateY(8px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n@keyframes pm-fade-in {\n  from { opacity: 0; }\n  to { opacity: 1; }\n}\n\n@keyframes pm-scale-in {\n  from {\n    opacity: 0;\n    transform: scale(0.98);\n  }\n  to {\n    opacity: 1;\n    transform: scale(1);\n  }\n}\n\n@keyframes pm-slide-down {\n  from {\n    opacity: 0;\n    max-height: 0;\n    transform: translateY(-4px);\n  }\n  to {\n    opacity: 1;\n    max-height: 1200px;\n    transform: translateY(0);\n  }\n}\n\n@keyframes pm-sheet-slide-up {\n  from {\n    opacity: 0;\n    transform: translateY(100%);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n@media (max-width: 700px) {\n  .prediction-market-page {\n    --pm-header-offset: 136px;\n    --pm-content-pad: 12px;\n  }\n}\n\n@media (max-width: 500px) {\n  .prediction-market-page {\n    --pm-header-offset: 132px;\n    --pm-content-pad: 10px;\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .prediction-market-page,\n  .prediction-market-main,\n  .market-detail-wrapper,\n  .market-detail-header,\n  .ua-replies-list,\n  .user-activity-panel,\n  .order-panel,\n  .order-panel-fieldset,\n  .order-panel-disabled-note,\n  .portfolio-page,\n  .market-detail-trade-sheet-backdrop,\n  .market-detail-trade-sheet-content {\n    animation: none !important;\n  }\n}\n\n/* from src/games/PredictionMarket/components/Header/header.scss */\n.header-section {\n  flex-shrink: 0;\n  color: rgb(var(--color-ink));\n  width: 100%;\n  left: 0;\n  top: 0;\n  position: fixed;\n  z-index: 1000;\n  box-sizing: border-box;\n  padding-top: 0.5rem;\n  padding-bottom: 0.35rem;\n  padding-left: 12px;\n  padding-right: 12px;\n  background: rgb(var(--color-surface) / 0.94);\n  backdrop-filter: blur(10px) saturate(1.2);\n  -webkit-backdrop-filter: blur(10px) saturate(1.2);\n  margin: 0;\n  transition: box-shadow var(--pm-duration-fast, 0.16s) var(--pm-ease, ease);\n  border-bottom: 1px solid rgb(var(--color-line) / 0.9);\n  box-shadow: 0 1px 0 rgb(var(--pm-gold) / 0.12);\n}\n.header-section::after {\n  content: none;\n}\n.header-section .logo-section {\n  color: rgb(var(--color-ink));\n  font-weight: 700;\n  cursor: pointer;\n  min-height: 2rem;\n  flex-shrink: 0;\n}\n.header-section .logo-section h4 {\n  margin: 0;\n  font-size: 0.92rem;\n  font-weight: 700;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  color: rgb(var(--pm-gold));\n}\n.header-section .logo-section img {\n  width: 1.65rem;\n  height: 1.65rem;\n  object-fit: contain;\n  filter: drop-shadow(0 0 6px rgb(var(--pm-gold) / 0.35));\n}\n.header-section .header-top-row {\n  gap: 0.5rem;\n  width: 100%;\n  max-width: 1400px;\n  margin: 0 auto;\n  min-height: 2rem;\n  flex-wrap: nowrap;\n  align-items: center !important;\n}\n.header-section .actions-section {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 0.4rem;\n  min-width: 0;\n  flex: 1 1 auto;\n  width: auto;\n  margin-left: auto;\n}\n:is(.header-section, .pm-header-actions) .header-icon-btn {\n  flex-shrink: 0;\n  width: 2rem;\n  height: 2rem;\n  padding: 0;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border: 1px solid rgb(var(--color-line-strong));\n  border-radius: var(--pm-radius-sm, 6px);\n  background: rgb(var(--color-surface-raised));\n  color: rgb(var(--color-ink-muted));\n  cursor: pointer;\n  appearance: none;\n  font-size: 0.85rem;\n  transition: background 0.15s, color 0.15s, border-color 0.15s;\n}\n:is(.header-section, .pm-header-actions) .header-icon-btn:hover {\n  background: rgb(var(--color-surface-muted));\n  color: rgb(var(--color-ink));\n  border-color: rgb(var(--pm-gold) / 0.45);\n}\n.header-section .balance-section {\n  border: 1px solid rgb(var(--color-line-strong));\n  border-radius: var(--pm-radius-sm, 6px);\n  display: flex;\n  align-items: stretch;\n  gap: 0.5rem;\n  overflow: hidden;\n  background: linear-gradient(\n    180deg,\n    rgb(var(--color-surface-raised)) 0%,\n    rgb(var(--color-surface-muted) / 0.65) 100%\n  );\n  box-shadow: inset 0 1px 0 rgb(var(--pm-gold) / 0.08);\n}\n.header-section .action-icons {\n  display: flex;\n  flex-direction: column;\n  width: 2rem;\n  flex-shrink: 0;\n  background: rgb(var(--color-surface-muted));\n}\n.header-section .action-icons button {\n  flex: 1;\n  min-height: 1.85rem;\n  width: 2rem;\n  border: none;\n  outline: none;\n  background: transparent;\n  color: rgb(var(--color-ink-soft));\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: background 0.15s, color 0.15s;\n  box-shadow: none;\n  appearance: none;\n}\n.header-section .balance-section {\n  padding-right: 0.65rem;\n  font-weight: 600;\n  color: rgb(var(--color-ink-soft));\n  max-width: 100%;\n}\n.header-section .balance-values {\n  display: flex;\n  flex-direction: column;\n  gap: 0.05rem;\n  line-height: 1.15;\n  padding: 0.3rem 0;\n  min-width: 0;\n  font-size: 0.72rem;\n  justify-content: center;\n}\n.header-section .balance-currency {\n  color: rgb(var(--color-ink-faint));\n  font-size: 0.62rem;\n  font-weight: 700;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n}\n.header-section .balance-main,\n.header-section .balance-sub {\n  white-space: normal;\n  overflow-wrap: anywhere;\n  word-break: break-word;\n}\n.header-section .balance-sub-row {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 0.6rem;\n  min-width: 0;\n}\n.header-section .balance-sub-row .balance-sub {\n  flex: 0 1 auto;\n}\n.header-section .balance-main {\n  font-weight: 700;\n  font-variant-numeric: tabular-nums;\n  color: rgb(var(--pm-gold));\n  font-size: 0.82rem;\n}\n.header-section .balance-sub {\n  color: rgb(var(--color-ink-muted));\n  font-weight: 600;\n}\n.header-section .action-icons button + button {\n  border-top: 1px solid rgb(var(--color-line-strong));\n}\n.header-section .action-icons button i {\n  font-size: 0.95rem;\n  line-height: 1;\n}\n.header-section .action-icons button:hover {\n  background: rgb(var(--color-line));\n  color: rgb(var(--pm-gold));\n}\n.header-section .action-icons button:focus {\n  outline: none;\n  box-shadow: none;\n}\n@media (max-width: 900px) {\n  .header-section .header-top-row {\n    align-items: center !important;\n  }\n  .header-section .actions-section {\n    width: auto;\n    flex: 1 1 auto;\n    justify-content: flex-end;\n  }\n  .header-section .balance-section {\n    max-width: min(100%, 280px);\n  }\n}\n@media (max-width: 700px) {\n  .header-section .header-top-row {\n    align-items: center !important;\n  }\n  .header-section .logo-section {\n    width: fit-content;\n  }\n  .header-section .logo-section h4 {\n    display: none;\n  }\n  .header-section .actions-section {\n    gap: 0.35rem;\n    width: auto;\n    flex: 1 1 auto;\n  }\n  .header-section .balance-section {\n    flex: 0 1 auto;\n    min-width: 0;\n  }\n}\n@media (max-width: 500px) {\n  .header-section {\n    padding-left: 8px;\n    padding-right: 8px;\n  }\n  .header-section .action-icons {\n    width: 2rem;\n  }\n  .header-section .action-icons button {\n    width: 2rem;\n    min-height: 1.85rem;\n  }\n  .header-section .balance-section {\n    padding-right: 0.5rem;\n    gap: 0.4rem;\n  }\n  .header-section .balance-values {\n    font-size: 0.7rem;\n    gap: 0.05rem;\n    padding: 0.28rem 0;\n  }\n  .header-section .balance-sub-row {\n    gap: 0.4rem;\n  }\n}\n:is(.header-section, .pm-header-actions) .market-orders-indicator {\n  position: relative;\n  flex-shrink: 0;\n}\n:is(.header-section, .pm-header-actions) .market-orders-indicator__trigger {\n  width: 2rem;\n  height: 2rem;\n  border: 1px solid transparent;\n  border-radius: var(--pm-radius-sm, 6px);\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  cursor: default;\n  box-shadow: none;\n  appearance: none;\n  padding: 0;\n}\n:is(.header-section, .pm-header-actions) .market-orders-indicator__trigger--active {\n  background: rgb(var(--color-warning-soft));\n  border-color: rgb(var(--color-warning));\n  color: rgb(var(--color-warning-contrast));\n}\n:is(.header-section, .pm-header-actions) .market-orders-indicator__trigger--active i {\n  animation: market-orders-indicator-spin 1s linear infinite;\n}\n:is(.header-section, .pm-header-actions) .market-orders-indicator__trigger--idle {\n  background: rgb(var(--color-success-soft));\n  border-color: rgb(var(--color-success));\n  color: rgb(var(--color-success-contrast));\n}\n:is(.header-section, .pm-header-actions) .market-orders-indicator__trigger i {\n  font-size: 1rem;\n  line-height: 1;\n}\n:is(.header-section, .pm-header-actions) .market-orders-indicator__dropdown {\n  position: absolute;\n  top: calc(100% + 8px);\n  right: 0;\n  width: min(20rem, calc(100vw - 2rem));\n  padding: 0.75rem 0.85rem;\n  border-radius: 10px;\n  background: rgb(var(--color-surface-raised));\n  border: 1px solid rgb(var(--color-line-strong));\n  box-shadow: 0 10px 24px rgb(var(--color-shadow) / 0.12);\n  color: rgb(var(--color-ink));\n  font-size: clamp(0.72rem, 2.5vw, 0.78rem);\n  line-height: 1.45;\n  text-align: left;\n  opacity: 0;\n  visibility: hidden;\n  margin-top: -4px;\n  transition: opacity 0.15s ease, margin-top 0.15s ease, visibility 0.15s ease;\n  pointer-events: none;\n  z-index: 1100;\n}\n:is(.header-section, .pm-header-actions) .market-orders-indicator:hover .market-orders-indicator__dropdown,\n:is(.header-section, .pm-header-actions) .market-orders-indicator:focus-within .market-orders-indicator__dropdown {\n  opacity: 1;\n  visibility: visible;\n  margin-top: 0;\n  pointer-events: auto;\n}\n:is(.header-section, .pm-header-actions) .market-orders-indicator__dropdown-title {\n  margin: 0 0 0.5rem;\n  font-size: 0.72rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  color: rgb(var(--color-warning-contrast));\n}\n:is(.header-section, .pm-header-actions) .market-orders-indicator__dropdown-details {\n  display: flex;\n  flex-direction: column;\n  gap: 0.25rem;\n  color: rgb(var(--color-ink-soft));\n  font-weight: 500;\n  overflow-wrap: anywhere;\n}\n:is(.header-section, .pm-header-actions) .market-orders-indicator__dropdown-empty {\n  margin: 0;\n  color: rgb(var(--color-ink-muted));\n  font-weight: 500;\n  overflow-wrap: anywhere;\n}\n@keyframes market-orders-indicator-spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n:is(.header-section, .pm-header-actions) .notification-bell {\n  position: relative;\n  flex-shrink: 0;\n}\n:is(.header-section, .pm-header-actions) .notification-bell__trigger {\n  position: relative;\n  width: 2rem;\n  height: 2rem;\n  border: 1px solid rgb(var(--color-line-strong));\n  border-radius: var(--pm-radius-sm, 6px);\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  background: rgb(var(--color-surface-raised));\n  color: rgb(var(--color-ink-soft));\n  box-shadow: none;\n  appearance: none;\n  padding: 0;\n  transition: background 0.15s, border-color 0.15s, color 0.15s;\n}\n:is(.header-section, .pm-header-actions) .notification-bell__trigger i {\n  font-size: 1.05rem;\n  line-height: 1;\n}\n:is(.header-section, .pm-header-actions) .notification-bell__trigger:hover {\n  background: rgb(var(--color-surface-muted));\n  border-color: rgb(var(--color-line-strong));\n  color: rgb(var(--color-ink));\n}\n:is(.header-section, .pm-header-actions) .notification-bell__trigger--active {\n  background: rgb(var(--color-info-soft));\n  border-color: rgb(var(--color-info));\n  color: rgb(var(--color-info-contrast));\n}\n:is(.header-section, .pm-header-actions) .notification-bell__badge {\n  position: absolute;\n  top: -5px;\n  right: -5px;\n  min-width: 1.1rem;\n  height: 1.1rem;\n  padding: 0 0.25rem;\n  border-radius: 999px;\n  background: rgb(var(--color-danger));\n  color: rgb(var(--color-surface-raised));\n  font-size: 0.62rem;\n  font-weight: 700;\n  line-height: 1.1rem;\n  text-align: center;\n  border: 2px solid rgb(var(--color-surface));\n}\n:is(.header-section, .pm-header-actions) .notification-bell__dropdown {\n  position: absolute;\n  top: calc(100% + 8px);\n  right: 0;\n  width: min(22rem, calc(100vw - 2rem));\n  max-height: min(24rem, calc(100vh - 6rem));\n  display: flex;\n  flex-direction: column;\n  border-radius: 12px;\n  background: rgb(var(--color-surface-raised));\n  border: 1px solid rgb(var(--color-line-strong));\n  box-shadow: 0 12px 28px rgb(var(--color-shadow) / 0.14);\n  z-index: 1200;\n  overflow: hidden;\n}\n:is(.header-section, .pm-header-actions) .notification-bell__dropdown-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 0.5rem;\n  padding: 0.85rem 1rem;\n  border-bottom: 1px solid rgb(var(--color-line));\n  background: rgb(var(--color-surface-overlay));\n}\n:is(.header-section, .pm-header-actions) .notification-bell__dropdown-header h3 {\n  margin: 0;\n  font-size: 0.9rem;\n  font-weight: 700;\n  color: rgb(var(--color-ink));\n}\n:is(.header-section, .pm-header-actions) .notification-bell__count {\n  font-size: 0.72rem;\n  font-weight: 600;\n  color: rgb(var(--color-ink-faint));\n  white-space: nowrap;\n}\n:is(.header-section, .pm-header-actions) .notification-bell__list {\n  overflow-y: auto;\n  max-height: min(20rem, calc(100vh - 9rem));\n}\n:is(.header-section, .pm-header-actions) .notification-bell__empty {\n  margin: 0;\n  padding: 1.25rem 1rem;\n  color: rgb(var(--color-ink-faint));\n  font-size: 0.82rem;\n  line-height: 1.45;\n  text-align: center;\n}\n:is(.header-section, .pm-header-actions) .notification-bell__item {\n  width: 100%;\n  display: flex;\n  align-items: flex-start;\n  gap: 0.7rem;\n  padding: 0.8rem 1rem;\n  border: none;\n  border-bottom: 1px solid rgb(var(--color-surface-muted));\n  background: transparent;\n  text-align: left;\n  cursor: pointer;\n  transition: background 0.15s;\n}\n:is(.header-section, .pm-header-actions) .notification-bell__item:hover {\n  background: rgb(var(--color-surface-overlay));\n}\n:is(.header-section, .pm-header-actions) .notification-bell__item--unread {\n  background: rgb(var(--color-info-soft));\n}\n:is(.header-section, .pm-header-actions) .notification-bell__item--unread:hover {\n  background: rgb(var(--color-info-soft));\n}\n:is(.header-section, .pm-header-actions) .notification-bell__icon {\n  flex-shrink: 0;\n  width: 2rem;\n  height: 2rem;\n  border-radius: 999px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 0.8rem;\n}\n:is(.header-section, .pm-header-actions) .notification-bell__icon--order {\n  background: rgb(var(--color-info-soft));\n  color: rgb(var(--color-info-contrast));\n}\n:is(.header-section, .pm-header-actions) .notification-bell__icon--trade {\n  background: rgb(var(--color-success-soft));\n  color: rgb(var(--color-success-contrast));\n}\n:is(.header-section, .pm-header-actions) .notification-bell__icon--order_complete {\n  background: rgb(var(--color-success-soft));\n  color: rgb(var(--color-success-contrast));\n}\n:is(.header-section, .pm-header-actions) .notification-bell__icon--position {\n  background: rgb(var(--color-info-soft));\n  color: rgb(var(--color-info-contrast));\n}\n:is(.header-section, .pm-header-actions) .notification-bell__icon--resolution {\n  background: rgb(var(--color-warning-soft));\n  color: rgb(var(--color-warning-contrast));\n}\n:is(.header-section, .pm-header-actions) .notification-bell__icon--wallet {\n  background: rgb(var(--color-warning-soft));\n  color: rgb(var(--color-warning-contrast));\n}\n:is(.header-section, .pm-header-actions) .notification-bell__content {\n  display: flex;\n  flex-direction: column;\n  gap: 0.15rem;\n  min-width: 0;\n}\n:is(.header-section, .pm-header-actions) .notification-bell__title {\n  font-size: 0.8rem;\n  font-weight: 700;\n  color: rgb(var(--color-ink));\n  overflow-wrap: anywhere;\n}\n:is(.header-section, .pm-header-actions) .notification-bell__option {\n  font-size: 0.72rem;\n  font-weight: 600;\n  color: rgb(var(--color-ink-muted));\n  overflow-wrap: anywhere;\n}\n:is(.header-section, .pm-header-actions) .notification-bell__message {\n  font-size: 0.75rem;\n  color: rgb(var(--color-ink-soft));\n  line-height: 1.35;\n  overflow-wrap: anywhere;\n}\n:is(.header-section, .pm-header-actions) .notification-bell__time {\n  font-size: 0.68rem;\n  color: rgb(var(--color-ink-faint));\n  font-weight: 500;\n  margin-top: 0.1rem;\n}\n@media (max-width: 620px) {\n  :is(.header-section, .pm-header-actions) .market-orders-indicator__dropdown {\n    position: fixed;\n    top: 76px;\n    left: 12px;\n    right: 12px;\n    width: auto;\n  }\n  .header-section .balance-section {\n    padding-right: 0;\n    gap: 0;\n    width: fit-content;\n  }\n  .header-section .balance-values {\n    display: none;\n  }\n  .header-section .actions-section {\n    width: fit-content;\n    margin-left: auto;\n  }\n  .header-section .action-icons {\n    border-radius: 10px;\n    overflow: hidden;\n  }\n  .header-section .action-icons button {\n    min-height: 2.45rem;\n  }\n  :is(.header-section, .pm-header-actions) .notification-bell__dropdown {\n    position: fixed;\n    top: 76px;\n    left: 12px;\n    right: 12px;\n    width: auto;\n  }\n}\n\n/* from src/games/PredictionMarket/components/Markets/markets.scss */\n/* Featured news ticker fade edges (Tailwind animation + mask) */\n.masked-news-fade {\n  -webkit-mask-image: linear-gradient(180deg, transparent 0%, #000 14%, #000 86%, transparent 100%);\n  mask-image: linear-gradient(180deg, transparent 0%, #000 14%, #000 86%, transparent 100%);\n}\n\n/* from src/games/PredictionMarket/components/MarketDetail/marketDetail.scss */\n.market-detail-wrapper {\n  width: min(100%, calc(100% - var(--pm-content-pad, 16px) * 2));\n  max-width: 1400px;\n  margin: 12px auto;\n  padding: 0 4px;\n  max-height: calc(100vh - var(--pm-header-offset, 140px) - 8px);\n  overflow-y: auto;\n  scrollbar-width: none;\n  -ms-overflow-style: none;\n  padding-bottom: 16px;\n  box-sizing: border-box;\n  font-family: inherit;\n  animation: pm-fade-in-up var(--pm-duration-slow, 0.36s) var(--pm-ease, ease) both;\n}\n\n/* stretch so the order column matches main height — sticky panel then lasts until\n   layout ends; footer below scrolls the whole block up together */\n.market-detail-layout {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) minmax(260px, min(380px, 100%));\n  gap: clamp(12px, 2.5vw, 20px);\n  align-items: stretch;\n}\n\n.market-detail-main {\n  min-width: 0;\n}\n\n.market-detail-order-panel-wrap {\n  --order-panel-top: 12px;\n  --order-panel-bottom-pad: 16px;\n  --order-panel-max-h: calc(\n    100vh - var(--pm-header-offset, 140px) - var(--order-panel-top) - var(--order-panel-bottom-pad)\n  );\n  --order-panel-max-h: calc(\n    100dvh - var(--pm-header-offset, 140px) - var(--order-panel-top) - var(--order-panel-bottom-pad)\n  );\n  min-width: 0;\n  width: 100%;\n  max-width: 380px;\n  justify-self: end;\n  align-self: start;\n  display: flex;\n  flex-direction: column;\n  position: sticky;\n  top: var(--order-panel-top);\n  max-height: var(--order-panel-max-h);\n}\n\n.market-detail-order-panel-wrap .order-panel {\n  align-self: stretch;\n  flex: 0 1 auto;\n  min-height: 0;\n  height: auto;\n  max-height: var(--order-panel-max-h);\n  position: static;\n  top: auto;\n}\n\n.market-detail-wrapper::-webkit-scrollbar {\n  width: 0;\n  height: 0;\n}\n\n.market-detail-wrapper > footer {\n  margin-top: 24px;\n  margin-left: -8px;\n  margin-right: -8px;\n  width: calc(100% + 16px);\n}\n\n.market-detail-header {\n  display: flex;\n  gap: 14px;\n  margin-bottom: 16px;\n  animation: pm-fade-in-up var(--pm-duration, 0.24s) var(--pm-ease, ease) 0.06s both;\n}\n\n.market-detail-image {\n  width: 56px;\n  height: 56px;\n  border-radius: var(--pm-radius, 8px);\n  object-fit: cover;\n  border: 1px solid rgb(var(--color-line));\n  transition: transform var(--pm-duration, 0.24s) var(--pm-ease-spring, ease);\n}\n\n.market-detail-header:hover .market-detail-image {\n  transform: scale(1.04);\n}\n\n.market-detail-meta {\n  flex: 1;\n}\n\n.market-category {\n  font-size: 12px;\n  color: rgb(var(--color-ink-faint));\n  margin: 0 0 6px 0;\n  text-transform: uppercase;\n  font-weight: 600;\n}\n\n.market-title {\n  font-size: 1.15rem;\n  line-height: 1.35;\n  font-weight: 700;\n  letter-spacing: -0.01em;\n  margin: 0 0 8px 0;\n  color: rgb(var(--color-ink));\n}\n\n.market-meta-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n}\n\n.market-meta {\n  font-size: 13px;\n  color: rgb(var(--color-ink-faint));\n  font-weight: 500;\n  margin: 0;\n}\n\n.market-meta-actions {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  flex-shrink: 0;\n}\n\n.graph-legend {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 14px 20px;\n  margin-bottom: 14px;\n  padding-bottom: 12px;\n  border-bottom: 1px solid rgb(var(--color-surface-muted));\n}\n\n.graph-legend-item {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  min-width: 0;\n}\n\n.graph-legend-dot {\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  flex-shrink: 0;\n}\n\n.graph-legend-text {\n  display: inline-flex;\n  align-items: baseline;\n  gap: 8px;\n  font-size: 14px;\n  font-weight: 600;\n  min-width: 0;\n}\n\n.graph-legend-title {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  max-width: 200px;\n}\n\n.graph-legend-chance {\n  font-weight: 600;\n  font-variant-numeric: tabular-nums;\n  flex-shrink: 0;\n}\n\n.graph-tooltip {\n  background: white;\n  border: 1px solid rgb(var(--color-line));\n  padding: 8px 10px;\n  border-radius: 10px;\n  box-shadow: 0 8px 20px rgb(var(--color-shadow) / 0.08);\n  min-width: 140px;\n}\n\n.tooltip-time {\n  font-size: 11px;\n  color: rgb(var(--color-ink-faint));\n  margin: 0 0 8px 0;\n  padding-bottom: 6px;\n  border-bottom: 1px solid rgb(var(--color-surface-muted));\n}\n\n.tooltip-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: baseline;\n  gap: 16px;\n  font-size: 13px;\n  font-weight: 600;\n  margin: 4px 0 0 0;\n}\n\n.tooltip-option-title {\n  flex: 1;\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.tooltip-option-chance {\n  font-variant-numeric: tabular-nums;\n  flex-shrink: 0;\n}\n\n.graph-range-filters {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: center;\n  gap: 4px;\n  margin-top: 4px;\n  padding-top: 14px;\n  border-top: 1px solid rgb(var(--color-surface-muted));\n}\n\n.graph-range-btn {\n  padding: 6px 14px;\n  border: none;\n  border-radius: 999px;\n  background: transparent;\n  font-size: 13px;\n  font-weight: 600;\n  color: rgb(var(--color-ink-faint));\n  cursor: pointer;\n  font-family: inherit;\n  line-height: 1.2;\n  transition: background 0.15s ease, color 0.15s ease;\n}\n\n.graph-range-btn:hover {\n  color: rgb(var(--color-ink));\n}\n\n.graph-range-btn--active {\n  background: rgb(var(--color-accent-soft));\n  color: rgb(var(--color-ink));\n}\n\n.user-activity-panel {\n  border-top: 1px solid rgb(var(--color-surface-muted));\n  padding-top: 12px;\n  animation: pm-fade-in var(--pm-duration, 0.28s) var(--pm-ease, ease);\n}\n\n.ua-top-holders-head {\n  display: flex;\n  justify-content: flex-end;\n  margin-bottom: 10px;\n}\n\n.ua-top-holders-grid {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 12px;\n}\n\n.ua-comment-card {\n  border: 1px solid rgb(var(--color-line));\n  border-radius: 10px;\n  padding: 10px;\n  background: rgb(var(--color-surface-overlay));\n}\n\n.ua-comment-card + .ua-comment-card {\n  margin-top: 8px;\n}\n\n.ua-comment-head {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 10px;\n}\n\n.ua-comment-head-user {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.ua-comment-head-user img {\n  width: 26px;\n  height: 26px;\n  border-radius: 999px;\n  object-fit: cover;\n  flex-shrink: 0;\n}\n\n.ua-comment-user {\n  font-size: 12px;\n  font-weight: 600;\n  color: rgb(var(--color-ink));\n}\n\n.ua-comment-time {\n  font-size: 11px;\n  color: rgb(var(--color-ink-faint));\n}\n\n.ua-comment-text {\n  margin: 6px 0 0 0;\n  font-size: 13px;\n  line-height: 1.5;\n  color: rgb(var(--color-ink-soft));\n  overflow-wrap: break-word;\n}\n\n.ua-comment-compose {\n  border: 1px solid rgb(var(--color-line));\n  border-radius: 10px;\n  padding: 10px;\n  background: rgb(var(--color-surface-overlay));\n  margin-bottom: 10px;\n}\n\n.ua-comment-compose-label {\n  display: block;\n  font-size: 12px;\n  font-weight: 600;\n  color: rgb(var(--color-ink));\n  margin-bottom: 8px;\n}\n\n.ua-comment-compose-input {\n  width: 100%;\n  box-sizing: border-box;\n  /* border: 1px solid rgb(var(--color-line-strong)); */\n  border-radius: 8px;\n  background: rgb(var(--color-surface-raised));\n  color: rgb(var(--color-ink));\n  font-size: 13px;\n  line-height: 1.45;\n  font-family: inherit;\n  resize: vertical;\n  padding: 8px 10px;\n}\n\n.ua-comment-compose-input::placeholder {\n  color: rgb(var(--color-ink-faint));\n}\n\n.ua-comment-compose-btn {\n  margin-top: 8px;\n  border: 1px solid rgb(var(--color-ink));\n  background: rgb(var(--color-ink));\n  color: rgb(var(--color-surface-raised));\n  border-radius: 0.5rem;\n  padding: 6px 12px;\n  font-size: 12px;\n  font-weight: 600;\n  font-family: inherit;\n  cursor: pointer;\n}\n\n.is-active-button {\n  background: rgb(var(--color-ink)) !important;\n  border-color: rgb(var(--color-ink)) !important;\n  color: rgb(var(--color-surface-raised)) !important;\n}\n\n.ua-comment-compose-btn:hover {\n  background: rgb(var(--color-ink-soft));\n  border-color: rgb(var(--color-ink-soft));\n}\n\n.ua-comment-actions {\n  margin-top: 8px;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.ua-comment-action-btn {\n  border: 1px solid rgb(var(--color-line));\n  background: rgb(var(--color-surface-raised));\n  color: rgb(var(--color-ink-soft));\n  border-radius: 0.5rem;\n  padding: 4px 10px;\n  font-size: 12px;\n  font-weight: 600;\n  font-family: inherit;\n  cursor: pointer;\n}\n\n.ua-comment-action-btn:hover {\n  background: rgb(var(--color-surface-overlay));\n}\n\n.ua-comment-reply-input {\n  margin-top: 8px;\n  width: 100%;\n  box-sizing: border-box;\n  border: 1px solid rgb(var(--color-line-strong));\n  border-radius: 8px;\n  font-size: 13px;\n  color: rgb(var(--color-ink));\n  background: rgb(var(--color-surface-raised));\n  padding: 8px 10px;\n  font-family: inherit;\n}\n\n.ua-comment-reply-input::placeholder {\n  color: rgb(var(--color-ink-faint));\n}\n\n.ua-comment-reply-box {\n  margin-top: 8px;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.ua-comment-reply-btn {\n  border: 1px solid rgb(var(--color-ink));\n  background: rgb(var(--color-ink));\n  color: rgb(var(--color-surface-raised));\n  border-radius: 0.5rem;\n  padding: 8px 14px;\n  font-size: 12px;\n  font-weight: 600;\n  font-family: inherit;\n  cursor: pointer;\n  flex-shrink: 0;\n  transition: background 0.15s ease, border-color 0.15s ease;\n}\n\n.ua-comment-reply-btn:hover {\n  background: rgb(var(--color-ink-soft));\n  border-color: rgb(var(--color-ink-soft));\n}\n\n.ua-replies-list {\n  margin-top: 10px;\n  padding-left: 12px;\n  border-left: 2px solid rgb(var(--color-line));\n  display: grid;\n  gap: 8px;\n  animation: pm-fade-in var(--pm-duration, 0.28s) var(--pm-ease, ease);\n}\n\n.ua-reply-card {\n  border: 1px solid rgb(var(--color-line));\n  border-radius: 10px;\n  padding: 8px 10px;\n  background: rgb(var(--color-surface-raised));\n}\n\n.ua-load-more-btn {\n  width: 100%;\n  margin-top: 12px;\n  border: 1px solid rgb(var(--color-line-strong));\n  background: rgb(var(--color-surface-overlay));\n  color: rgb(var(--color-ink));\n  border-radius: 0.5rem;\n  padding: 10px 14px;\n  font-size: 13px;\n  font-weight: 600;\n  font-family: inherit;\n  cursor: pointer;\n  transition: background 0.15s ease, border-color 0.15s ease, color 0.15s ease;\n}\n\n.ua-load-more-btn:hover:not(:disabled) {\n  background: rgb(var(--color-surface-muted));\n  border-color: rgb(var(--color-line-strong));\n}\n\n.ua-load-more-btn:disabled {\n  cursor: not-allowed;\n  opacity: 0.7;\n}\n\n.ua-table-wrap {\n  width: 100%;\n  overflow-x: auto;\n  scrollbar-width: none;\n  -ms-overflow-style: none;\n}\n\n.ua-table-wrap::-webkit-scrollbar {\n  width: 0;\n  height: 0;\n}\n\n.ua-split-tables {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 12px;\n}\n\n.ua-table {\n  width: 100%;\n  min-width: 260px;\n  border-collapse: collapse;\n}\n\n.ua-table th {\n  text-align: left;\n  padding: 8px 6px;\n  font-size: 11px;\n  font-weight: 600;\n  color: rgb(var(--color-ink-faint));\n  border-bottom: 1px solid rgb(var(--color-surface-muted));\n}\n\n.ua-table td {\n  padding: 10px 6px;\n  font-size: 13px;\n  color: rgb(var(--color-ink));\n  font-variant-numeric: tabular-nums;\n  border-bottom: 1px solid rgb(var(--color-surface-overlay));\n}\n\n.ua-activity-list {\n  margin: 0;\n  padding: 0;\n  list-style: none;\n}\n\n.ua-activity-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 16px;\n  padding: 10px 0;\n  border-bottom: 1px solid rgb(var(--color-surface-overlay));\n}\n\n.ua-activity-main {\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.ua-activity-type {\n  font-size: 11px;\n  font-weight: 600;\n  color: rgb(var(--color-ink-faint));\n  text-transform: uppercase;\n}\n\n.ua-activity-detail {\n  font-size: 13px;\n  color: rgb(var(--color-ink));\n  line-height: 1.45;\n}\n\n.ua-activity-meta {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  gap: 2px;\n  flex-shrink: 0;\n}\n\n.ua-activity-value {\n  font-size: 12px;\n  font-weight: 600;\n  color: rgb(var(--color-ink));\n  font-variant-numeric: tabular-nums;\n}\n\n.ua-activity-time {\n  font-size: 11px;\n  color: rgb(var(--color-ink-faint));\n}\n\n@media (max-width: 992px) {\n  .market-detail-layout {\n    grid-template-columns: 1fr;\n    gap: 16px;\n  }\n  .market-detail-order-panel-wrap {\n    max-width: none;\n    justify-self: stretch;\n  }\n  .market-detail-wrapper {\n    max-height: calc(100vh - 108px);\n  }\n  .ua-activity-row {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 6px;\n  }\n  .ua-activity-meta {\n    align-items: flex-start;\n  }\n  .ua-split-tables {\n    grid-template-columns: 1fr;\n  }\n  .ua-top-holders-grid {\n    grid-template-columns: 1fr;\n  }\n  .ua-comment-head {\n    align-items: flex-start;\n    flex-direction: column;\n    gap: 6px;\n  }\n  .ua-comment-reply-box {\n    flex-direction: column;\n    align-items: stretch;\n  }\n  .ua-comment-reply-btn {\n    width: 100%;\n  }\n  .ua-load-more-btn {\n    padding: 10px 12px;\n  }\n}\n\n.market-detail-trade-fab {\n  display: none;\n}\n\n@media (max-width: 992px) {\n  .market-detail-wrapper {\n    padding-bottom: 88px;\n  }\n\n  .market-detail-trade-fab {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    gap: 8px;\n    position: fixed;\n    right: 16px;\n    bottom: 20px;\n    z-index: 900;\n    padding: 14px 20px;\n    border: none;\n    border-radius: 0.5rem;\n    background: rgb(var(--color-accent));\n    color: rgb(var(--color-accent-contrast));\n    font-size: 15px;\n    font-weight: 700;\n    font-family: inherit;\n    cursor: pointer;\n    box-shadow: 0 8px 28px rgb(var(--color-shadow) / 0.2);\n    transition:\n      transform var(--pm-duration-fast, 0.18s) var(--pm-ease-spring, ease),\n      box-shadow var(--pm-duration-fast, 0.18s) var(--pm-ease, ease);\n  }\n\n  .market-detail-trade-fab i {\n    font-size: 14px;\n  }\n\n  .market-detail-trade-fab:hover {\n    transform: translateY(-2px);\n    box-shadow: 0 12px 32px rgb(var(--color-shadow) / 0.28);\n  }\n\n  .market-detail-trade-fab:active {\n    transform: translateY(0);\n  }\n\n  .market-detail-trade-sheet {\n    position: fixed;\n    inset: 0;\n    z-index: 1200;\n    display: flex;\n    flex-direction: column;\n    justify-content: flex-end;\n  }\n\n  .market-detail-trade-sheet-backdrop {\n    position: absolute;\n    inset: 0;\n    border: none;\n    padding: 0;\n    background: rgb(var(--color-ink) / 0.5);\n    backdrop-filter: blur(4px);\n    -webkit-backdrop-filter: blur(4px);\n    cursor: pointer;\n    animation: pm-fade-in var(--pm-duration-fast, 0.18s) var(--pm-ease, ease) both;\n  }\n\n  .market-detail-trade-sheet-content {\n    position: relative;\n    z-index: 1;\n    width: 100%;\n    max-height: min(92vh, 900px);\n    max-height: min(92dvh, 900px);\n    display: flex;\n    flex-direction: column;\n    min-height: 0;\n    overflow: hidden;\n    animation: pm-sheet-slide-up var(--pm-duration, 0.28s) var(--pm-ease, ease) both;\n  }\n}\n\n@media (max-width: 640px) {\n  .market-detail-image {\n    width: 60px;\n    height: 60px;\n  }\n}\n\n/* from src/games/PredictionMarket/components/MarketDetail/OrderPanel/orderPanel.scss */\n/* The panel shell is styled in orderPanel.styles.js; only the scrollbar\n   pseudo-elements, which Tailwind cannot target, remain here. */\n.order-panel::-webkit-scrollbar {\n  width: 6px;\n}\n\n.order-panel::-webkit-scrollbar-thumb {\n  border-radius: 999px;\n  background: rgb(var(--color-line-strong));\n}\n\n.order-panel-disabled .order-panel-submit {\n  opacity: 0.55;\n  cursor: not-allowed;\n}\n\n.order-panel-section {\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n}\n\n.order-panel-field-row {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) minmax(0, 1.15fr);\n  gap: 10px;\n  align-items: end;\n}\n\n.order-panel-field-row .order-panel-field {\n  min-width: 0;\n}\n\n.order-panel-field-row .order-panel-stepper-btn {\n  flex-basis: 40px;\n}\n\n.order-panel-field-row .order-panel-stepper-input {\n  padding-left: 8px;\n  padding-right: 8px;\n}\n\n@container order-panel (max-width: 300px) {\n  .order-panel-field-row {\n    grid-template-columns: 1fr;\n  }\n\n  .order-panel-field-row .order-panel-stepper-btn {\n    flex-basis: 40px;\n  }\n}\n\n.order-panel-section--muted .order-panel-hint {\n  margin: 0 0 4px 0;\n  font-size: 12px;\n  line-height: 1.45;\n  color: rgb(var(--color-ink-faint));\n}\n\n.order-panel-side-toggle {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 0;\n  padding: 3px;\n  border-radius: 10px;\n  background: rgb(var(--color-surface-overlay));\n  /* border: 1px solid rgb(var(--color-line-strong)); */\n}\n\n.order-panel-side-toggle-btn {\n  padding: 10px 12px;\n  border: none;\n  border-radius: 8px;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  font-family: inherit;\n  background: transparent;\n  color: rgb(var(--color-ink-faint));\n  transition: background 0.15s ease, color 0.15s ease;\n}\n\n.order-panel-side-toggle-btn--active {\n  background: rgb(var(--color-surface-raised));\n  color: rgb(var(--color-ink));\n  box-shadow: 0 0 0 1px rgb(var(--color-line-strong)) inset;\n}\n\n.order-panel-outcome {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 8px;\n}\n\n.order-panel-outcome-btn {\n  padding: 12px 10px;\n  border-radius: 0.5rem;\n  border: 1px solid rgb(var(--color-line));\n  background: rgb(var(--color-surface-raised));\n  color: rgb(var(--color-ink-soft));\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  font-family: inherit;\n  font-variant-numeric: tabular-nums;\n  transition: border-color 0.15s ease, background 0.15s ease, box-shadow 0.15s ease;\n}\n\n.order-panel-outcome-btn:hover {\n  border-color: rgb(var(--color-line-strong));\n  background: rgb(var(--color-surface-overlay));\n}\n\n.order-panel-outcome-btn--active {\n  border-color: rgb(var(--color-ink));\n  background: rgb(var(--color-surface-muted));\n  color: rgb(var(--color-ink));\n  box-shadow: 0 0 0 1px rgb(var(--color-shadow) / 0.14);\n}\n\n.order-panel-outcome-btn--yes.order-panel-outcome-btn--active {\n  border-color: rgb(var(--pm-gold));\n  background: rgb(var(--pm-gold) / 0.16);\n  color: rgb(var(--pm-gold));\n  box-shadow: 0 0 0 1px rgb(var(--pm-gold) / 0.28);\n}\n\n.order-panel-outcome-btn--no.order-panel-outcome-btn--active {\n  border-color: rgb(var(--color-danger));\n  background: rgb(var(--color-danger) / 0.12);\n  color: rgb(var(--color-danger-contrast));\n  box-shadow: 0 0 0 1px rgb(var(--color-danger) / 0.22);\n}\n\n.order-panel-field {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  margin: 0;\n}\n\n.order-panel-field-label {\n  font-size: 12px;\n  font-weight: 600;\n  color: rgb(var(--color-ink-faint));\n}\n\n.order-panel-stepper {\n  display: flex;\n  align-items: stretch;\n  border-radius: 10px;\n  border: 1px solid rgb(var(--color-line));\n  background: rgb(var(--color-surface-raised));\n  overflow: hidden;\n}\n\n.order-panel-stepper-btn {\n  flex: 0 0 44px;\n  border: none;\n  background: rgb(var(--color-surface-overlay));\n  color: rgb(var(--color-ink-muted));\n  font-size: 18px;\n  font-weight: 500;\n  line-height: 1;\n  cursor: pointer;\n  font-family: inherit;\n  transition: background 0.12s ease, color 0.12s ease;\n}\n\n.order-panel-stepper-btn:hover {\n  background: rgb(var(--color-surface-muted));\n  color: rgb(var(--color-ink));\n}\n\n.order-panel-stepper-btn:active {\n  background: rgb(var(--color-line));\n}\n\n.order-panel-stepper > .order-panel-stepper-input {\n  border-left: 1px solid rgb(var(--color-line));\n  border-right: 1px solid rgb(var(--color-line));\n}\n\n.order-panel-stepper-input-wrap {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  align-items: center;\n  position: relative;\n  border-left: 1px solid rgb(var(--color-line));\n  border-right: 1px solid rgb(var(--color-line));\n}\n\n.order-panel-stepper-input {\n  flex: 1;\n  min-width: 0;\n  border: none;\n  background: transparent;\n  color: rgb(var(--color-ink));\n  font-size: 15px;\n  font-weight: 600;\n  font-variant-numeric: tabular-nums;\n  padding: 12px 10px;\n  text-align: center;\n  outline: none;\n  font-family: inherit;\n}\n\n.order-panel-stepper-input::placeholder {\n  color: rgb(var(--color-ink-faint));\n}\n\n.order-panel-stepper-input--cents {\n  padding-right: 22px;\n  text-align: center;\n}\n\n.order-panel-suffix {\n  position: absolute;\n  right: 10px;\n  font-size: 13px;\n  font-weight: 600;\n  color: rgb(var(--color-ink-faint));\n  pointer-events: none;\n}\n\n.order-panel-submit {\n  margin-top: 4px;\n  width: 100%;\n  padding: 11px 14px;\n  border: 1px solid rgb(var(--pm-gold) / 0.55);\n  border-radius: 0.5rem;\n  background: linear-gradient(\n    180deg,\n    rgb(var(--pm-gold)) 0%,\n    rgb(var(--pm-gold-dark, 203 125 0)) 100%\n  );\n  color: rgb(var(--color-accent-contrast));\n  font-size: 13px;\n  font-weight: 700;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  cursor: pointer;\n  font-family: inherit;\n  transition: filter 0.15s ease, transform 0.05s ease, box-shadow 0.15s ease;\n  box-shadow: 0 2px 8px rgb(var(--pm-gold) / 0.28);\n}\n\n.order-panel-submit:disabled {\n  opacity: 0.55;\n  cursor: not-allowed;\n  filter: none;\n  transform: none;\n  box-shadow: none;\n}\n\n.order-panel-submit:hover {\n  filter: brightness(1.06);\n}\n\n.order-panel-submit:hover:disabled {\n  filter: none;\n}\n\n.order-panel-submit:active {\n  transform: scale(0.99);\n}\n\n.order-panel-submit:active:disabled {\n  transform: none;\n}\n\n.order-panel-error-message {\n  margin: 8px 0 0;\n  font-size: 12px;\n  font-weight: 600;\n  line-height: 1.4;\n  color: rgb(var(--color-danger));\n}\n\n.order-panel-market-tab-summary,\n.order-panel-limit-tab-summary {\n  margin-top: 2px;\n  padding: 10px 12px;\n  /* border: 1px solid rgb(var(--color-line-strong)); */\n  border-radius: 10px;\n  background: rgb(var(--color-surface-overlay));\n}\n\n.order-panel-summary-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  gap: 6px 10px;\n  color: rgb(var(--color-ink-soft));\n  font-size: 12px;\n  font-weight: 600;\n  line-height: 1.4;\n}\n\n.order-panel-summary-label {\n  color: rgb(var(--color-ink-faint));\n  font-weight: 600;\n}\n\n.order-panel-commission-rate {\n  margin-left: 2px;\n  color: rgb(var(--color-warning));\n  font-size: 11px;\n  font-weight: 500;\n}\n\n.order-panel-summary-value {\n  color: rgb(var(--color-ink));\n  font-weight: 600;\n  font-variant-numeric: tabular-nums;\n}\n\n.order-panel-summary-row + .order-panel-summary-row {\n  margin-top: 8px;\n}\n\n.order-panel-fee-note {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  margin-top: 8px;\n}\n\n.order-panel-fee-note-copy {\n  margin: 0;\n  color: rgb(var(--color-ink-soft));\n  font-size: 12px;\n  font-weight: 600;\n  line-height: 1.4;\n}\n\n.order-panel-fee-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 12px;\n  font-variant-numeric: tabular-nums;\n}\n\n.order-panel-fee-table-caption {\n  caption-side: top;\n  text-align: left;\n  margin-bottom: 6px;\n  color: rgb(var(--color-ink-faint));\n  font-size: 11px;\n  font-weight: 700;\n}\n\n.order-panel-fee-table th,\n.order-panel-fee-table td {\n  padding: 6px 0;\n  border-bottom: 1px solid rgb(var(--color-line));\n  text-align: left;\n}\n\n.order-panel-fee-table th:last-child,\n.order-panel-fee-table td:last-child {\n  text-align: right;\n}\n\n.order-panel-fee-table th {\n  color: rgb(var(--color-ink-faint));\n  font-weight: 700;\n}\n\n.order-panel-submit--secondary {\n  background: rgb(var(--color-surface-muted));\n  color: rgb(var(--color-ink));\n  border: 1px solid rgb(var(--color-line-strong));\n  box-shadow: none;\n  letter-spacing: 0.02em;\n  text-transform: none;\n}\n\n.order-panel-submit--secondary:hover {\n  background: rgb(var(--color-line));\n  filter: none;\n}\n\n/* Match market detail stack breakpoint (992px) — mobile uses sheet modal */\n@media (max-width: 992px) {\n  .market-detail-order-panel-wrap {\n    position: static;\n    top: auto;\n    max-height: none;\n  }\n\n  .market-detail-order-panel-wrap .order-panel {\n    height: auto;\n    max-height: none;\n  }\n}\n@media (max-width: 480px) {\n  .order-panel-stepper-btn {\n    flex-basis: 40px;\n  }\n}\n\n/* from src/games/PredictionMarket/components/MarketDetail/OptionList/optionList.scss */\n.option-detail-toolbar {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 8px;\n  margin-bottom: 12px;\n  row-gap: 10px;\n}\n\n.option-detail-tabs {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  flex-shrink: 0;\n}\n\n.option-detail-book-tabs {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  flex-shrink: 0;\n  margin-left: auto;\n}\n\n.option-detail-tab {\n  border: 1px solid rgb(var(--color-line));\n  border-radius: 999px;\n  background: rgb(var(--color-surface-raised));\n  color: rgb(var(--color-ink-faint));\n  font-size: 13px;\n  font-weight: 600;\n  font-family: inherit;\n  padding: 7px 12px;\n  cursor: pointer;\n  white-space: nowrap;\n  line-height: 1.2;\n}\n\n.option-detail-tab--active {\n  color: rgb(var(--color-ink));\n  background: rgb(var(--color-accent-soft));\n  border-color: rgb(var(--color-line-strong));\n}\n\n.option-detail-tab--yes.option-detail-tab--active {\n  color: rgb(var(--pm-gold));\n  background: rgb(var(--pm-gold) / 0.14);\n  border-color: rgb(var(--pm-gold));\n}\n\n.option-detail-tab--no.option-detail-tab--active {\n  color: rgb(var(--color-danger-contrast));\n  background: rgb(var(--color-danger) / 0.12);\n  border-color: rgb(var(--color-danger));\n}\n\n.option-orderbook {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.option-orderbook-grid {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.book-side {\n  /* border: 1px solid rgb(var(--color-line-strong)); */\n  border-radius: 10px;\n  padding: 12px;\n  /* background: rgb(var(--color-surface-raised)); */\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.book-side-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.book-side-title {\n  margin: 0;\n  font-size: 13px;\n  font-weight: 600;\n  color: rgb(var(--color-ink));\n  letter-spacing: 0.02em;\n}\n\n.book-block {\n  border: 1px solid rgb(var(--color-line));\n  border-radius: 8px;\n  overflow: hidden;\n  background: rgb(var(--color-surface-overlay));\n}\n\n.book-block--ask {\n  border-color: rgb(var(--color-danger-soft));\n  background: rgb(var(--color-danger-soft));\n}\n\n.book-block--bid {\n  border-color: rgb(var(--color-success-soft));\n  background: rgb(var(--color-success-soft));\n}\n\n.book-block-heading {\n  padding: 6px 10px;\n  border-bottom: 1px solid rgb(var(--color-line));\n  background: rgb(var(--color-surface-raised));\n}\n\n.book-block--ask .book-block-heading {\n  border-bottom-color: rgb(var(--color-danger-soft));\n}\n\n.book-block--bid .book-block-heading {\n  border-bottom-color: rgb(var(--color-success-soft));\n}\n\n.book-block-side {\n  font-size: 10px;\n  font-weight: 700;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  color: rgb(var(--color-ink-faint));\n}\n\n.book-block--ask .book-block-side {\n  color: rgb(var(--color-danger-contrast));\n}\n\n.book-block--bid .book-block-side {\n  color: rgb(var(--color-success-contrast));\n}\n\n.book-grid {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr) minmax(0, 1fr);\n  column-gap: 8px;\n  align-items: center;\n  padding: 0 10px;\n}\n\n.book-grid--header {\n  min-height: 28px;\n  font-size: 11px;\n  font-weight: 600;\n  /* color: rgb(var(--color-ink-faint)); */\n  background: rgb(var(--color-surface-raised));\n  border-bottom: 1px solid rgb(var(--color-line));\n}\n\n.book-block--ask .book-grid--header {\n  border-bottom-color: rgb(var(--color-danger-soft));\n}\n\n.book-block--bid .book-grid--header {\n  border-bottom-color: rgb(var(--color-success-soft));\n}\n\n.book-grid-body {\n  max-height: 168px;\n  overflow-y: auto;\n  overflow-x: hidden;\n  scrollbar-gutter: stable;\n  padding: 4px 0;\n}\n.book-grid-body::-webkit-scrollbar {\n  width: 6px;\n}\n.book-grid-body::-webkit-scrollbar-thumb {\n  background: rgb(var(--color-line-strong));\n  border-radius: 3px;\n}\n\n.book-grid--row {\n  min-height: 28px;\n  margin: 0 4px 2px;\n  padding: 0 6px;\n  border-radius: 4px;\n  font-size: 12px;\n  color: rgb(var(--color-ink));\n  font-variant-numeric: tabular-nums;\n}\n\n.book-grid-col--right {\n  text-align: right;\n}\n\n.book-row {\n  --row-fill: 0%;\n  background: linear-gradient(to right, var(--row-color) 0, var(--row-color) var(--row-fill), transparent var(--row-fill), transparent 100%);\n}\n\n.book-row--ask {\n  --row-color: rgb(var(--color-danger) / 0.18);\n}\n\n.book-row--bid {\n  --row-color: rgb(var(--color-success) / 0.18);\n}\n\n.book-row--ask.book-row--user-order {\n  --row-color: rgb(var(--color-danger) / 0.42);\n  box-shadow: inset 3px 0 0 rgb(var(--color-danger));\n  font-weight: 700;\n}\n\n.book-row--bid.book-row--user-order {\n  --row-color: rgb(var(--color-success) / 0.42);\n  box-shadow: inset 3px 0 0 rgb(var(--color-success));\n  font-weight: 700;\n}\n\n.book-row-you {\n  margin-left: 6px;\n  padding: 1px 5px;\n  border-radius: 3px;\n  font-size: 10px;\n  font-style: normal;\n  font-weight: 700;\n  letter-spacing: 0.02em;\n  color: rgb(var(--color-ink));\n  background: rgb(var(--color-accent-soft));\n  border: 1px solid rgb(var(--color-line-strong));\n  vertical-align: middle;\n}\n\n.book-spread-bar {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  margin: 2px 0;\n  padding: 8px 10px;\n  border: 1px dashed rgb(var(--color-line-strong));\n  border-radius: 8px;\n  background: rgb(var(--color-surface-muted));\n}\n\n.book-spread-label {\n  font-size: 11px;\n  font-weight: 600;\n  /* color: rgb(var(--color-ink-faint)); */\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n}\n\n.book-spread-value {\n  font-size: 12px;\n  font-weight: 600;\n  color: rgb(var(--color-ink));\n  font-variant-numeric: tabular-nums;\n}\n\n.book-empty-row {\n  padding: 12px 10px;\n  text-align: center;\n  font-size: 12px;\n  /* color: rgb(var(--color-ink-faint)); */\n}\n\n.option-graph {\n  /* border: 1px solid rgb(var(--color-line-strong)); */\n  border-radius: 12px;\n  padding: 10px 10px 8px;\n  /* background: rgb(var(--color-surface-raised)); */\n}\n\n.option-graph-legend {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  margin-top: 6px;\n}\n\n.option-graph-legend-item {\n  border-radius: 999px;\n  padding: 4px 8px;\n  font-size: 11px;\n  font-weight: 600;\n}\n\n.option-graph-legend-item--yes-bid {\n  background: rgb(var(--color-success-soft));\n  color: rgb(var(--color-success-contrast));\n}\n\n.option-graph-legend-item--yes-ask {\n  background: rgb(var(--color-success-soft));\n  color: rgb(var(--color-success-contrast));\n}\n\n.option-graph-legend-item--no-bid {\n  background: rgb(var(--color-info-soft));\n  color: rgb(var(--color-info-contrast));\n}\n\n.option-graph-legend-item--no-ask {\n  background: rgb(var(--color-info-soft));\n  color: rgb(var(--color-info-contrast));\n}\n\n@media (max-width: 640px) {\n  .option-orderbook-grid {\n    gap: 10px;\n  }\n\n  .option-detail-toolbar {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .option-detail-tabs,\n  .option-detail-book-tabs {\n    margin-left: 0;\n    width: 100%;\n  }\n\n  .option-detail-tab {\n    flex: 1 1 auto;\n    text-align: center;\n    font-size: 12px;\n    padding: 8px 10px;\n  }\n}\n\n/* from src/games/PredictionMarket/components/Portfolio/portfolio.scss */\n.portfolio-page {\n  width: min(100%, calc(100% - var(--pm-content-pad, 12px) * 2));\n  max-width: 1400px;\n  margin: 10px auto 0;\n  padding: 0 4px 16px;\n  box-sizing: border-box;\n  animation: pm-fade-in-up var(--pm-duration-slow, 0.36s) var(--pm-ease, ease) both;\n}\n\n.portfolio-summary-wrap {\n  margin-bottom: 12px;\n}\n\n.portfolio-summary-card,\n.portfolio-tabs-card {\n  border: 1px solid rgb(var(--color-line-strong));\n  border-radius: var(--pm-radius, 8px);\n  background: linear-gradient(\n    180deg,\n    rgb(var(--color-surface-raised)) 0%,\n    rgb(var(--color-surface-muted) / 0.45) 100%\n  );\n  box-shadow: inset 0 1px 0 rgb(var(--pm-gold) / 0.06);\n}\n\n.portfolio-summary-card {\n  padding: 12px;\n}\n\n.portfolio-summary-head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 14px;\n  margin-bottom: 14px;\n}\n\n.portfolio-summary-caption {\n  margin: 0 0 4px 0;\n  font-size: 12px;\n  font-weight: 600;\n  color: rgb(var(--color-ink-faint));\n  text-transform: uppercase;\n}\n\n.portfolio-summary-title {\n  margin: 0;\n  font-size: 23px;\n  line-height: 1.2;\n  letter-spacing: -0.01em;\n  color: rgb(var(--color-ink));\n}\n\n.portfolio-summary-actions {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.portfolio-action-btn {\n  border: 1px solid rgb(var(--color-line-strong));\n  border-radius: 0.5rem;\n  padding: 8px 14px;\n  background: rgb(var(--color-surface-raised));\n  color: rgb(var(--color-ink));\n  font-size: 13px;\n  font-weight: 600;\n  font-family: inherit;\n  cursor: pointer;\n}\n\n.portfolio-action-btn:hover {\n  background: rgb(var(--color-surface-overlay));\n}\n\n.portfolio-action-btn--primary {\n  background: rgb(var(--color-ink));\n  border-color: rgb(var(--color-ink));\n  color: rgb(var(--color-surface-raised));\n}\n\n.portfolio-action-btn--primary:hover {\n  background: rgb(var(--color-ink-soft));\n  border-color: rgb(var(--color-ink-soft));\n}\n\n.portfolio-metrics-grid {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 10px;\n  margin-bottom: 14px;\n}\n\n.portfolio-metric-card {\n  border: 1px solid rgb(var(--color-line));\n  border-radius: 12px;\n  background: rgb(var(--color-surface-overlay));\n  padding: 10px;\n}\n\n.portfolio-metric-label {\n  margin: 0 0 6px 0;\n  font-size: 12px;\n  color: rgb(var(--color-ink-faint));\n  font-weight: 600;\n}\n\n.portfolio-metric-label-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  margin-bottom: 6px;\n}\n\n.portfolio-metric-label-row .portfolio-metric-label {\n  margin: 0;\n}\n\n.portfolio-commission-btn {\n  flex-shrink: 0;\n  border: 1px solid rgb(var(--color-line));\n  border-radius: 0.5rem;\n  background: transparent;\n  padding: 2px 8px;\n  font-size: 10px;\n  font-weight: 600;\n  color: rgb(var(--color-ink-faint));\n  cursor: pointer;\n  line-height: 1.4;\n  white-space: nowrap;\n}\n\n.portfolio-commission-btn:hover {\n  border-color: rgb(var(--color-ink-faint));\n  color: rgb(var(--color-ink));\n}\n\n.portfolio-commission-btn--active {\n  border-color: rgb(var(--color-ink-faint));\n  background: rgb(var(--color-surface-muted));\n  color: rgb(var(--color-ink));\n}\n\n.portfolio-metric-value {\n  margin: 0;\n  font-size: 22px;\n  font-weight: 600;\n  color: rgb(var(--color-ink));\n  line-height: 1.25;\n  font-variant-numeric: tabular-nums;\n}\n\n.portfolio-metric-value--positive {\n  color: rgb(var(--color-success-contrast));\n}\n\n.portfolio-metric-value--negative {\n  color: rgb(var(--color-danger-contrast));\n}\n\n.portfolio-metric-commission {\n  font-size: 14px;\n  font-weight: 500;\n  color: rgb(var(--color-ink-faint));\n}\n\n.portfolio-profit-graph {\n  border: 1px solid rgb(var(--color-line));\n  border-radius: 12px;\n  padding: 10px 8px 2px;\n}\n\n.portfolio-profit-graph-head {\n  padding: 0 8px;\n}\n\n.portfolio-profit-title {\n  margin: 0 0 8px 0;\n  font-size: 14px;\n  font-weight: 600;\n  color: rgb(var(--color-ink));\n}\n\n.portfolio-tooltip {\n  background: rgb(var(--color-surface-raised));\n  border: 1px solid rgb(var(--color-line));\n  border-radius: 10px;\n  box-shadow: 0 8px 20px rgb(var(--color-shadow) / 0.08);\n  padding: 8px 10px;\n}\n\n.portfolio-tooltip-time {\n  margin: 0 0 6px 0;\n  border-bottom: 1px solid rgb(var(--color-surface-muted));\n  padding-bottom: 6px;\n  font-size: 11px;\n  color: rgb(var(--color-ink-faint));\n}\n\n.portfolio-tooltip-profit {\n  margin: 0;\n  font-size: 13px;\n  font-weight: 600;\n}\n\n.portfolio-tooltip-profit--up {\n  color: rgb(var(--color-success-contrast));\n}\n\n.portfolio-tooltip-profit--down {\n  color: rgb(var(--color-danger-contrast));\n}\n\n.portfolio-tabs-card {\n  padding: 18px 18px 16px;\n}\n\n.portfolio-activity-head {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 16px;\n  margin-bottom: 16px;\n}\n\n.portfolio-activity-eyebrow {\n  margin: 0 0 4px;\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: rgb(var(--color-ink-faint));\n}\n\n.portfolio-activity-title {\n  margin: 0;\n  font-size: 22px;\n  line-height: 1.2;\n  letter-spacing: -0.02em;\n  color: rgb(var(--color-ink));\n}\n\n.portfolio-history-controls {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  min-width: 0;\n  flex-shrink: 0;\n}\n\n.portfolio-search-wrap {\n  position: relative;\n  display: flex;\n  align-items: center;\n}\n\n.portfolio-search-icon {\n  position: absolute;\n  left: 12px;\n  font-size: 12px;\n  color: rgb(var(--color-ink-faint));\n  pointer-events: none;\n}\n\n.portfolio-search-input {\n  height: 38px;\n  min-width: 240px;\n  border: 1px solid rgb(var(--color-line));\n  border-radius: 12px;\n  padding: 0 12px 0 34px;\n  font-size: 13px;\n  color: rgb(var(--color-ink));\n  background: rgb(var(--color-surface-overlay));\n  transition: border-color 0.15s ease, background 0.15s ease, box-shadow 0.15s ease;\n}\n\n.portfolio-search-input:focus {\n  outline: none;\n  border-color: rgb(var(--color-info));\n  background: rgb(var(--color-surface-raised));\n  box-shadow: 0 0 0 3px rgb(var(--color-info) / 0.1);\n}\n\n.portfolio-refresh-btn {\n  width: 38px;\n  height: 38px;\n  border: 1px solid rgb(var(--color-line));\n  border-radius: 0.5rem;\n  background: rgb(var(--color-surface-overlay));\n  color: rgb(var(--color-ink-muted));\n  cursor: pointer;\n  transition: all 0.15s ease;\n}\n\n.portfolio-refresh-btn:hover {\n  color: rgb(var(--color-ink));\n  background: rgb(var(--color-surface-raised));\n  border-color: rgb(var(--color-line-strong));\n}\n\n.portfolio-activity-tabs {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 10px;\n  margin-bottom: 14px;\n}\n\n.portfolio-tab-btn {\n  position: relative;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  min-width: 0;\n  padding: 12px 14px;\n  border: 1px solid rgb(var(--color-line));\n  border-radius: 14px;\n  background: linear-gradient(180deg, rgb(var(--color-surface-raised)) 0%, rgb(var(--color-surface-overlay)) 100%);\n  color: rgb(var(--color-ink-faint));\n  font-size: 13px;\n  font-weight: 700;\n  font-family: inherit;\n  cursor: pointer;\n  overflow: hidden;\n  transition: transform 0.15s ease, border-color 0.15s ease, box-shadow 0.15s ease;\n}\n\n.portfolio-tab-btn::before {\n  content: \"\";\n  position: absolute;\n  inset: 0 auto auto 0;\n  width: 100%;\n  height: 3px;\n  opacity: 0;\n  transition: opacity 0.15s ease;\n}\n\n.portfolio-tab-btn--positions::before {\n  background: linear-gradient(90deg, rgb(var(--color-success)), rgb(var(--color-success)));\n}\n\n.portfolio-tab-btn--orders::before {\n  background: linear-gradient(90deg, rgb(var(--color-info)), rgb(var(--color-info)));\n}\n\n.portfolio-tab-btn--history::before {\n  background: linear-gradient(90deg, rgb(var(--color-info)), rgb(var(--color-info)));\n}\n\n.portfolio-tab-btn:hover {\n  transform: translateY(-1px);\n  border-color: rgb(var(--color-line-strong));\n  box-shadow: 0 8px 20px rgb(var(--color-shadow) / 0.06);\n  color: rgb(var(--color-ink));\n}\n\n.portfolio-tab-btn--active {\n  color: rgb(var(--color-ink));\n  border-color: transparent;\n  box-shadow: 0 10px 24px rgb(var(--color-shadow) / 0.08);\n}\n\n.portfolio-tab-btn--active::before {\n  opacity: 1;\n}\n\n.portfolio-tab-btn--active.portfolio-tab-btn--positions {\n  background: linear-gradient(180deg, rgb(var(--color-success-soft)) 0%, rgb(var(--color-surface-raised)) 72%);\n}\n\n.portfolio-tab-btn--active.portfolio-tab-btn--orders {\n  background: linear-gradient(180deg, rgb(var(--color-info-soft)) 0%, rgb(var(--color-surface-raised)) 72%);\n}\n\n.portfolio-tab-btn--active.portfolio-tab-btn--history {\n  background: linear-gradient(180deg, rgb(var(--color-info-soft)) 0%, rgb(var(--color-surface-raised)) 72%);\n}\n\n.portfolio-tab-btn-icon {\n  width: 34px;\n  height: 34px;\n  border-radius: 10px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  font-size: 14px;\n  background: rgb(var(--color-surface-muted));\n  color: rgb(var(--color-ink-faint));\n}\n\n.portfolio-tab-btn--active.portfolio-tab-btn--positions .portfolio-tab-btn-icon {\n  background: rgb(var(--color-success-soft));\n  color: rgb(var(--color-success-contrast));\n}\n\n.portfolio-tab-btn--active.portfolio-tab-btn--orders .portfolio-tab-btn-icon {\n  background: rgb(var(--color-info-soft));\n  color: rgb(var(--color-info-contrast));\n}\n\n.portfolio-tab-btn--active.portfolio-tab-btn--history .portfolio-tab-btn-icon {\n  background: rgb(var(--color-info-soft));\n  color: rgb(var(--color-info-contrast));\n}\n\n.portfolio-tab-btn-label {\n  flex: 1;\n  text-align: left;\n  min-width: 0;\n}\n\n.portfolio-tab-count {\n  min-width: 22px;\n  height: 22px;\n  padding: 0 6px;\n  border-radius: 999px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 11px;\n  font-weight: 700;\n  font-variant-numeric: tabular-nums;\n  background: rgb(var(--color-shadow) / 0.06);\n  color: rgb(var(--color-ink-soft));\n}\n\n.portfolio-tab-btn--active .portfolio-tab-count {\n  background: rgb(var(--color-shadow) / 0.1);\n}\n\n.portfolio-tab-panel {\n  --panel-accent: rgb(var(--color-ink-faint));\n  --panel-accent-soft: rgb(var(--color-surface-overlay));\n  --panel-row-accent: rgb(var(--color-line));\n  min-height: 84px;\n}\n\n.portfolio-tab-panel--positions {\n  --panel-accent: rgb(var(--color-success));\n  --panel-accent-soft: rgb(var(--color-success-soft));\n  --panel-row-accent: rgb(var(--color-success));\n}\n\n.portfolio-tab-panel--orders {\n  --panel-accent: rgb(var(--color-info));\n  --panel-accent-soft: rgb(var(--color-info-soft));\n  --panel-row-accent: rgb(var(--color-info));\n}\n\n.portfolio-tab-panel--history {\n  --panel-accent: rgb(var(--color-info));\n  --panel-accent-soft: rgb(var(--color-info-soft));\n  --panel-row-accent: rgb(var(--color-info));\n}\n\n.portfolio-orders-filters {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px;\n  margin-bottom: 12px;\n}\n\n.portfolio-orders-filters .portfolio-activity-filter {\n  margin: 0;\n  flex: 1 1 220px;\n}\n\n.portfolio-order-type-filter {\n  flex: 0 1 180px;\n}\n\n.portfolio-activity-filter {\n  margin: 0 0 12px;\n  padding: 8px 12px;\n  border-radius: 12px;\n  background: linear-gradient(90deg, color-mix(in srgb, var(--panel-accent) 8%, transparent), transparent);\n  border: 1px solid color-mix(in srgb, var(--panel-accent) 14%, rgb(var(--color-line)));\n}\n\n.portfolio-tab-panel .molecule-common-filter-btn--active {\n  border-color: color-mix(in srgb, var(--panel-accent) 30%, rgb(var(--color-line-strong)));\n  background: var(--panel-accent-soft);\n  color: rgb(var(--color-ink));\n}\n\n.portfolio-tab-panel .molecule-empty-panel {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  min-height: 200px;\n  padding: 24px 16px;\n  border-radius: 16px;\n  background: linear-gradient(180deg, var(--panel-accent-soft), rgb(var(--color-surface-raised)) 70%);\n  border: 1px dashed color-mix(in srgb, var(--panel-accent) 22%, rgb(var(--color-line-strong)));\n}\n\n.portfolio-tab-panel .molecule-empty-title {\n  font-size: 16px;\n  font-weight: 700;\n}\n\n.portfolio-tab-panel .molecule-loader-wrap {\n  min-height: 180px;\n}\n\n.portfolio-tab-panel .molecule-table-wrap {\n  border-radius: 14px;\n  overflow: hidden;\n  border: 1px solid rgb(var(--color-line));\n}\n\n.portfolio-tab-panel .molecule-table-head {\n  background: linear-gradient(180deg, var(--panel-accent-soft), rgb(var(--color-surface-raised)));\n}\n\n.portfolio-tab-panel .molecule-table-th {\n  padding: 10px 12px;\n  font-size: 10px;\n  font-weight: 800;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  color: var(--panel-accent);\n  border-bottom: 1px solid color-mix(in srgb, var(--panel-accent) 12%, rgb(var(--color-surface-muted)));\n  white-space: nowrap;\n}\n\n.portfolio-tab-panel .molecule-table-tr {\n  transition: background 0.12s ease, box-shadow 0.12s ease;\n}\n\n.portfolio-tab-panel .molecule-table-tr--clickable:hover {\n  background: color-mix(in srgb, var(--panel-accent-soft) 55%, rgb(var(--color-surface-raised)));\n}\n\n.portfolio-tab-panel .molecule-table-td {\n  padding: 12px;\n  font-size: 13px;\n  border-bottom: 1px solid rgb(var(--color-surface-muted));\n  vertical-align: middle;\n}\n\n.portfolio-tab-panel .molecule-table-body .molecule-table-tr {\n  border-left: 3px solid transparent;\n}\n\n.portfolio-tab-panel .molecule-table-body .molecule-table-tr--clickable:hover {\n  border-left-color: var(--panel-row-accent);\n}\n\n.portfolio-tab-panel .molecule-table-thumbnail {\n  width: 44px;\n  height: 44px;\n  border-radius: 12px;\n  box-shadow: 0 4px 12px rgb(var(--color-shadow) / 0.08);\n}\n\n.portfolio-tab-panel .molecule-table-td[data-label=Title],\n.portfolio-tab-panel .molecule-table-td[data-label=\"Question Title\"] {\n  font-weight: 700;\n  color: rgb(var(--color-ink));\n  max-width: 220px;\n}\n\n.portfolio-tab-panel .molecule-table-td[data-label=\"To Win\"] {\n  font-weight: 700;\n  font-size: 14px;\n}\n\n.portfolio-tab-panel .molecule-table-td[data-label=\"Realized Pnl\"] {\n  font-weight: 700;\n}\n\n.portfolio-tab-panel .molecule-table-td[data-label=\"Realized Pnl\"].positive-pnl {\n  font-weight: 700;\n  color: rgb(var(--color-success-contrast));\n}\n\n.portfolio-tab-panel .molecule-table-td[data-label=\"Realized Pnl\"].negative-pnl {\n  font-weight: 700;\n  color: rgb(var(--color-danger-contrast));\n}\n\n.portfolio-tab-panel .molecule-table-td[data-label=Price] {\n  font-weight: 800;\n  color: rgb(var(--color-info-contrast));\n  font-size: 15px;\n}\n\n.portfolio-tab-panel .molecule-table-td[data-label=Side] {\n  font-weight: 800;\n  font-size: 11px;\n  letter-spacing: 0.05em;\n  text-transform: uppercase;\n}\n\n.portfolio-tab-panel .molecule-table-td[data-label=Outcome] {\n  font-weight: 800;\n  font-size: 11px;\n  letter-spacing: 0.05em;\n  text-transform: uppercase;\n}\n\n.portfolio-tab-panel--positions .molecule-table-td[data-label=\"Yes Shares\"],\n.portfolio-tab-panel--positions .molecule-table-td[data-label=\"No Shares\"] {\n  font-weight: 700;\n}\n\n.portfolio-tab-panel--history .molecule-table-td[data-label=Description] {\n  font-weight: 600;\n  line-height: 1.45;\n  max-width: 360px;\n}\n\n.portfolio-tab-panel .molecule-table-action-btn {\n  border-color: rgb(var(--color-danger-soft));\n  background: rgb(var(--color-danger-soft));\n  color: rgb(var(--color-danger-contrast));\n  border-radius: 0.5rem;\n  font-weight: 700;\n}\n\n.portfolio-tab-panel .molecule-table-action-btn:hover {\n  background: rgb(var(--color-danger-soft));\n  border-color: rgb(var(--color-danger-soft));\n}\n\n.portfolio-tab-panel .molecule-table-pagination {\n  padding: 12px 4px 4px;\n}\n\n.portfolio-empty-title {\n  margin: 0;\n  font-size: 15px;\n  font-weight: 600;\n  color: rgb(var(--color-ink));\n}\n\n.portfolio-empty-caption {\n  margin: 6px 0 0 0;\n  font-size: 13px;\n  color: rgb(var(--color-ink-faint));\n  line-height: 1.5;\n}\n\n.portfolio-chart-empty {\n  height: 220px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  padding: 0 10px;\n}\n\n.wallet-activity-overlay {\n  position: fixed;\n  inset: 0;\n  z-index: 1200;\n  background: rgb(var(--color-shadow) / 0.45);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 16px;\n}\n\n.wallet-activity-modal {\n  width: min(420px, 100%);\n  position: relative;\n  border-radius: 14px;\n  background: rgb(var(--color-surface-raised));\n  border: 1px solid rgb(var(--color-line));\n  box-shadow: 0 18px 40px rgb(var(--color-shadow) / 0.18);\n  padding: 18px;\n}\n\n.wallet-activity-close {\n  position: absolute;\n  top: 10px;\n  right: 10px;\n  border: 1px solid rgb(var(--color-line-strong));\n  border-radius: 999px;\n  width: 28px;\n  height: 28px;\n  background: rgb(var(--color-surface-raised));\n  color: rgb(var(--color-ink-soft));\n  cursor: pointer;\n  line-height: 1;\n  font-size: 14px;\n}\n\n.wallet-activity-title {\n  margin: 0 0 14px 0;\n  color: rgb(var(--color-ink));\n  font-size: 20px;\n  font-weight: 700;\n}\n\n.wallet-activity-form {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.wallet-activity-label {\n  font-size: 13px;\n  font-weight: 600;\n  color: rgb(var(--color-ink-muted));\n}\n\n.wallet-activity-input {\n  height: 42px;\n  border-radius: 10px;\n  border: 1px solid rgb(var(--color-line-strong));\n  padding: 0 12px;\n  font-size: 14px;\n  color: rgb(var(--color-ink));\n  background: rgb(var(--color-surface-raised));\n}\n\n.wallet-activity-input:focus {\n  outline: none;\n  border-color: rgb(var(--color-ink-faint));\n}\n\n.wallet-activity-submit {\n  margin-top: 6px;\n  height: 42px;\n  border: 0;\n  border-radius: 0.5rem;\n  font-size: 14px;\n  font-weight: 700;\n  font-family: inherit;\n  color: rgb(var(--color-surface-raised));\n  background: rgb(var(--color-ink));\n  cursor: pointer;\n}\n\n.wallet-activity-submit:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n@media (max-width: 992px) {\n  .portfolio-page {\n    width: min(1200px, calc(100% - 20px));\n    margin-top: 16px;\n    padding-bottom: 20px;\n  }\n  .portfolio-summary-title {\n    font-size: 20px;\n  }\n  .portfolio-summary-head {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n  .portfolio-metrics-grid {\n    grid-template-columns: 1fr;\n  }\n  .portfolio-metric-value {\n    font-size: 20px;\n  }\n  .portfolio-activity-head {\n    flex-direction: column;\n    align-items: stretch;\n  }\n  .portfolio-history-controls {\n    width: 100%;\n  }\n  .portfolio-search-input {\n    flex: 1;\n    min-width: 0;\n    width: 100%;\n  }\n  .portfolio-activity-tabs {\n    grid-template-columns: 1fr;\n  }\n}\n@media (max-width: 768px) {\n  .portfolio-tab-panel .molecule-table,\n  .portfolio-tab-panel .molecule-table-head,\n  .portfolio-tab-panel .molecule-table-body,\n  .portfolio-tab-panel .molecule-table-tr,\n  .portfolio-tab-panel .molecule-table-th,\n  .portfolio-tab-panel .molecule-table-td {\n    display: block;\n    width: 100%;\n  }\n  .portfolio-tab-panel .molecule-table-head {\n    position: absolute;\n    width: 1px;\n    height: 1px;\n    padding: 0;\n    margin: -1px;\n    overflow: hidden;\n    clip: rect(0, 0, 0, 0);\n    white-space: nowrap;\n    border: 0;\n  }\n  .portfolio-tab-panel .molecule-table-body .molecule-table-tr {\n    margin-bottom: 10px;\n    padding: 12px;\n    border: 1px solid rgb(var(--color-line));\n    border-left: 3px solid var(--panel-row-accent);\n    border-radius: 14px;\n    background: rgb(var(--color-surface-raised));\n    box-shadow: 0 4px 14px rgb(var(--color-shadow) / 0.04);\n  }\n  .portfolio-tab-panel .molecule-table-body .molecule-table-tr--clickable:hover {\n    box-shadow: 0 8px 20px rgb(var(--color-shadow) / 0.07);\n  }\n  .portfolio-tab-panel .molecule-table-td {\n    display: grid;\n    grid-template-columns: minmax(90px, 38%) 1fr;\n    gap: 8px;\n    align-items: baseline;\n    padding: 7px 0;\n    border-bottom: 1px solid rgb(var(--color-surface-overlay));\n  }\n  .portfolio-tab-panel .molecule-table-td:last-child {\n    border-bottom: 0;\n  }\n  .portfolio-tab-panel .molecule-table-td::before {\n    content: attr(data-label);\n    font-size: 10px;\n    font-weight: 800;\n    letter-spacing: 0.05em;\n    text-transform: uppercase;\n    color: rgb(var(--color-ink-faint));\n  }\n  .portfolio-tab-panel .molecule-table-td--thumbnail {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    grid-template-columns: 1fr;\n    padding-bottom: 10px;\n    margin-bottom: 4px;\n    border-bottom: 1px solid rgb(var(--color-surface-muted));\n  }\n  .portfolio-tab-panel .molecule-table-td--thumbnail::before {\n    display: none;\n  }\n  .portfolio-tab-panel .molecule-table-td[data-label=Title],\n  .portfolio-tab-panel .molecule-table-td[data-label=\"Question Title\"] {\n    max-width: none;\n  }\n  .portfolio-tab-panel .molecule-table-td:has(.molecule-table-actions) {\n    grid-template-columns: 1fr;\n    padding-top: 10px;\n  }\n  .portfolio-tab-panel .molecule-table-td:has(.molecule-table-actions)::before {\n    display: none;\n  }\n}\n@media (max-width: 576px) {\n  .portfolio-summary-card,\n  .portfolio-tabs-card {\n    border-radius: 12px;\n  }\n  .portfolio-summary-card {\n    padding: 12px;\n  }\n  .portfolio-tabs-card {\n    padding: 12px;\n  }\n  .portfolio-activity-title {\n    font-size: 18px;\n  }\n  .portfolio-tab-btn {\n    padding: 10px 12px;\n  }\n  .portfolio-tab-btn-icon {\n    width: 30px;\n    height: 30px;\n    font-size: 13px;\n  }\n  .portfolio-summary-actions {\n    width: 100%;\n  }\n  .portfolio-action-btn {\n    flex: 1;\n    text-align: center;\n  }\n  .wallet-activity-overlay {\n    align-items: flex-end;\n    padding: 0;\n  }\n  .wallet-activity-modal {\n    width: 100%;\n    border-bottom-left-radius: 0;\n    border-bottom-right-radius: 0;\n    padding: 16px;\n  }\n}\n\n/* Casino embed densify — remaining panel radii */\n.prediction-market-page--casino .sub-filter-bar,\n.prediction-market-page--casino .sub-filter-item,\n.prediction-market-page--casino .market-detail-trade-fab,\n.prediction-market-page--casino .how-it-works-panel,\n.prediction-market-page--casino .common-popup,\n.prediction-market-page--casino .wallet-activity-modal,\n.prediction-market-page--casino .portfolio-tabs-card,\n.prediction-market-page--casino .notification-bell__dropdown,\n.prediction-market-page--casino .market-orders-indicator__dropdown {\n  border-radius: var(--pm-radius, 8px);\n}\n\n.prediction-market-page--casino .order-panel-outcome-btn,\n.prediction-market-page--casino .order-panel-stepper,\n.prediction-market-page--casino .order-panel-market-tab-summary,\n.prediction-market-page--casino .order-panel-limit-tab-summary,\n.prediction-market-page--casino .order-panel-disabled-note {\n  border-radius: 0.5rem;\n}\n\n.dark .prediction-market-page--casino .header-section {\n  background: rgb(var(--color-surface) / 0.96);\n}\n\n/* ========== Breaking Markets ========== */\n.breaking-markets {\n  position: relative;\n  isolation: isolate;\n  min-height: calc(100vh - var(--pm-header-offset, 140px) - 12px);\n  padding: 10px 12px 18px;\n  overflow: hidden;\n  animation: pm-fade-in-up var(--pm-duration-slow, 0.36s) var(--pm-ease, ease) both;\n}\n\n.breaking-markets-bg {\n  position: absolute;\n  inset: -4%;\n  z-index: 0;\n  background-color: rgb(var(--color-surface));\n  background-image: var(--breaking-bg, none);\n  background-size: cover;\n  background-position: center;\n  filter: blur(16px) saturate(1.25) brightness(0.68);\n  transform: scale(1.06);\n  opacity: 0.9;\n}\n\n.breaking-markets-veil {\n  position: absolute;\n  inset: 0;\n  z-index: 1;\n  background:\n    radial-gradient(ellipse 65% 50% at 50% 30%, rgb(0 0 0 / 0.22), transparent 70%),\n    linear-gradient(180deg, rgb(var(--color-surface) / 0.3) 0%, rgb(var(--color-surface) / 0.55) 50%, rgb(var(--color-surface) / 0.82) 100%);\n  pointer-events: none;\n}\n\n.breaking-markets--empty {\n  display: grid;\n  place-items: center;\n  min-height: 40vh;\n}\n\n.breaking-markets-empty-copy {\n  margin: 0;\n  font-size: 1rem;\n  font-weight: 600;\n  color: rgb(var(--color-ink-muted));\n}\n\n.breaking-markets-stage {\n  position: relative;\n  z-index: 2;\n  width: min(100%, 1480px);\n  margin: 0 auto;\n}\n\n.breaking-markets-arrow {\n  position: absolute;\n  top: 50%;\n  z-index: 5;\n  display: grid;\n  place-items: center;\n  width: 48px;\n  height: 48px;\n  padding: 0;\n  border: 1px solid rgb(var(--color-warning, 245 158 11) / 0.55);\n  border-radius: 999px;\n  background: rgb(var(--color-surface-raised) / 0.95);\n  color: rgb(var(--color-warning, 245 158 11));\n  font-size: 16px;\n  cursor: pointer;\n  box-shadow: 0 8px 22px rgb(0 0 0 / 0.2), 0 0 0 4px rgb(var(--color-warning, 245 158 11) / 0.18);\n  transform: translateY(-50%);\n  transition: transform 0.18s ease, background 0.18s ease;\n}\n\n.breaking-markets-arrow--prev { left: 8px; }\n.breaking-markets-arrow--next { right: 8px; }\n\n.breaking-markets-arrow:hover,\n.breaking-markets-arrow:focus-visible {\n  background: rgb(var(--color-warning, 245 158 11));\n  color: #111;\n  outline: none;\n  transform: translateY(-50%) scale(1.06);\n}\n\n.breaking-markets-arrow:active {\n  transform: translateY(-50%) scale(0.96);\n}\n\n.breaking-markets-card {\n  position: relative;\n  z-index: 3;\n  display: flex;\n  flex-direction: column;\n  min-width: 0;\n  margin: 0 56px;\n  padding: 14px clamp(12px, 2vw, 20px) 16px;\n  border-radius: 18px;\n  background: rgb(var(--color-surface-raised) / 0.92);\n  border: 1px solid rgb(var(--color-line) / 0.7);\n  box-shadow: 0 18px 48px rgb(0 0 0 / 0.22);\n  backdrop-filter: blur(12px);\n  animation: breaking-card-in 0.34s var(--pm-ease, ease) both;\n}\n\n.breaking-markets-card-bg {\n  position: absolute;\n  inset: 0;\n  z-index: 0;\n  border-radius: inherit;\n  overflow: hidden;\n  pointer-events: none;\n}\n\n.breaking-markets-card-bg img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  opacity: 0.26;\n  filter: blur(2px) saturate(1.05);\n  transform: scale(1.04);\n}\n\n.breaking-markets-card-bg::after {\n  content: '';\n  position: absolute;\n  inset: 0;\n  background: linear-gradient(\n    180deg,\n    rgb(var(--color-surface-raised) / 0.72) 0%,\n    rgb(var(--color-surface-raised) / 0.88) 45%,\n    rgb(var(--color-surface-raised) / 0.95) 100%\n  );\n}\n\n.breaking-markets-card > :not(.breaking-markets-card-bg) {\n  position: relative;\n  z-index: 1;\n}\n\n.breaking-markets-card-top {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 10px;\n  margin-bottom: 12px;\n}\n\n.breaking-markets-card-actions {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.breaking-markets-badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  padding: 5px 10px;\n  border-radius: 999px;\n  font-size: 11px;\n  font-weight: 800;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  color: rgb(var(--color-warning, 245 158 11));\n  background: rgb(var(--color-warning, 245 158 11) / 0.14);\n  border: 1px solid rgb(var(--color-warning, 245 158 11) / 0.4);\n}\n\n.breaking-markets-progress {\n  display: inline-flex;\n  align-items: baseline;\n  gap: 2px;\n  padding: 4px 10px;\n  border-radius: 999px;\n  font-size: 12px;\n  font-weight: 800;\n  color: rgb(var(--color-ink));\n  background: rgb(var(--color-surface) / 0.7);\n  border: 1px solid rgb(var(--color-line));\n}\n\n.breaking-markets-progress-sep { opacity: 0.45; margin: 0 1px; }\n\n.breaking-markets-expand {\n  display: grid;\n  place-items: center;\n  width: 36px;\n  height: 36px;\n  padding: 0;\n  border: 1px solid rgb(var(--color-line-strong));\n  border-radius: 0.5rem;\n  background: rgb(var(--color-surface) / 0.85);\n  color: rgb(var(--color-ink));\n  cursor: pointer;\n  transition: background 0.15s ease, border-color 0.15s ease;\n}\n\n.breaking-markets-expand:hover,\n.breaking-markets-expand:focus-visible {\n  border-color: rgb(var(--color-warning, 245 158 11) / 0.7);\n  color: rgb(var(--color-warning, 245 158 11));\n  outline: none;\n}\n\n.breaking-markets-loader {\n  min-height: 280px;\n  display: grid;\n  place-items: center;\n}\n\n.breaking-markets-layout {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) minmax(260px, min(380px, 100%));\n  gap: clamp(12px, 2vw, 18px);\n  align-items: start;\n}\n\n.breaking-markets-main {\n  min-width: 0;\n  max-height: calc(100vh - var(--pm-header-offset, 140px) - 220px);\n  overflow-y: auto;\n  scrollbar-width: thin;\n  padding-right: 4px;\n}\n\n.breaking-markets-order-wrap {\n  --order-panel-max-h: calc(100vh - var(--pm-header-offset, 140px) - 220px);\n  min-width: 0;\n  width: 100%;\n  max-width: 380px;\n  position: sticky;\n  top: 0;\n  align-self: start;\n  max-height: var(--order-panel-max-h);\n  display: flex;\n  flex-direction: column;\n}\n\n.breaking-markets-order-wrap .order-panel {\n  position: static;\n  max-height: var(--order-panel-max-h);\n  height: auto;\n  min-height: 0;\n  overflow: auto;\n}\n\n.market-detail-image--breaking {\n  width: 64px;\n  height: 64px;\n  border-radius: 12px;\n}\n\n.breaking-markets-mobile-options {\n  list-style: none;\n  margin: 4px 0 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  max-height: min(52vh, 420px);\n  overflow-y: auto;\n  -webkit-overflow-scrolling: touch;\n}\n\n.breaking-markets-mobile-option {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  width: 100%;\n  padding: 10px 12px;\n  border-radius: 0.5rem;\n  background: rgb(var(--color-surface) / 0.7);\n  border: 1px solid rgb(var(--color-line));\n  color: rgb(var(--color-ink));\n  cursor: pointer;\n  text-align: left;\n  transition: border-color 0.15s ease, background 0.15s ease;\n}\n\n.breaking-markets-mobile-option.is-selected {\n  border-color: rgb(var(--color-warning, 245 158 11) / 0.85);\n  background: rgb(var(--color-warning, 245 158 11) / 0.14);\n  box-shadow: 0 0 0 2px rgb(var(--color-warning, 245 158 11) / 0.2);\n}\n\n.breaking-markets-mobile-option-thumb {\n  width: 40px;\n  height: 40px;\n  border-radius: 10px;\n  object-fit: cover;\n  flex-shrink: 0;\n}\n\n.breaking-markets-mobile-option-title {\n  font-size: 13px;\n  font-weight: 700;\n  color: rgb(var(--color-ink));\n  line-height: 1.3;\n}\n\n.breaking-markets-mobile-cta {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 8px;\n  margin-top: 8px;\n  position: sticky;\n  bottom: 0;\n  padding-top: 8px;\n}\n\n.breaking-markets-mobile-trade {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  min-height: 46px;\n  padding: 0 16px;\n  border-radius: 0.5rem;\n  font-size: 14px;\n  font-weight: 800;\n  cursor: pointer;\n  border: 0;\n  background: rgb(var(--color-warning, 245 158 11));\n  color: #111;\n}\n\n.breaking-markets-mobile-trade:disabled {\n  opacity: 0.45;\n  cursor: not-allowed;\n}\n\n.breaking-markets--mobile {\n  min-height: auto;\n  overflow: visible;\n  padding: 12px 12px 28px;\n  background: transparent;\n}\n\n.breaking-mobile {\n  position: relative;\n  z-index: 2;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.breaking-mobile-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 10px;\n}\n\n.breaking-mobile-back {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  padding: 8px 12px;\n  border: 1px solid rgb(var(--color-line));\n  border-radius: 0.5rem;\n  background: rgb(var(--color-surface-raised) / 0.95);\n  color: rgb(var(--color-ink));\n  font-size: 13px;\n  font-weight: 700;\n  cursor: pointer;\n}\n\n.breaking-mobile-markets {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.breaking-mobile-market-card {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  width: 100%;\n  padding: 12px;\n  border: 1px solid rgb(var(--color-line));\n  border-radius: 16px;\n  background: rgb(var(--color-surface-raised) / 0.96);\n  color: rgb(var(--color-ink));\n  text-align: left;\n  cursor: pointer;\n  box-shadow: 0 6px 18px rgb(0 0 0 / 0.08);\n}\n\n.breaking-mobile-market-card img {\n  width: 56px;\n  height: 56px;\n  border-radius: 12px;\n  object-fit: cover;\n  flex-shrink: 0;\n}\n\n.breaking-mobile-market-body {\n  display: flex;\n  flex-direction: column;\n  gap: 3px;\n  min-width: 0;\n  flex: 1;\n}\n\n.breaking-mobile-market-category {\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  color: rgb(var(--color-ink-muted));\n}\n\n.breaking-mobile-market-title {\n  font-size: 14px;\n  font-weight: 800;\n  line-height: 1.3;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n}\n\n.breaking-mobile-market-vol {\n  font-size: 12px;\n  font-weight: 600;\n  color: rgb(var(--color-ink-muted));\n}\n\n.breaking-mobile-market-chevron {\n  color: rgb(var(--color-ink-faint));\n  flex-shrink: 0;\n}\n\n.breaking-mobile-selected {\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n}\n\n.breaking-mobile-selected-thumb {\n  width: 56px;\n  height: 56px;\n  border-radius: 12px;\n  object-fit: cover;\n  flex-shrink: 0;\n  border: 1px solid rgb(var(--color-line));\n}\n\n.breaking-mobile-options-label {\n  margin: 4px 0 0;\n  font-size: 12px;\n  font-weight: 800;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  color: rgb(var(--color-ink-muted));\n}\n\n.breaking-markets-bottom {\n  position: relative;\n  z-index: 2;\n  width: min(100%, 1480px);\n  margin: 14px auto 0;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.breaking-markets-dots {\n  display: flex;\n  justify-content: center;\n  gap: 7px;\n}\n\n.breaking-markets-dots button {\n  width: 8px;\n  height: 8px;\n  padding: 0;\n  border: 0;\n  border-radius: 999px;\n  background: rgb(var(--color-line-strong));\n  cursor: pointer;\n  transition: width 0.2s ease, background 0.2s ease;\n}\n\n.breaking-markets-dots button.is-active {\n  width: 24px;\n  background: rgb(var(--color-warning, 245 158 11));\n}\n\n.breaking-markets-rail {\n  list-style: none;\n  margin: 0;\n  padding: 2px 2px 6px;\n  display: flex;\n  gap: 10px;\n  overflow-x: auto;\n  scrollbar-width: thin;\n  scroll-snap-type: x mandatory;\n  -webkit-overflow-scrolling: touch;\n}\n\n.breaking-markets-rail-card {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  width: min(240px, 72vw);\n  padding: 8px;\n  border: 1px solid rgb(var(--color-line));\n  border-radius: 14px;\n  background: rgb(var(--color-surface-raised) / 0.92);\n  color: rgb(var(--color-ink));\n  cursor: pointer;\n  text-align: left;\n  scroll-snap-align: start;\n  transition: border-color 0.18s ease, transform 0.18s ease;\n}\n\n.breaking-markets-rail-card img {\n  width: 44px;\n  height: 44px;\n  border-radius: 10px;\n  object-fit: cover;\n  flex-shrink: 0;\n}\n\n.breaking-markets-rail-title {\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  font-size: 12px;\n  font-weight: 700;\n  line-height: 1.3;\n}\n\n.breaking-markets-rail-card.is-active {\n  border-color: rgb(var(--color-warning, 245 158 11) / 0.8);\n  box-shadow: 0 0 0 2px rgb(var(--color-warning, 245 158 11) / 0.2);\n}\n\n.breaking-markets-rail-card:hover,\n.breaking-markets-rail-card:focus-visible {\n  transform: translateY(-1px);\n  border-color: rgb(var(--color-warning, 245 158 11) / 0.65);\n  outline: none;\n}\n\n@keyframes breaking-card-in {\n  from {\n    opacity: 0;\n    transform: translateY(10px) scale(0.985);\n  }\n  to {\n    opacity: 1;\n    transform: none;\n  }\n}\n\n/* My Position tab */\n.order-panel-my-position {\n  flex-shrink: 0;\n  margin-top: auto;\n  border-top: 1px solid rgb(var(--color-line));\n  padding: 12px 14px 14px;\n  background: linear-gradient(180deg, rgb(var(--color-surface-overlay)) 0%, rgb(var(--color-surface-muted)) 100%);\n  border-radius: 0 0 15px 15px;\n}\n\n.order-panel-my-position-pnl {\n  display: flex;\n  align-items: baseline;\n  justify-content: space-between;\n  gap: 12px;\n  margin-top: 10px;\n  padding: 8px 10px;\n  border-radius: 10px;\n  border: 1px solid rgb(var(--color-line));\n  background: rgb(var(--color-surface-raised));\n}\n\n.order-panel-my-position-pnl-label {\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  color: rgb(var(--color-ink-faint));\n}\n\n.order-panel-my-position-pnl-value {\n  font-size: 15px;\n  font-weight: 700;\n  font-variant-numeric: tabular-nums;\n  color: rgb(var(--color-ink));\n  line-height: 1.2;\n}\n\n.order-panel-my-position-table-wrap {\n  width: 100%;\n  min-width: 0;\n  overflow-x: auto;\n  -webkit-overflow-scrolling: touch;\n  scrollbar-width: none;\n}\n\n.order-panel-my-position-table-wrap::-webkit-scrollbar {\n  height: 0;\n}\n\n.order-panel-my-position-table {\n  width: 100%;\n  min-width: 240px;\n  border-collapse: collapse;\n  table-layout: fixed;\n  font-size: 12px;\n}\n\n.order-panel-my-position-th {\n  padding: 0 6px 8px 6px;\n  text-align: right;\n  font-size: 10px;\n  font-weight: 700;\n  letter-spacing: 0.03em;\n  text-transform: uppercase;\n  color: rgb(var(--color-ink-faint));\n  border-bottom: 1px solid rgb(var(--color-line));\n  vertical-align: bottom;\n}\n\n.order-panel-my-position-th--metric {\n  width: 42%;\n  text-align: left;\n  padding-left: 0;\n  text-transform: none;\n  font-size: 11px;\n  letter-spacing: 0.01em;\n}\n\n.order-panel-my-position-th--yes,\n.order-panel-my-position-th--no {\n  width: 29%;\n}\n\n.order-panel-my-position-th--yes {\n  color: rgb(var(--color-success));\n}\n\n.order-panel-my-position-th--no {\n  color: rgb(var(--color-danger));\n}\n\n.order-panel-my-position-metric {\n  padding: 8px 8px 8px 0;\n  text-align: left;\n  font-size: 11px;\n  font-weight: 700;\n  color: rgb(var(--color-ink-soft));\n  border-bottom: 1px solid rgb(var(--color-surface-muted));\n  vertical-align: middle;\n}\n\n.order-panel-my-position-table td {\n  padding: 8px 6px;\n  text-align: right;\n  font-weight: 600;\n  font-variant-numeric: tabular-nums;\n  color: rgb(var(--color-ink));\n  border-bottom: 1px solid rgb(var(--color-surface-muted));\n}\n\n.order-panel-my-position-table tbody tr:last-child th,\n.order-panel-my-position-table tbody tr:last-child td {\n  border-bottom: none;\n  padding-bottom: 2px;\n}\n\n.order-panel-my-position-sr-only {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border: 0;\n}\n\n.option-my-position {\n  display: flex;\n  flex-direction: column;\n  gap: 0;\n}\n\n.option-my-position-section-title {\n  margin: 0 0 10px;\n  font-size: 14px;\n  font-weight: 700;\n  color: rgb(var(--color-ink));\n}\n\n.option-my-position-summary {\n  border: 1px solid rgb(var(--color-line));\n  border-radius: 12px;\n  padding: 14px;\n  background: rgb(var(--color-surface-raised));\n}\n\n.option-my-position-loading {\n  margin: 0;\n  color: rgb(var(--color-ink-faint));\n  font-size: 13px;\n}\n\n.option-my-position-orders-panel {\n  margin-top: 16px;\n  padding: 14px;\n  border: 1px solid rgb(var(--color-line));\n  border-radius: 12px;\n  background: rgb(var(--color-surface));\n  box-shadow: 0 1px 0 rgb(var(--color-line) / 0.6);\n  --panel-accent: rgb(var(--color-accent));\n  --panel-accent-soft: rgb(var(--color-accent-soft));\n  --panel-row-accent: rgb(var(--color-accent));\n}\n\n.option-my-position-orders-title {\n  margin: 0 0 12px;\n  padding-bottom: 10px;\n  font-size: 14px;\n  font-weight: 700;\n  color: rgb(var(--color-ink));\n  border-bottom: 1px solid rgb(var(--color-line));\n}\n\n.option-my-position-orders-filters {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  margin-bottom: 12px;\n}\n\n.option-my-position-orders-filters .portfolio-activity-filter {\n  margin: 0;\n  flex: 1 1 180px;\n  min-width: 0;\n}\n\n.option-my-position-orders-panel .portfolio-activity-filter {\n  padding: 8px 10px;\n  border-radius: 12px;\n  background: linear-gradient(90deg, color-mix(in srgb, var(--panel-accent) 8%, transparent), transparent);\n  border: 1px solid color-mix(in srgb, var(--panel-accent) 14%, rgb(var(--color-line)));\n}\n\n.option-my-position-orders-panel .molecule-common-filter-btn--active {\n  border-color: color-mix(in srgb, var(--panel-accent) 30%, rgb(var(--color-line-strong)));\n  background: var(--panel-accent-soft);\n  color: rgb(var(--color-ink));\n}\n\n.option-my-position-orders-panel .molecule-table-wrap {\n  border: 1px solid rgb(var(--color-line));\n  border-radius: 12px;\n  background: rgb(var(--color-surface-raised));\n  overflow: auto;\n}\n\n.option-my-position-orders-panel .molecule-table-th {\n  font-size: 11px;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  color: rgb(var(--color-ink-faint));\n  white-space: nowrap;\n}\n\n.option-my-position-orders-panel .molecule-table-td {\n  font-size: 13px;\n  white-space: nowrap;\n}\n\n.option-my-position-orders-panel .molecule-table-tr--clickable:hover {\n  background: rgb(var(--color-surface-overlay));\n}\n\n.option-my-position-orders-panel .molecule-table-action-btn {\n  font-size: 12px;\n  padding: 5px 10px;\n}\n\n.option-my-position-orders-panel .molecule-empty-panel {\n  min-height: 160px;\n  padding: 20px 16px;\n  border-radius: 12px;\n  background: linear-gradient(180deg, var(--panel-accent-soft), rgb(var(--color-surface-raised)) 70%);\n}\n\n@media (max-width: 768px) {\n  .option-my-position-orders-filters .portfolio-activity-filter {\n    flex: 1 1 100%;\n  }\n\n  .option-my-position-orders-panel .molecule-table,\n  .option-my-position-orders-panel .molecule-table-head,\n  .option-my-position-orders-panel .molecule-table-body,\n  .option-my-position-orders-panel .molecule-table-tr,\n  .option-my-position-orders-panel .molecule-table-th,\n  .option-my-position-orders-panel .molecule-table-td {\n    display: block;\n    width: 100%;\n  }\n\n  .option-my-position-orders-panel .molecule-table-head {\n    position: absolute;\n    width: 1px;\n    height: 1px;\n    padding: 0;\n    margin: -1px;\n    overflow: hidden;\n    clip: rect(0, 0, 0, 0);\n    white-space: nowrap;\n    border: 0;\n  }\n\n  .option-my-position-orders-panel .molecule-table-body .molecule-table-tr {\n    margin-bottom: 10px;\n    padding: 12px;\n    border: 1px solid rgb(var(--color-line));\n    border-left: 3px solid var(--panel-row-accent);\n    border-radius: 14px;\n    background: rgb(var(--color-surface-raised));\n    box-shadow: 0 4px 14px rgb(var(--color-shadow) / 0.04);\n  }\n\n  .option-my-position-orders-panel .molecule-table-td {\n    display: grid;\n    grid-template-columns: minmax(90px, 38%) 1fr;\n    gap: 8px;\n    align-items: baseline;\n    padding: 7px 0;\n    border-bottom: 1px solid rgb(var(--color-surface-overlay));\n    white-space: normal;\n  }\n\n  .option-my-position-orders-panel .molecule-table-td:last-child {\n    border-bottom: 0;\n  }\n\n  .option-my-position-orders-panel .molecule-table-td::before {\n    content: attr(data-label);\n    font-size: 10px;\n    font-weight: 800;\n    letter-spacing: 0.05em;\n    text-transform: uppercase;\n    color: rgb(var(--color-ink-faint));\n  }\n\n  .option-my-position-orders-panel .molecule-table-td:has(.molecule-table-actions) {\n    grid-template-columns: 1fr;\n    padding-top: 10px;\n  }\n\n  .option-my-position-orders-panel .molecule-table-td:has(.molecule-table-actions)::before {\n    display: none;\n  }\n\n  .option-my-position-orders-panel .molecule-table-pagination {\n    padding: 10px 4px 4px;\n  }\n}\n\n@media (max-width: 640px) {\n  .option-my-position-summary {\n    padding: 12px;\n    border-radius: 10px;\n  }\n\n  .option-my-position-orders-panel {\n    margin-top: 12px;\n    padding: 12px;\n    border-radius: 10px;\n  }\n\n  .option-my-position-section-title,\n  .option-my-position-orders-title {\n    font-size: 13px;\n  }\n\n  .option-my-position-orders-filters {\n    gap: 6px;\n  }\n\n  .option-my-position-orders-filters .molecule-common-filter-btn {\n    flex: 1 1 auto;\n    font-size: 12px;\n    padding: 6px 10px;\n  }\n}\n\n@media (max-width: 480px) {\n  .order-panel-my-position {\n    padding: 10px 12px 12px;\n  }\n\n  .order-panel-my-position-pnl {\n    padding: 7px 9px;\n    margin-top: 8px;\n  }\n\n  .order-panel-my-position-pnl-value {\n    font-size: 14px;\n  }\n\n  .order-panel-my-position-table {\n    font-size: 11px;\n  }\n\n  .order-panel-my-position-th {\n    font-size: 9px;\n    padding: 0 4px 5px 4px;\n  }\n\n  .order-panel-my-position-metric,\n  .order-panel-my-position-table td {\n    padding: 7px 4px;\n  }\n}\n\n\n/* === Demo mode (ported from B2B) === */\n\n.header-section .is-demo-disabled,\n.is-demo-disabled {\n  opacity: 0.55;\n  pointer-events: none;\n  cursor: default;\n}\n.header-section .is-demo-disabled button:disabled,\n.is-demo-disabled button:disabled {\n  cursor: default;\n}\n\n\n.manage-market {\n  position: relative;\n  flex-shrink: 0;\n}\n\n.manage-market__trigger {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.45rem;\n  min-height: 2rem;\n  padding: 0 0.75rem;\n  border: 1px solid rgb(var(--color-line-strong));\n  border-radius: var(--pm-radius-sm, 6px);\n  background: linear-gradient(\n    180deg,\n    rgb(var(--color-surface-raised)) 0%,\n    rgb(var(--color-surface-muted) / 0.65) 100%\n  );\n  color: rgb(var(--color-ink-soft));\n  font-family: inherit;\n  font-size: 0.72rem;\n  font-weight: 700;\n  letter-spacing: 0.03em;\n  text-transform: uppercase;\n  white-space: nowrap;\n  cursor: pointer;\n  appearance: none;\n  box-shadow: inset 0 1px 0 rgb(var(--pm-gold) / 0.08);\n  transition:\n    background 0.15s ease,\n    border-color 0.15s ease,\n    color 0.15s ease,\n    box-shadow 0.15s ease;\n}\n\n.manage-market__trigger i {\n  font-size: 0.72rem;\n  line-height: 1;\n}\n\n.manage-market__trigger:hover {\n  background: rgb(var(--color-surface-muted));\n  border-color: rgb(var(--color-line-strong));\n  color: rgb(var(--color-ink));\n}\n\n.manage-market__trigger--active {\n  background: rgb(var(--color-info-soft));\n  border-color: rgb(var(--color-info));\n  color: rgb(var(--color-info-contrast));\n  box-shadow: inset 0 0 0 1px rgb(var(--color-info) / 0.18);\n}\n\n.manage-market__chevron {\n  opacity: 0.75;\n  font-size: 0.62rem !important;\n}\n\n.manage-market__overlay {\n  position: fixed;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  z-index: 900;\n  display: flex;\n  flex-direction: column;\n  min-height: 0;\n  background:\n    linear-gradient(\n      180deg,\n      rgb(var(--color-surface) / 0.88) 0%,\n      rgb(var(--color-surface) / 0.72) 42%,\n      rgb(var(--color-surface) / 0.66) 100%\n    );\n  backdrop-filter: blur(12px) saturate(1.2);\n  -webkit-backdrop-filter: blur(12px) saturate(1.2);\n  color: rgb(var(--color-ink));\n  border: 0;\n  box-shadow: none;\n  border-radius: 0;\n  animation: news-overlay-enter 0.34s var(--pm-ease) both;\n  overflow: hidden;\n  cursor: pointer;\n}\n\n.manage-market__overlay-body {\n  flex: 1 1 auto;\n  min-height: 0;\n  overflow-x: hidden;\n  overflow-y: auto;\n  overscroll-behavior: contain;\n  padding: 18px 20px 36px;\n  padding-right: 56px;\n  -webkit-overflow-scrolling: touch;\n  width: 100%;\n  max-width: 900px;\n  margin: 0 auto;\n  box-sizing: border-box;\n  position: relative;\n  z-index: 1;\n  cursor: default;\n}\n\n.manage-market__overlay .manage-market__header {\n  margin: 0 0 18px;\n  padding: 0 0 14px;\n  border-bottom: 1px solid rgb(var(--color-line) / 0.85);\n  background: transparent;\n}\n\n.manage-market__overlay .manage-market__title {\n  font-size: 1.05rem;\n  letter-spacing: -0.01em;\n}\n\n.manage-market__overlay .manage-market__subtitle {\n  font-size: 0.82rem;\n}\n\n.manage-market__close--overlay {\n  position: absolute;\n  top: 12px;\n  right: 16px;\n  z-index: 2;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n}\n\n.manage-market__header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 0.75rem;\n  padding: 0.9rem 1rem;\n  border-bottom: 1px solid rgb(var(--color-line));\n  background: rgb(var(--color-surface-overlay));\n}\n\n.manage-market__title {\n  margin: 0;\n  font-size: 0.9rem;\n  font-weight: 700;\n  line-height: 1.25;\n  color: rgb(var(--color-ink));\n}\n\n.manage-market__subtitle {\n  margin: 0.25rem 0 0;\n  font-size: 0.75rem;\n  line-height: 1.45;\n  color: rgb(var(--color-ink-faint));\n}\n\n.manage-market__close {\n  flex-shrink: 0;\n  width: 2rem;\n  height: 2rem;\n  border: 1px solid rgb(var(--color-line-strong));\n  border-radius: var(--pm-radius-sm, 6px);\n  background: rgb(var(--color-surface-raised));\n  color: rgb(var(--color-ink-soft));\n  cursor: pointer;\n  appearance: none;\n  transition: background 0.15s ease, color 0.15s ease;\n}\n\n.manage-market__close:hover {\n  background: rgb(var(--color-surface-muted));\n  color: rgb(var(--color-ink));\n}\n\n.manage-market__body {\n  overflow-y: auto;\n  padding: 0.85rem 1rem 1.25rem;\n  scrollbar-width: thin;\n  scrollbar-color: rgb(var(--color-line-strong)) transparent;\n}\n\n.manage-market__overlay .manage-market__body {\n  overflow: visible;\n  padding: 0;\n}\n\n.manage-market__overlay .manage-market__steps {\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 1rem;\n}\n\n.manage-market__steps {\n  display: grid;\n  gap: 0.75rem;\n}\n\n.manage-market__step {\n  padding: 0.85rem;\n  border: 1px solid rgb(var(--color-line));\n  border-radius: 10px;\n  background: rgb(var(--color-surface-overlay));\n}\n\n.manage-market__step--locked {\n  opacity: 0.72;\n}\n\n.manage-market__step-head {\n  display: flex;\n  align-items: flex-start;\n  gap: 0.65rem;\n  margin-bottom: 0.55rem;\n}\n\n.manage-market__step-badge {\n  flex-shrink: 0;\n  width: 1.5rem;\n  height: 1.5rem;\n  border-radius: 999px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  background: rgb(var(--color-info-soft));\n  color: rgb(var(--color-info-contrast));\n  font-size: 0.72rem;\n  font-weight: 800;\n}\n\n.manage-market__step-meta {\n  min-width: 0;\n  flex: 1;\n}\n\n.manage-market__step-title {\n  margin: 0;\n  font-size: 0.82rem;\n  font-weight: 700;\n  color: rgb(var(--color-ink));\n}\n\n.manage-market__step-status {\n  display: inline-block;\n  margin-top: 0.15rem;\n  font-size: 0.68rem;\n  font-weight: 700;\n  letter-spacing: 0.03em;\n  text-transform: uppercase;\n  color: rgb(var(--color-ink-faint));\n}\n\n.manage-market__step-status--done {\n  color: rgb(var(--color-success-contrast));\n}\n\n.manage-market__step-copy {\n  margin: 0 0 0.75rem;\n  font-size: 0.75rem;\n  line-height: 1.45;\n  color: rgb(var(--color-ink-soft));\n}\n\n.manage-market__field-label {\n  margin-bottom: 0.45rem;\n}\n\n.manage-market__outcome {\n  margin-bottom: 0.75rem;\n}\n\n.manage-market__action {\n  margin-top: 0;\n}\n\n.manage-market__sheet {\n  position: fixed;\n  inset: 0;\n  z-index: 1250;\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-end;\n}\n\n.manage-market__sheet-backdrop {\n  position: absolute;\n  inset: 0;\n  border: none;\n  padding: 0;\n  background: rgb(var(--color-ink) / 0.5);\n  backdrop-filter: blur(4px);\n  -webkit-backdrop-filter: blur(4px);\n  cursor: pointer;\n  animation: pm-fade-in var(--pm-duration-fast, 0.18s) var(--pm-ease, ease) both;\n}\n\n.manage-market__sheet-content {\n  position: relative;\n  z-index: 1;\n  width: 100%;\n  max-height: min(88dvh, 720px);\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  border-top-left-radius: 16px;\n  border-top-right-radius: 16px;\n  border: 1px solid rgb(var(--color-line-strong));\n  border-bottom: none;\n  background: linear-gradient(\n    180deg,\n    rgb(var(--color-surface-raised)) 0%,\n    rgb(var(--color-surface-muted) / 0.82) 100%\n  );\n  box-shadow: 0 -8px 32px rgb(var(--color-shadow) / 0.18);\n  animation: pm-sheet-slide-up var(--pm-duration, 0.28s) var(--pm-ease, ease) both;\n}\n\n@media (max-width: 992px) {\n  .manage-market__trigger {\n    min-height: 2.25rem;\n    padding: 0 0.65rem;\n    font-size: 0.68rem;\n  }\n}\n\n@media (max-width: 860px) {\n  .manage-market__overlay .manage-market__steps {\n    grid-template-columns: 1fr;\n  }\n}\n\n\n.demo-walkthrough {\n  position: fixed;\n  inset: 0;\n  z-index: 1260;\n  pointer-events: none;\n}\n\n.demo-walkthrough__shade {\n  position: absolute;\n  inset: 0;\n  pointer-events: none;\n}\n\n.demo-walkthrough__hole {\n  position: absolute;\n  border-radius: 14px;\n  box-shadow: 0 0 0 9999px rgb(var(--color-shadow) / 0.55);\n  outline: 2px solid rgb(var(--color-info, 0 149 255) / 0.85);\n  transition:\n    top 0.22s ease,\n    left 0.22s ease,\n    width 0.22s ease,\n    height 0.22s ease,\n    opacity 0.18s ease;\n  pointer-events: none;\n}\n\n.demo-walkthrough__tip {\n  position: fixed;\n  z-index: 1;\n  width: min(340px, calc(100vw - 24px));\n  padding: 14px 14px 12px;\n  border: 1px solid rgb(var(--color-line-strong));\n  border-radius: 16px;\n  background: rgb(var(--color-surface-raised));\n  box-shadow: 0 18px 40px rgb(var(--color-shadow) / 0.28);\n  color: rgb(var(--color-ink));\n  pointer-events: auto;\n  animation: demo-walkthrough-tip-in 0.22s ease;\n  box-sizing: border-box;\n}\n\n.demo-walkthrough__tip-head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  margin-bottom: 8px;\n}\n\n.demo-walkthrough__progress {\n  font-size: 0.7rem;\n  font-weight: 700;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  color: rgb(var(--color-ink-muted));\n}\n\n.demo-walkthrough__icon-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 28px;\n  height: 28px;\n  border: none;\n  border-radius: 999px;\n  background: rgb(var(--color-surface-muted) / 0.9);\n  color: rgb(var(--color-ink-muted));\n  cursor: pointer;\n  flex-shrink: 0;\n}\n\n.demo-walkthrough__icon-btn:hover {\n  color: rgb(var(--color-ink));\n  background: rgb(var(--color-surface-overlay));\n}\n\n.demo-walkthrough__title {\n  margin: 0;\n  font-size: 1.05rem;\n  font-weight: 750;\n  line-height: 1.25;\n  letter-spacing: -0.01em;\n}\n\n.demo-walkthrough__body {\n  margin: 8px 0 0;\n  font-size: 0.9rem;\n  line-height: 1.45;\n  color: rgb(var(--color-ink-soft));\n}\n\n.demo-walkthrough__hint {\n  margin: 8px 0 0;\n  padding: 8px 10px;\n  border-radius: 10px;\n  background: rgb(var(--color-info-soft, 219 234 254) / 0.55);\n  font-size: 0.78rem;\n  line-height: 1.4;\n  color: rgb(var(--color-ink-muted));\n}\n\n.demo-walkthrough__waiting {\n  margin: 10px 0 0;\n  font-size: 0.78rem;\n  font-weight: 700;\n  line-height: 1.35;\n  color: rgb(var(--color-warning, 245 158 11));\n}\n\n.demo-walkthrough__btn:disabled {\n  opacity: 0.45;\n  cursor: not-allowed;\n}\n\n.demo-walkthrough__actions {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  margin-top: 14px;\n}\n\n.demo-walkthrough__actions-end {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  flex-wrap: wrap;\n  justify-content: flex-end;\n}\n\n.demo-walkthrough__btn {\n  min-height: 34px;\n  padding: 0 12px;\n  border: 1px solid transparent;\n  border-radius: 10px;\n  font-family: inherit;\n  font-size: 0.82rem;\n  font-weight: 700;\n  cursor: pointer;\n}\n\n.demo-walkthrough__btn--ghost {\n  background: transparent;\n  border-color: transparent;\n  color: rgb(var(--color-ink-muted));\n}\n\n.demo-walkthrough__btn--ghost:hover {\n  color: rgb(var(--color-ink));\n}\n\n.demo-walkthrough__btn--secondary {\n  background: rgb(var(--color-surface-muted));\n  border-color: rgb(var(--color-line));\n  color: rgb(var(--color-ink-soft));\n}\n\n.demo-walkthrough__btn--primary {\n  background: #0095ff;\n  color: #fff;\n}\n\n.demo-walkthrough__btn--primary:hover {\n  opacity: 0.94;\n}\n\n.demo-walkthrough-launcher {\n  position: fixed;\n  left: 16px;\n  bottom: 24px;\n  z-index: 1260;\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  min-height: 40px;\n  padding: 0 14px;\n  border: 1px solid rgb(var(--color-line-strong));\n  border-radius: 999px;\n  background: rgb(var(--color-surface-raised));\n  color: rgb(var(--color-ink));\n  box-shadow: 0 10px 24px rgb(var(--color-shadow) / 0.2);\n  font-family: inherit;\n  font-size: 0.82rem;\n  font-weight: 700;\n  cursor: pointer;\n}\n\n.demo-walkthrough-launcher:hover {\n  border-color: rgb(var(--color-info, 0 149 255) / 0.55);\n}\n\n@media (max-width: 992px) {\n  .demo-walkthrough__tip {\n    width: auto;\n    max-width: none;\n    padding: 12px 12px 10px;\n    border-radius: 14px;\n    overflow: auto;\n    -webkit-overflow-scrolling: touch;\n    box-shadow: 0 12px 32px rgb(var(--color-shadow) / 0.32);\n  }\n\n  .demo-walkthrough__tip--dock-top {\n    transform: none;\n  }\n\n  .demo-walkthrough__tip--dock-bottom {\n    transform: none;\n  }\n\n  .demo-walkthrough__title {\n    font-size: 0.98rem;\n  }\n\n  .demo-walkthrough__body {\n    font-size: 0.84rem;\n    line-height: 1.4;\n  }\n\n  .demo-walkthrough__hint {\n    font-size: 0.74rem;\n    padding: 7px 9px;\n  }\n\n  .demo-walkthrough__actions {\n    margin-top: 12px;\n    gap: 6px;\n    flex-wrap: wrap;\n  }\n\n  .demo-walkthrough__btn {\n    min-height: 36px;\n    padding: 0 11px;\n    font-size: 0.8rem;\n  }\n\n  .demo-walkthrough__hole {\n    border-radius: 12px;\n    /* Keep hole transitions snappy so scroll/sheet open stays aligned */\n    transition:\n      top 0.12s ease,\n      left 0.12s ease,\n      width 0.12s ease,\n      height 0.12s ease,\n      opacity 0.12s ease;\n  }\n\n  .demo-walkthrough-launcher {\n    left: max(12px, env(safe-area-inset-left, 0px));\n    bottom: calc(88px + env(safe-area-inset-bottom, 0px));\n  }\n}\n\n@media (max-width: 480px) {\n  .demo-walkthrough__actions {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .demo-walkthrough__actions-end {\n    width: 100%;\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n  }\n\n  .demo-walkthrough__btn--ghost {\n    order: 1;\n    width: 100%;\n    min-height: 32px;\n  }\n\n  .demo-walkthrough__btn--primary {\n    grid-column: 2;\n  }\n\n  .demo-walkthrough__actions-end .demo-walkthrough__btn--secondary:only-child,\n  .demo-walkthrough__actions-end .demo-walkthrough__btn--primary:only-child {\n    grid-column: 1 / -1;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
